export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Datetime: any;
  JSON: any;
};

export type AchPaymentFile = {
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AchRemittanceMethodDetails = {
  utilityBankAccountNumber?: Maybe<Scalars['String']>;
  utilityBankRoutingNumber?: Maybe<Scalars['String']>;
  utilityCode?: Maybe<Scalars['String']>;
  utilityName?: Maybe<Scalars['String']>;
};

export type AchUtilityRemittanceFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  remittanceBatchId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AchUtilityRemittancesResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<Maybe<UtilityRemittance>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Account = {
  /**
   * A collection of aggregate statistics about environmental/financial impact.
   * These numbers may be 0, if the impact does not apply (for example, there is no "last statement")
   * Note that this is impact from VNM only
   */
  accountImpactStats: ImpactStats;
  accountNumber: Scalars['Int'];
  accountSummary: Array<Maybe<AccountSummaryDetail>>;
  activeAt?: Maybe<Scalars['Datetime']>;
  additionalEmails: Array<AdditionalEmail>;
  assignedPaymentMethodIds: Array<Scalars['Int']>;
  availableCredits?: Maybe<Scalars['Int']>;
  balances?: Maybe<AccountBalances>;
  billPayDeactivationWarnings?: Maybe<Array<ClosureWarning>>;
  billStartDate?: Maybe<Scalars['Date']>;
  businessName?: Maybe<Scalars['String']>;
  businessPhone?: Maybe<Scalars['String']>;
  closureWarnings?: Maybe<Array<ClosureWarning>>;
  contractLinks: Array<ContractLink>;
  createdAt: Scalars['Datetime'];
  creditRating?: Maybe<CreditRating>;
  credits?: Maybe<Array<Maybe<Credit>>>;
  customPlans: Array<Plan>;
  customerAccountType: CustomerAccountType;
  customerType?: Maybe<Scalars['String']>;
  dashboardNotifications: DashboardNotifications;
  deletedAt?: Maybe<Scalars['Datetime']>;
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  emails?: Maybe<Array<OutboundEmail>>;
  /** @deprecated use planAttributes.evergreenNextBillDate */
  evergreenNextBillDate?: Maybe<Scalars['Date']>;
  filteredNotifications?: Maybe<FilteredNotifications>;
  /**
   * Groups related plans together for use with the mergePlans mutations.
   * Use Account.plans for a flat list of all plans.
   */
  groupedPlans: Array<GroupedPlans>;
  hasOpenTasks?: Maybe<Scalars['Boolean']>;
  hasProductLead: Scalars['Boolean'];
  id: Scalars['Int'];
  isCustomerTypeFlaggedAsSuspect: Scalars['Boolean'];
  isMdu?: Maybe<Scalars['Boolean']>;
  /** @deprecated This is in the process of being deprecated with the custom_plans work. */
  kwh?: Maybe<Scalars['Int']>;
  legalDispute: Scalars['Boolean'];
  /** @deprecated temporary flag for the migration to custom plans (2020-21) */
  migrated: Scalars['Boolean'];
  migratedPlanId?: Maybe<Scalars['Int']>;
  migratedToAccount?: Maybe<Account>;
  migratedUtilityAccountId?: Maybe<Scalars['Int']>;
  mostRecentProductLead?: Maybe<ProductLead>;
  mostRecentStatement?: Maybe<Statement>;
  name?: Maybe<Scalars['String']>;
  notes: Array<Note>;
  notifications: Array<Notification>;
  onBillSubscriptions: Array<Maybe<OnBillSubscription>>;
  paymentMethods: Array<PaymentMethod>;
  perchManaged: Scalars['Boolean'];
  /** @deprecated use customPlans instead */
  plan?: Maybe<Plan>;
  planAttributes?: Maybe<PlanAttributes>;
  planStatusCounts: PlanStatusCounts;
  productLeads: Array<ProductLead>;
  /** @deprecated Use plan.productSubscriptions instead */
  productSubscriptions: Array<Maybe<ProductSubscription>>;
  sandboxed: Scalars['Boolean'];
  seagullAccountId?: Maybe<Scalars['String']>;
  shouldProvideReferralBonus?: Maybe<Scalars['Boolean']>;
  sponsorshipAvailability: SponsorshipAvailability;
  star?: Maybe<Scalars['String']>;
  state: State;
  statements: Array<Statement>;
  statistics?: Maybe<AccountStatistics>;
  status: Scalars['String'];
  transitionBillingExclusion: Scalars['Boolean'];
  user: User;
  /** @deprecated Use account.utilityAccounts instead. */
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccounts: Array<UtilityAccount>;
  /** @deprecated Use account.utilityCredentials instead. */
  utilityCredential: UtilityCredential;
  utilityCredentials: Array<UtilityCredential>;
  /** @deprecated Use search.billingChangeHistory instead. */
  versionHistory: VersionHistoryResponse;
  vnmSubscription?: Maybe<VnmSubscription>;
  zip?: Maybe<Scalars['String']>;
};

export type AccountDashboardNotificationsArgs = {
  input?: InputMaybe<DashboardNotificationsInput>;
};

export type AccountFilteredNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type AccountHasProductLeadArgs = {
  productId: Scalars['Int'];
};

export type AccountMostRecentProductLeadArgs = {
  productType?: InputMaybe<Scalars['String']>;
};

export type AccountPaymentMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PaymentMethodType>;
};

export type AccountProductSubscriptionsArgs = {
  type?: InputMaybe<Scalars['String']>;
};

export type AccountVersionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type AccountAttributesInput = {
  accountType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type AccountBalances = {
  accountId: Scalars['Int'];
  balanceCents?: Maybe<Scalars['Int']>;
  balanceDueCents?: Maybe<Scalars['Int']>;
  pastDueCents?: Maybe<Scalars['Int']>;
  pendingBalanceCents?: Maybe<Scalars['Int']>;
};

export type AccountClosureRequest = {
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  attritionCategory: AttritionCategory;
  attritionCategoryId: Scalars['Int'];
  auditReportFile?: Maybe<Scalars['String']>;
  auditReportFileExists: Scalars['Boolean'];
  closureType: ClosureType;
  createdAt: Scalars['Datetime'];
  finalVnmStatus: Scalars['String'];
  id: Scalars['Int'];
  note: Scalars['String'];
  processRequestFile?: Maybe<Scalars['String']>;
  processRequestFileExists: Scalars['Boolean'];
  processedAt?: Maybe<Scalars['Datetime']>;
  rejectionReason?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['Datetime']>;
  reviewedBy?: Maybe<AdminUser>;
  reviewedById?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  suppressEmailCommunication: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  validationReportFile?: Maybe<Scalars['String']>;
  validationReportFileExists: Scalars['Boolean'];
};

export type AccountClosureRequestFileDownloadUrls = {
  auditReportFileUrl?: Maybe<Scalars['String']>;
  processRequestFileUrl: Scalars['String'];
  validationReportFileUrl?: Maybe<Scalars['String']>;
};

export type AccountClosureRequestResponse = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  result?: Maybe<Array<AccountClosureRequest>>;
  resultCount: Scalars['Int'];
};

export type AccountStatistics = {
  vnm?: Maybe<AccountVnmStatistics>;
};

export type AccountSummaryDetail = {
  accountBusinessName?: Maybe<Scalars['String']>;
  annualizedUsageEstimate?: Maybe<Scalars['String']>;
  associatedSolarFarm?: Maybe<Scalars['String']>;
  commercialOperationDate?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['String']>;
  paymentSummary?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  rateClass?: Maybe<Scalars['String']>;
  serviceAddress?: Maybe<Scalars['String']>;
  utilityAccountNumber?: Maybe<Scalars['String']>;
  utilityCompany?: Maybe<Scalars['String']>;
  vnmSubscriptionStatus?: Maybe<Scalars['String']>;
};

export enum AccountTypeInput {
  LovebirdAccount = 'lovebird_account',
  LovebirdAccountWithoutUtilityAccount = 'lovebird_account_without_utility_account',
}

export type AccountVnmStatistics = {
  /** average savings from vnm per month in cents */
  averageMonthlySavings?: Maybe<Scalars['Float']>;
  /** total saved from vnm in cents */
  cumulativeSavings?: Maybe<Scalars['Float']>;
};

export type AchTransfer = {
  accountIds: Array<Scalars['Int']>;
  amountCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  increaseAchTransferId?: Maybe<Scalars['String']>;
  increaseDashboardUrl?: Maybe<Scalars['String']>;
  payee: Scalars['String'];
  remittanceItemIds: Array<Scalars['Int']>;
  sandboxed: Scalars['Boolean'];
  statementIds: Array<Scalars['Int']>;
  status: AchTransferStatus;
};

export type AchTransferFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  increaseAchTransferId?: InputMaybe<Scalars['String']>;
  remittanceBatchId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<AchTransferStatus>>;
  tenantIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum AchTransferStatus {
  Error = 'error',
  Flagged = 'flagged',
  New = 'new',
  Received = 'received',
  Rejected = 'rejected',
  Returned = 'returned',
  Submitted = 'submitted',
}

export type AchTransfersSearchResponse = {
  count: Scalars['Int'];
  records: Array<AchTransfer>;
  totalCount: Scalars['Int'];
};

export type AcquisitionStatistics = {
  estimatedHomesPowered: Scalars['Int'];
};

export type ActiveBillingSettings = {
  billExperience?: Maybe<BillExperience>;
  solarProjectType?: Maybe<SolarProjectType>;
};

export type AddAccountEmailInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type AdditionalEmail = {
  email: Scalars['String'];
  id: Scalars['Int'];
};

export type Address = {
  addressType: AddressType;
  addressableId: Scalars['Int'];
  addressableType: AddressableType;
  city: Scalars['String'];
  id: Scalars['Int'];
  state: Scalars['String'];
  streetOne: Scalars['String'];
  streetTwo?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type AddressInput = {
  addressVariables?: InputMaybe<AddressVariables>;
};

export enum AddressType {
  Billing = 'billing',
  Contact = 'contact',
}

export type AddressVariables = {
  city: Scalars['String'];
  state: Scalars['String'];
  streetOne: Scalars['String'];
  streetTwo?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export enum AddressableType {
  Plan = 'Plan',
  User = 'User',
}

export enum AdminReviewOutcome {
  Dismissed = 'dismissed',
  Updated = 'updated',
}

export type AdminSamlLoginLinks = {
  entra?: Maybe<Scalars['String']>;
  okta: Scalars['String'];
};

export type AdminTariffNormalization = {
  missingPropertyInputs?: Maybe<Array<NormalizationPropertyKey>>;
  resolvedPropertyInputs?: Maybe<Array<NormalizationPropertyKey>>;
  tariff: MappedTariff;
  warnings?: Maybe<Scalars['String']>;
};

export type AdminTariffNormalizations = {
  matches?: Maybe<Array<AdminTariffNormalization>>;
  sourceTariffName?: Maybe<Scalars['String']>;
  sourceUtilityId?: Maybe<Scalars['ID']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AdminUser = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  jwt: Scalars['String'];
  lastName: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  openTaskCount?: Maybe<Scalars['Int']>;
};

export type AdminUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  roles?: InputMaybe<Array<InputMaybe<Role>>>;
};

export type AdvocacyCampaign = {
  active: Scalars['Boolean'];
  callToActionText: Scalars['String'];
  editableBody: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  legislationDescription: Scalars['String'];
  numberOfSubmissions: Scalars['Int'];
  shareText: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  stateId: Scalars['Int'];
  subjectLine: Scalars['String'];
  successMessage: Scalars['String'];
  successTitle: Scalars['String'];
  uneditableBody: Scalars['String'];
};

export type AdvocacyCampaignSubmission = {
  advocacyCampaignId: Scalars['Int'];
  id: Scalars['Int'];
  userId: Scalars['Int'];
};

export type AdvocacyInput = {
  accountId: Scalars['Int'];
  billText: Scalars['String'];
  body: Scalars['String'];
  representatives?: InputMaybe<Array<RepresentativeInput>>;
  subject: Scalars['String'];
};

export type AllSuppliersItem = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AllUtilitiesItem = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Ambassador = {
  id: Scalars['Int'];
  promoCode?: Maybe<PromoCode>;
  userId?: Maybe<Scalars['Int']>;
};

export type AppliedCredit = {
  appliedDate: Scalars['Datetime'];
  externalAccountId: Scalars['Int'];
  statementId: Scalars['Int'];
};

export type ApplyPromoCodeInput = {
  email: Scalars['String'];
  promoCode: Scalars['String'];
};

export enum ArcadiaApp {
  Funnel = 'funnel',
  Lovebird = 'lovebird',
  Peregrine = 'peregrine',
  Sphinx = 'sphinx',
}

export type ArrayUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AssignTasksInput = {
  assigneeId: Scalars['Int'];
  taskIds: Array<Scalars['Int']>;
};

export type AssignWinbackAccountLeadsInput = {
  accountLeadIds: Array<Scalars['Int']>;
  assigneeId: Scalars['Int'];
};

export type AttachBillingQueueItemInput = {
  id: Scalars['Int'];
  utilityStatementId: Scalars['Int'];
};

export type AttachEmailParsingResultInput = {
  id: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
};

export type AttributeCriteria = {
  criteria: Scalars['JSON'];
  partialMatch?: Maybe<Scalars['Boolean']>;
};

export type Attrition = {
  attritionCategory?: Maybe<AttritionCategory>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
};

export type AttritionCategory = {
  consideredForWinback: Scalars['Boolean'];
  enableForAllInInstantClosure: Scalars['Boolean'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  productId?: Maybe<Scalars['Int']>;
  productTarget: Scalars['String'];
};

export enum AttritionProductTarget {
  ConsolidatedBilling = 'consolidated_billing',
  Evergreen = 'evergreen',
  FlatBill = 'flat_bill',
  OnBillFinance = 'on_bill_finance',
  VirtualNetMetering = 'virtual_net_metering',
}

export type AuditLogEvent = {
  adminUser?: Maybe<AdminUser>;
  /** @deprecated Use adminUser field instead */
  adminUserId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  eventType: Scalars['String'];
  id: Scalars['Int'];
  resourceId: Scalars['Int'];
  resourceType: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export type AuthedAdminUser = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  openTaskCount?: Maybe<Scalars['Int']>;
  roles: Array<Scalars['String']>;
  token: Scalars['String'];
};

export type AuthedServiceUser = {
  id: Scalars['Int'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export type AuthedUser = {
  email: Scalars['String'];
  id: Scalars['Int'];
  token: Scalars['String'];
};

export type AverageUsageByMonth = {
  date: Scalars['String'];
  kwh: Scalars['Float'];
};

export type BaseRequest = {
  endsWith?: InputMaybe<Scalars['Boolean']>;
  fields?: InputMaybe<Scalars['String']>;
  isRegex?: InputMaybe<Scalars['Boolean']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchOn?: InputMaybe<Array<Scalars['String']>>;
  sortOn?: InputMaybe<Array<Scalars['String']>>;
  sortOrder?: InputMaybe<Array<InputMaybe<SortOrder>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export enum BillExperience {
  ArcadiaBilled = 'arcadia_billed',
  DualBilled = 'dual_billed',
  Unknown = 'unknown',
  UtilityBilled = 'utility_billed',
}

export enum BillExtractionQualificationStatus {
  Failed = 'failed',
  NeedsReview = 'needs_review',
  Qualified = 'qualified',
}

export enum BillExtractionSecondaryAccountIdentifierType {
  CustomerNumber = 'customer_number',
  ElectricChoiceId = 'electric_choice_id',
  PodId = 'pod_id',
  PremisesNumber = 'premises_number',
  ResidentialServiceNumber = 'residential_service_number',
}

export type BillPayServiceProductEligibility = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  ineligibilityReasons?: Maybe<Array<IneligibilityReason>>;
  status: Scalars['String'];
};

export enum BillPayServiceProductEligibilityStatus {
  Eligible = 'eligible',
  Ineligible = 'ineligible',
}

export type BillPayServiceProductLeadFilters = {
  billPayHighlights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billPayIneligibilityReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedBillPayHighlights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasBillPayHighlights?: InputMaybe<Scalars['Boolean']>;
  hasBillPayIneligibilityReasons?: InputMaybe<Scalars['Boolean']>;
  hasVnmProductLead?: InputMaybe<Scalars['Boolean']>;
  includedBillPayHighlights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBundleProduct?: InputMaybe<Scalars['Boolean']>;
  isSandboxed?: InputMaybe<Scalars['Boolean']>;
  utilityAccountStatuses?: InputMaybe<Array<Scalars['String']>>;
  utilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type BillPayServiceProductLeadSearchResult = {
  count?: Maybe<Scalars['Int']>;
  productLeads: Array<ProductLead>;
};

export type BillPayServiceProductSubscription = {
  amountCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  plan: Plan;
  product?: Maybe<Product>;
  status?: Maybe<Scalars['String']>;
};

export type BillUpload = {
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  image: Scalars['String'];
  status: Scalars['String'];
};

export type BillUploadInput = {
  accountId: Scalars['Int'];
  image: Scalars['String'];
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type BillingChangeHistoryFilters = {
  accountId?: InputMaybe<Scalars['Int']>;
  dateAfter?: InputMaybe<Scalars['Date']>;
  dateBefore?: InputMaybe<Scalars['Date']>;
  itemId?: InputMaybe<Scalars['Int']>;
  itemType?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['Int']>;
};

export type BillingExperienceMigrationInput = {
  batchNickname?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
};

export type BillingExperienceOption = {
  name: BillingExperienceOptionName;
};

export enum BillingExperienceOptionName {
  Acb = 'acb',
  Dual = 'dual',
  None = 'none',
  Ucb = 'ucb',
}

export enum BillingExperienceType {
  Acb = 'acb',
  Dual = 'dual',
  Ucb = 'ucb',
}

export type BillingHistoryFinished = {
  scraperRequestUuid: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BillingPeriodRepresentation = {
  fromDateOffset?: Maybe<Scalars['Int']>;
  style?: Maybe<Scalars['String']>;
  toDateOffset?: Maybe<Scalars['Int']>;
};

export type BillingQueueItem = {
  emailParsingResult?: Maybe<EmailParsingResult>;
  id: Scalars['Int'];
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  utilityStatement?: Maybe<UtilityStatement>;
  utilityStatementId?: Maybe<Scalars['Int']>;
};

export type BillingSettings = {
  collectAutomatically: Scalars['Boolean'];
  directPaymentToDeveloper: Scalars['Boolean'];
  invoicingCadence?: Maybe<Scalars['String']>;
  invoicingDay?: Maybe<Scalars['Int']>;
  invoicingType?: Maybe<InvoicingType>;
  offlineInvoicing: Scalars['Boolean'];
  paysByCheck: Scalars['Boolean'];
};

export type BillingSettingsInput = {
  collectAutomatically?: InputMaybe<Scalars['Boolean']>;
  directPaymentToDeveloper?: InputMaybe<Scalars['Boolean']>;
  invoicingType?: InputMaybe<InvoicingType>;
  offlineInvoicing?: InputMaybe<Scalars['Boolean']>;
  paysByCheck?: InputMaybe<Scalars['Boolean']>;
};

export enum BillingTypes {
  Consolidated = 'consolidated',
  Independent = 'independent',
}

export type BooleanUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export enum BuilderTypeInput {
  WithPlanTemplate = 'with_plan_template',
  WithReferencePlan = 'with_reference_plan',
}

export type BulkAddBillPayInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type BulkProcessingRequest = {
  actorReportFile?: Maybe<Scalars['String']>;
  actorReportFileExists: Scalars['Boolean'];
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  approvalFlowEnabled: Scalars['Boolean'];
  auditReportFile?: Maybe<Scalars['String']>;
  auditReportFileExists: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  note: Scalars['String'];
  processRequestFile?: Maybe<Scalars['String']>;
  processRequestFileExists: Scalars['Boolean'];
  processedAt?: Maybe<Scalars['Datetime']>;
  rejectionReason?: Maybe<Scalars['String']>;
  requestType: Scalars['String'];
  reviewedAt?: Maybe<Scalars['Datetime']>;
  reviewedBy?: Maybe<AdminUser>;
  reviewedById?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  validationReportFile?: Maybe<Scalars['String']>;
  validationReportFileExists: Scalars['Boolean'];
};

export type BulkProcessingRequestFileDownloadUrls = {
  actorReportFileUrl?: Maybe<Scalars['String']>;
  auditReportFileUrl?: Maybe<Scalars['String']>;
  processRequestFileUrl: Scalars['String'];
  validationReportFileUrl?: Maybe<Scalars['String']>;
};

export type BulkProcessingRequestResponse = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  result?: Maybe<Array<BulkProcessingRequest>>;
  resultCount: Scalars['Int'];
};

export type BulkProcessingRequestTypes = {
  canCreate?: Maybe<Scalars['Boolean']>;
  canRead?: Maybe<Scalars['Boolean']>;
  requestType?: Maybe<Scalars['String']>;
};

export type BulkRemoveBillPayInput = {
  csv: Scalars['String'];
};

export type BulkScraperRequestOutput = {
  error?: Maybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
};

export type CalculateTariffCostsInput = {
  fromDateTime: Scalars['String'];
  masterTariffId: Scalars['ID'];
  propertyInputs?: InputMaybe<Array<CalculationPropertyInput>>;
  toDateTime: Scalars['String'];
};

export type CalculateTariffCostsOutput = {
  costs?: Maybe<Array<TariffCost>>;
};

export type CalculationPropertyInput = {
  dataValue: Scalars['String'];
  keyName: Scalars['String'];
  quantityUnit?: InputMaybe<Scalars['String']>;
};

export type CarbonEquivalency = {
  carbonFromBiomass: Scalars['Float'];
  carbonFromCoal: Scalars['Float'];
  carbonFromNaturalGas: Scalars['Float'];
  carbonFromOil: Scalars['Float'];
  kwh: Scalars['Int'];
  totalCarbon: Scalars['Float'];
  totalRecsPurchased: Scalars['Float'];
};

export type CategoryKeys = {
  programEligibility: Array<StaticRule>;
  qualification: Array<StaticRule>;
};

export type CenterPoint = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum ChargeClass {
  AfterTax = 'AFTER_TAX',
  Contracted = 'CONTRACTED',
  Distribution = 'DISTRIBUTION',
  NonBypassable = 'NON_BYPASSABLE',
  Other = 'OTHER',
  Suppl = 'SUPPL',
  Tax = 'TAX',
  Transmission = 'TRANSMISSION',
  UserAdjusted = 'USER_ADJUSTED',
}

export enum ChargePeriod {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
}

export enum ChargeType {
  ConsumptionBased = 'CONSUMPTION_BASED',
  DemandBased = 'DEMAND_BASED',
  FixedPrice = 'FIXED_PRICE',
  Maximum = 'MAXIMUM',
  Minimum = 'MINIMUM',
  NetExcessGeneration = 'NET_EXCESS_GENERATION',
  Quantity = 'QUANTITY',
  Tax = 'TAX',
}

export type CleanKilowattHour = {
  accountId: Scalars['Int'];
  carbonEquivalency: CarbonEquivalency;
  createdAt: Scalars['Datetime'];
  endDate: Scalars['Date'];
  featuredWindProject: WindProject;
  fuelTypeEquivalency: FuelTypeEquivalency;
  id: Scalars['Int'];
  kwh?: Maybe<Scalars['Int']>;
  productSubscription: ProductSubscription;
  /** @deprecated use productSubscription.id */
  productSubscriptionId: Scalars['Int'];
  startDate: Scalars['Date'];
  totalRecsPurchased?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

export type ClearDisputesInput = {
  planId: Scalars['Int'];
};

export type CloseAccountInput = {
  attritionCategoryId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  emailIdentifier?: InputMaybe<Scalars['String']>;
};

export type CloseAccountsAndPlansInput = {
  accounts?: InputMaybe<Array<CloseItemInput>>;
  plans?: InputMaybe<Array<ClosePlanInput>>;
};

export type CloseAccountsAndPlansOutput = {
  accounts: Array<Account>;
  plans: Array<Plan>;
};

export type CloseItemInput = {
  attritionCategoryId: Scalars['Int'];
  attritionComment?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type ClosePlanInput = {
  billPaySubscriptionDeactivations?: InputMaybe<Array<CloseItemInput>>;
  closureEmailIdentifier?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  vnmSubscriptionCancellations?: InputMaybe<Array<CloseItemInput>>;
};

export type CloseWinbackCampaignsInput = {
  campaignIds: Array<Scalars['Int']>;
  closureComment?: InputMaybe<Scalars['String']>;
  closureReason: WinbackCampaignClosureReason;
};

export enum ClosureType {
  ArcadiaAccount = 'arcadia_account',
  BillPaySubscriptions = 'bill_pay_subscriptions',
  UtilityAccount = 'utility_account',
}

export type CommunitySolarAdminReview = {
  adminUser: AdminUser;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  reviewOutcome: Scalars['String'];
};

export type CommunitySolarAdminReviewResponse = {
  id: Scalars['Int'];
};

export type CommunitySolarLead = {
  id: Scalars['Int'];
  leadErrors?: Maybe<Array<Scalars['String']>>;
  leadStatus?: Maybe<Scalars['String']>;
  perchCustomerType?: Maybe<Scalars['String']>;
  personalizedContractId?: Maybe<Scalars['Int']>;
  salesforceId?: Maybe<Scalars['String']>;
  salesforceSyncStatus?: Maybe<Scalars['String']>;
  signupContractTemplateId?: Maybe<Scalars['Int']>;
  underwritingCriteria?: Maybe<Scalars['String']>;
};

export type CommunitySolarProjectGroup = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  stateId: Scalars['Int'];
  usesIpaContracts: Scalars['Boolean'];
};

export type CommunitySolarRule = {
  rule: SubscriberRequirement;
  utilityAccount: UtilityAccount;
  utilityAccountId: Scalars['Int'];
};

export type CommunitySolarRuleFilters = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accountStatus?: InputMaybe<Scalars['String']>;
  adminReviewOutcomes?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<DateRangeFilter>;
  customerClass?: InputMaybe<Array<Scalars['String']>>;
  enrollmentDataSources?: InputMaybe<Array<Scalars['String']>>;
  excludePerchLeads?: InputMaybe<Scalars['Boolean']>;
  hasPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  loadZoneIds?: InputMaybe<Array<Scalars['Int']>>;
  preEnrollmentOrAttrited?: InputMaybe<Scalars['Boolean']>;
  projectGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
  ruleFilters?: InputMaybe<Array<RuleStatusFilter>>;
  secondaryAccountIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  stateId?: InputMaybe<Scalars['Int']>;
  subscriptionStatuses?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountNumbers?: InputMaybe<Array<Scalars['String']>>;
  utilityCredentialStatuses?: InputMaybe<Array<Scalars['String']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
  verifiedLmiSourceTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  vnmDeveloperIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CommunitySolarRuleStatusesResponse = {
  count: Scalars['Int'];
  records: Array<UtilityAccount>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CommunitySolarUtilityAccount = {
  accountId: IntUpdate;
  accountNumber: StringUpdate;
  annualizedUsageEstimate: IntUpdate;
  autopayDisabled: BooleanUpdate;
  availableStatementDate: DateUpdate;
  budgetBilling: BooleanUpdate;
  communitySolarProjectGroupId: IntUpdate;
  connected: BooleanUpdate;
  createdAt: DatetimeUpdate;
  customerClass: StringUpdate;
  customerClassSource: StringUpdate;
  displayServiceAddress: StringUpdate;
  ebillDisabled: BooleanUpdate;
  gasOnly: BooleanUpdate;
  hasElectricMultimeter: BooleanUpdate;
  hasRooftopSolar: BooleanUpdate;
  hasVnmProduct: BooleanUpdate;
  highlights: ArrayUpdate;
  id: Scalars['Int'];
  is60Days: BooleanUpdate;
  isLmi: BooleanUpdate;
  latestAdminReview?: Maybe<CommunitySolarAdminReview>;
  loadZoneId: IntUpdate;
  meterNumbers: ArrayUpdate;
  name: StringUpdate;
  nameKeyForEdi: StringUpdate;
  noEbill: BooleanUpdate;
  nonArcadiaCommunitySolar: BooleanUpdate;
  pastDueAmount: FloatUpdate;
  pastDueUpdatedAt: DatetimeUpdate;
  paymentAssistanceProgram: BooleanUpdate;
  personalizedContractVersionsPending: BooleanUpdate;
  phoneNumber: StringUpdate;
  planId: IntUpdate;
  rateClassId: IntUpdate;
  rateClassName: StringUpdate;
  sandboxed: BooleanUpdate;
  scraperEnabled: BooleanUpdate;
  secondaryAccountIdentifier: StringUpdate;
  serviceAddressCity: StringUpdate;
  serviceAddressState: StringUpdate;
  serviceAddressStreetOne: StringUpdate;
  serviceAddressStreetTwo: StringUpdate;
  serviceAddressZip: StringUpdate;
  serviceCustomerName: StringUpdate;
  serviceIncludesElectric: BooleanUpdate;
  status: StringUpdate;
  types: ArrayUpdate;
  updatedAt: DatetimeUpdate;
};

export type CommunitySolarUtilityAccountUpdate = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedBy: Scalars['String'];
  utilityAccountId: Scalars['Int'];
  value: Scalars['String'];
};

export type CompletedAdvocacyCampaign = {
  advocacyCampaignId: Scalars['Int'];
  id: Scalars['Int'];
  message: Scalars['String'];
  title: Scalars['String'];
};

export type ContextScope = ExceptIn | OnlyIn;

export type Contract = {
  allVersions: Array<ContractVersion>;
  communitySolarProjectGroup?: Maybe<CommunitySolarProjectGroup>;
  communitySolarProjectGroupId?: Maybe<Scalars['Int']>;
  contractType: Scalars['String'];
  currentVersion?: Maybe<ContractVersion>;
  displayName: Scalars['String'];
  id: Scalars['Int'];
  internalName: Scalars['String'];
  state?: Maybe<State>;
  tag?: Maybe<Scalars['String']>;
};

export type ContractAddendum = {
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
};

export type ContractAgreement = {
  contractVersion: ContractVersion;
  contractVersionId: Scalars['Int'];
  contractVersionLanguage?: Maybe<ContractVersionLanguage>;
  contractVersionLanguageId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  executedContracts: Array<ExecutedContract>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']>;
};

export type ContractFileIngestionFilters = {
  /** Exact match on the user ingestion request ID. Combines with statuses using AND. */
  partnerSubscriberIngestionRequestId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<ContractFileIngestionStatus>>;
};

export type ContractFileIngestionOverviewInput = {
  filters?: InputMaybe<ContractFileIngestionFilters>;
  page?: InputMaybe<Scalars['Int']>;
};

export type ContractFileIngestionOverviewItem = {
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  billUploads: ContractFileIngestionTypeSummary;
  contracts: ContractFileIngestionTypeSummary;
  ingestionFile: Scalars['String'];
  partnerSubscriberIngestionRequestId: Scalars['Int'];
  proofDocs: ContractFileIngestionTypeSummary;
  requestedAt: Scalars['Datetime'];
};

export type ContractFileIngestionOverviewPage = {
  items: Array<ContractFileIngestionOverviewItem>;
  meta: ContractFileIngestionPageMeta;
};

export type ContractFileIngestionPageMeta = {
  page: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ContractFileIngestionRequest = {
  adminUser: AdminUser;
  adminUserId: Scalars['Int'];
  /** Signed audit report URL, valid for 24 hours. Null when there is no report yet. */
  auditReportFileDownloadUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  errorMessage?: Maybe<Scalars['String']>;
  failedCount: Scalars['Int'];
  id: Scalars['Int'];
  ingestionType: ContractFileIngestionType;
  partnerSubscriberIngestionRequestId: Scalars['Int'];
  sharepointFolderPath: Scalars['String'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: ContractFileIngestionStatus;
  succeededCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum ContractFileIngestionStatus {
  Failed = 'failed',
  InProgress = 'in_progress',
  PartiallySucceeded = 'partially_succeeded',
  /** Only in overview summaries and filters: the type has no run yet. Runs are never pending. */
  Pending = 'pending',
  Queued = 'queued',
  Succeeded = 'succeeded',
}

export enum ContractFileIngestionType {
  BillUploads = 'bill_uploads',
  Contracts = 'contracts',
  ProofDocs = 'proof_docs',
}

export type ContractFileIngestionTypeSummary = {
  /** Null when the status is pending */
  latestRunId?: Maybe<Scalars['Int']>;
  status: ContractFileIngestionStatus;
};

export type ContractLink = {
  accountId: Scalars['Int'];
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ContractMetadata = {
  contractVersionId: Scalars['Int'];
  id: Scalars['Int'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ContractSubscriberRequirement = SubscriberRequirement & {
  contract: Contract;
  contractId: Scalars['Int'];
  dependencies: Array<SubscriberRequirement>;
  key: Scalars['String'];
  status: SubscriberRequirementStatus;
};

export type ContractTabsDataInput = {
  county?: InputMaybe<Scalars['String']>;
  houseIncome?: InputMaybe<Scalars['String']>;
  houseOccupancy?: InputMaybe<Scalars['String']>;
  lmiProgram?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lmiSourceSelection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum ContractTag {
  /** Energywell specific tags */
  Energywell = 'energywell',
  /** Minnesota LMI specific tags */
  MnLmi = 'mn_lmi',
  /** NJ Affirmative Action specific tags */
  NjAffirmative = 'nj_affirmative',
  /** NYSEG utility specific e-billing contract. */
  Nyseg = 'nyseg',
  /** Oregon Affirmative Action specific tags */
  OregonAffirmative = 'oregon_affirmative',
  /** Oregon specific tags */
  OregonTier_1Lmi = 'oregon_tier_1_lmi',
  OregonTier_1LmiPge = 'oregon_tier_1_lmi_PGE',
  /** Portland General Electric specific tags for Oregon Tier 2 LMI */
  OregonTier_2LmiPge = 'oregon_tier_2_lmi_PGE',
  /** Pacific Power specific tags for Oregon Tier 2 LMI */
  OregonTier_2LmiPp = 'oregon_tier_2_lmi_PP',
  /** PowerSetter specific tags */
  Powersetter = 'powersetter',
  /** Contracts offering 10% savings to SMBs */
  Smb_10Off = 'smb_10_off',
  /** Contracts offering 15% savings to SMBs */
  Smb_15Off = 'smb_15_off',
  /** Contracts applying to all SMB customers. */
  SmbGeneral = 'smb_general',
  /** Solar Landscape specific tags */
  SolarLandscape = 'solar_landscape',
  /** Sponsored solar specific tags */
  SponsoredSolar = 'sponsored_solar',
}

export enum ContractType {
  Agency = 'agency',
  Brokerage = 'brokerage',
  Consent = 'consent',
  Direct = 'direct',
  DirectAndDisclosure = 'direct_and_disclosure',
  Disclosure = 'disclosure',
  FlatBill = 'flat_bill',
  Lmi = 'lmi',
  Obf = 'obf',
  Privacy = 'privacy',
  Solar = 'solar',
  Terms = 'terms',
  UsageRequest = 'usage_request',
  Vnm = 'vnm',
}

export type ContractVersion = {
  addendums: Array<ContractAddendum>;
  base64PerchPersonalizedFile?: Maybe<Scalars['String']>;
  base64PerchPersonalizedFiles?: Maybe<Array<PerchPersonalizedFileEntry>>;
  cancellationRequirements?: Maybe<Scalars['String']>;
  contractId: Scalars['Int'];
  contractType: Scalars['String'];
  contractVersionLanguage?: Maybe<ContractVersionLanguage>;
  createdAt: Scalars['Datetime'];
  current: Scalars['Boolean'];
  displayName: Scalars['String'];
  fileUrl: Scalars['String'];
  hasPersonalization?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalName: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  partnersInExhibit?: Maybe<Scalars['String']>;
  perchPersonalizedError?: Maybe<Scalars['String']>;
  perchPersonalizedFile?: Maybe<Scalars['String']>;
  personalizedFile?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  projectsInExibit?: Maybe<Scalars['String']>;
  savingsRate?: Maybe<Scalars['String']>;
  scrollRequired: Scalars['Boolean'];
  signatureType: Scalars['String'];
  state?: Maybe<State>;
  /** @deprecated Use state.id instead */
  stateId?: Maybe<Scalars['Int']>;
  subscriptionSizeMaximum?: Maybe<Scalars['String']>;
  tag?: Maybe<ContractTag>;
  termLength?: Maybe<Scalars['String']>;
  termStartDate?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  version: Scalars['Float'];
};

export type ContractVersionAddendumsArgs = {
  vnmSolarProjectIds: Array<Scalars['Int']>;
};

export type ContractVersionContractVersionLanguageArgs = {
  languageShortCode?: InputMaybe<Scalars['String']>;
};

export type ContractVersionPerchPersonalizedFileArgs = {
  planId: Scalars['Int'];
};

export type ContractVersionPersonalizedFileArgs = {
  utilityAccountId: Scalars['Int'];
};

export type ContractVersionLanguage = {
  contractVersionId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  languageShortCode: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export type ContractVersionPersonalizationRequest = {
  adminUser: AdminUser;
  adminUserId: Scalars['Int'];
  contractVersion: ContractVersion;
  contractVersionId: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['String'];
  uploadedFileUrl: Scalars['String'];
};

export type ContractVersionsInput = {
  agency?: InputMaybe<Scalars['Float']>;
  obf?: InputMaybe<Scalars['Float']>;
  privacy?: InputMaybe<Scalars['Float']>;
  solar?: InputMaybe<Scalars['Float']>;
  terms?: InputMaybe<Scalars['Float']>;
};

export type CorrectionLineItem = FormattedLineItem & {
  amountCents: Scalars['Int'];
  correctingStatement?: Maybe<Statement>;
  correctingStatementId?: Maybe<Scalars['Int']>;
  creditCorrection?: Maybe<CreditCorrection>;
  creditCorrectionId: Scalars['Int'];
  entryType: LineItemEntryType;
  id: Scalars['String'];
  key: LineItemKey;
  name: Scalars['String'];
  sandboxed: Scalars['Boolean'];
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId: Scalars['Int'];
};

export type CountGroupedByCampaignPresence = {
  withCampaign: Scalars['Int'];
  withoutCampaign: Scalars['Int'];
};

export type CountyData = {
  counties?: Maybe<Array<Maybe<Scalars['String']>>>;
  incomeLimits?: Maybe<Scalars['JSON']>;
};

export enum CountyProjectMatch {
  CountyFiltered = 'county_filtered',
  NoCounty = 'no_county',
  UnrestrictedFallback = 'unrestricted_fallback',
}

export type CreateAccountClosureRequestInput = {
  attritionCategoryId: Scalars['Int'];
  closureType: ClosureType;
  finalVnmStatus?: InputMaybe<Scalars['String']>;
  note: Scalars['String'];
  processRequestFile: Scalars['JSON'];
  suppressEmailCommunication?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAccountClosureRequestOutput = {
  accountClosureRequest?: Maybe<AccountClosureRequest>;
};

export type CreateAdvocacyCampaignSubmissionInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  advocacyCampaignId: Scalars['Int'];
  body: Scalars['String'];
  planId?: InputMaybe<Scalars['Int']>;
  representatives?: InputMaybe<Array<RepresentativeInput>>;
  subject: Scalars['String'];
  userId: Scalars['Int'];
};

/** Used to accept nested attributes for supplier statement detail associated with a utility statement */
export type CreateAssociatedSupplierStatementDetailInput = {
  rateClassId: Scalars['Int'];
  rateClassName: Scalars['String'];
};

export type CreateAttritionInput = {
  attritionCategoryId: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  vnmSubscriptionIds: Array<Scalars['Int']>;
};

export type CreateAttritionOutput = {
  attritionIds: Array<Scalars['Int']>;
};

export type CreateBillPayServiceProductEligibilityInput = {
  eligible: Scalars['Boolean'];
  reasons?: InputMaybe<Array<Scalars['String']>>;
  utilityAccountId: Scalars['Int'];
};

export type CreateBillPayServiceProductSubscriptionInput = {
  planId: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
};

export type CreateBulkProcessingRequestInput = {
  note: Scalars['String'];
  processRequestFile: Scalars['JSON'];
  requestType: Scalars['String'];
};

export type CreateBulkProcessingRequestOutput = {
  bulkProcessingRequest?: Maybe<BulkProcessingRequest>;
};

export type CreateCommunitySolarUtilityAccountExportInput = {
  filters?: InputMaybe<CommunitySolarRuleFilters>;
  includeSubscriptionData?: InputMaybe<Scalars['Boolean']>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateCommunitySolarUtilityAccountExportOutput = {
  id: Scalars['Int'];
};

export type CreateCommunitySolarUtilityAccountUpdateInput = {
  name: Scalars['String'];
  updatedBy: Scalars['String'];
  value: Scalars['String'];
};

export type CreateContractAgreementExportInput = {
  contractType: Scalars['String'];
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateContractAgreementExportOutput = {
  id: Scalars['Int'];
};

export type CreateContractAgreementInput = {
  contractVersionId: Scalars['Int'];
  contractVersionLanguageId?: InputMaybe<Scalars['Int']>;
  externalSystem?: InputMaybe<ExternalSystemDataInput>;
  file?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type CreateContractAgreementOutput = {
  success: Scalars['Boolean'];
};

export type CreateContractAgreementZippedFilesInput = {
  contractType: ContractType;
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateContractAgreementZippedFilesOutput = {
  errors: Scalars['JSON'];
  s3Key: Scalars['String'];
};

export type CreateContractAgreementsPerchInput = {
  contractVersionIds: Array<Scalars['Int']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type CreateContractFileIngestionRequestInput = {
  ingestionType: ContractFileIngestionType;
  partnerSubscriberIngestionRequestId: Scalars['Int'];
  sharepointFolderPath: Scalars['String'];
};

export type CreateContractInput = {
  base64Content: Scalars['String'];
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  contractType: Scalars['String'];
  displayName: Scalars['String'];
  internalName: Scalars['String'];
  stateId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type CreateContractLinkInput = {
  accountId: Scalars['Int'];
  details?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateContractVersionInput = {
  base64Content: Scalars['String'];
  hasAgencyLanguage?: InputMaybe<Scalars['Boolean']>;
  scrollRequired?: InputMaybe<Scalars['Boolean']>;
};

export type CreateContractVersionPersonalizationRequestInput = {
  contractVersionId: Scalars['Int'];
  uploadedFile: Scalars['JSON'];
};

export type CreateContractVersionPersonalizationRequestOutput = {
  contractVersionPersonalizationRequest?: Maybe<ContractVersionPersonalizationRequest>;
  error?: Maybe<Scalars['String']>;
};

export type CreateCreditCorrectionInput = {
  adjustmentCreditAmount?: InputMaybe<Scalars['Int']>;
  expectedCreditAmount?: InputMaybe<Scalars['Int']>;
  productionEndDate?: InputMaybe<Scalars['Date']>;
  productionStartDate?: InputMaybe<Scalars['Date']>;
  reason?: InputMaybe<Scalars['String']>;
  serviceEndDate?: InputMaybe<Scalars['Date']>;
  serviceStartDate?: InputMaybe<Scalars['Date']>;
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
};

export type CreateCreditInput = {
  accountIds: Array<Scalars['Int']>;
  amountCents: Scalars['Int'];
  creditTypeKey: Scalars['String'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

export type CreateCsCreditCalculationInput = {
  allocatedGeneration: Scalars['Int'];
  currentBankedGeneration: Scalars['Int'];
  energyChargeRate: Scalars['Float'];
  meterReading: Scalars['Float'];
  noOfDays: Scalars['Int'];
  previousBankedGeneration: Scalars['Int'];
  priorMeterReading: Scalars['Float'];
  priorReadDate: Scalars['Datetime'];
  readDate: Scalars['Datetime'];
  secondarySupplierRate?: InputMaybe<Scalars['Float']>;
  serviceEndDate: Scalars['Datetime'];
  serviceStartDate: Scalars['Datetime'];
  totalKwh: Scalars['Int'];
  unusedExpiredCredits: Scalars['Float'];
  utilityStatementId: Scalars['Int'];
};

export type CreateEmailVerificationAttemptResponse = {
  id: Scalars['Int'];
};

export type CreateExecutedContractExportInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateExecutedContractExportOutput = {
  id: Scalars['Int'];
};

export type CreateFinalizedUtilityAccountAllocationsInput = {
  data: Scalars['String'];
  parser: Scalars['String'];
};

export type CreateFunnelPacketInput = {
  accountId: Scalars['Int'];
  utilityId: Scalars['Int'];
};

export type CreateHostReportInput = {
  base64File: Scalars['String'];
  originalFilename: Scalars['String'];
  receiptDate: Scalars['Date'];
  utilityId: Scalars['Int'];
};

export type CreateHostReportOutput = {
  HostReport?: Maybe<HostReport>;
};

export type CreateLmiProofDocUploadExportInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateLmiProofDocUploadExportOutput = {
  id: Scalars['Int'];
};

export type CreateLmiProofDocZippedFilesInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateLmiProofDocZippedFilesOutput = {
  errors: Scalars['JSON'];
  s3Key: Scalars['String'];
};

export type CreateManualExtractionInput = {
  uploadedPdfFile: Scalars['JSON'];
  utilityAccountId: Scalars['Int'];
};

export type CreateManualExtractionOutput = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type CreateMeterInput = {
  meterNumber: Scalars['String'];
  utilityAccountId: Scalars['Int'];
};

export type CreateMoveRequestInput = {
  newPlanNickname?: InputMaybe<Scalars['String']>;
  oldUtilityAccountId?: InputMaybe<Scalars['Int']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  utilityId: Scalars['Int'];
};

export type CreateNoteInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  ownerId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  type: NoteType;
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateOptOutPeriodInput = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  vnmSolarProjectId: Scalars['Int'];
  vnmSubscriptionFilters?: InputMaybe<VnmSubscriptionFilters>;
  vnmSubscriptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CreatePartnerSubscriberIngestionRequestInput = {
  billingExperienceType: Scalars['String'];
  promoCode: Scalars['String'];
  uploadedIngestionFile: Scalars['JSON'];
};

export type CreatePartnerSubscriberIngestionRequestOutput = {
  partnerSubscriberIngestionRequest: PartnerSubscriberIngestionRequest;
};

export type CreatePerchContractAgreementInput = {
  contractVersionId: Scalars['Int'];
  contractVersionLanguageId?: InputMaybe<Scalars['Int']>;
  externalSystem?: InputMaybe<ExternalSystemDataInput>;
  file?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['Int']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type CreatePersonalizedContractPreviewInput = {
  contractVersionId: Scalars['Int'];
  tabsData: ContractTabsDataInput;
  utilityAccountId: Scalars['Int'];
};

export type CreatePlanInput = {
  accountId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  planTemplateId: Scalars['Int'];
};

export type CreatePlanWithUtilityAccountInput = {
  accountId: Scalars['Int'];
  billingExperience?: InputMaybe<Scalars['String']>;
  customerClass?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  planName?: InputMaybe<Scalars['String']>;
  planTemplateId?: InputMaybe<Scalars['Int']>;
  referencePlanId?: InputMaybe<Scalars['Int']>;
  utilityCredentialId?: InputMaybe<Scalars['Int']>;
  utilityId: Scalars['Int'];
};

export type CreatePlanWithUtilityAccountOutput = {
  account: Account;
  id: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
};

export type CreateProductLeadInput = {
  planId: Scalars['Int'];
  productId: Scalars['Int'];
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
};

export type CreateProspectUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  funnel: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  queryParams: Scalars['JSON'];
  utilityId: Scalars['Int'];
  zipCode: Scalars['String'];
};

export type CreateRefundTransactionInput = {
  amountCents: Scalars['Int'];
  refundReasonId: Scalars['Int'];
  statementId: Scalars['Int'];
};

export type CreateSessionInput = {
  adminUserId: Scalars['Int'];
  app: SessionApp;
  location: Scalars['String'];
};

export type CreateSetupIntentOutput = {
  stripeClientSecret: Scalars['String'];
};

export type CreateSignNowEnvelopeInput = {
  personalizedContractId: Scalars['Int'];
};

export type CreateStatementInput = {
  accountId: Scalars['Int'];
  autoIssue: Scalars['Boolean'];
  creditItems?: InputMaybe<Array<InputMaybe<CreditItemInput>>>;
  lineItems: Array<LineItemInput>;
  netPaymentTerms?: InputMaybe<Scalars['Int']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  paymentScheduledAt?: InputMaybe<Scalars['String']>;
  planId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CreateSupplierStatementDetailInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  budgetBill?: InputMaybe<Scalars['Boolean']>;
  currentSupplyRate?: InputMaybe<Scalars['Float']>;
  disconnectionNotice?: InputMaybe<Scalars['Boolean']>;
  finalBill?: InputMaybe<Scalars['Boolean']>;
  firstBill?: InputMaybe<Scalars['Boolean']>;
  loadZoneId?: InputMaybe<Scalars['Int']>;
  municipalAggregation?: InputMaybe<Scalars['Boolean']>;
  netMetered?: InputMaybe<Scalars['Boolean']>;
  pastDue?: InputMaybe<Scalars['Boolean']>;
  pastDueAmount?: InputMaybe<Scalars['Float']>;
  rateClassId?: InputMaybe<Scalars['Int']>;
  rateClassName?: InputMaybe<Scalars['String']>;
  secondaryAccountIdentifier?: InputMaybe<Scalars['String']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressState?: InputMaybe<Scalars['String']>;
  serviceAddressStreetOne?: InputMaybe<Scalars['String']>;
  serviceAddressStreetTwo?: InputMaybe<Scalars['String']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  serviceCustomerName?: InputMaybe<Scalars['String']>;
  sosSupply?: InputMaybe<Scalars['Boolean']>;
  supplierName?: InputMaybe<Scalars['String']>;
  utilityStatementId: Scalars['Int'];
};

export type CreateTemporaryPaymentHoldInput = {
  accountId: Scalars['Int'];
  amountCents: Scalars['Int'];
  deletePaymentMethodOnFailure: Scalars['Boolean'];
  paymentMethodId: Scalars['Int'];
};

export type CreateTemporaryPaymentHoldOutput = {
  /** used for error messages (not user-facing) */
  message?: Maybe<Scalars['String']>;
  result: PaymentHoldResult;
};

export type CreateThinkSyncCsvInput = {
  data: Scalars['String'];
  directory: Scalars['String'];
  fileName: Scalars['String'];
  nestedSubdirectory?: InputMaybe<Scalars['String']>;
  subDirectory?: InputMaybe<Scalars['String']>;
};

export type CreateUaLmiSourceTypeWithContractInput = {
  contractVersionId: Scalars['Int'];
  contractVersionLanguageId?: InputMaybe<Scalars['Int']>;
  documentType: Scalars['String'];
  externalSystem?: InputMaybe<Scalars['JSON']>;
  sourceFile?: InputMaybe<Scalars['String']>;
};

export type CreateUserEmailInput = {
  accountId: Scalars['Int'];
  accountNumber?: InputMaybe<Scalars['String']>;
  customText?: InputMaybe<Scalars['String']>;
  emailName: Scalars['String'];
  overrideEmail?: InputMaybe<Scalars['String']>;
  serviceAddress?: InputMaybe<Scalars['String']>;
};

export type CreateUserEmailOutput = {
  message?: Maybe<Scalars['String']>;
  query: Query;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateUserTipInput = {
  completed: Scalars['Boolean'];
  tipId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CreateUtilityAccountBillExtractionInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  annualUsageKwh?: InputMaybe<Scalars['Float']>;
  extractionId: Scalars['String'];
  meterNumber?: InputMaybe<Scalars['String']>;
  qualificationStatus: BillExtractionQualificationStatus;
  secondaryId?: InputMaybe<Scalars['String']>;
  secondaryIdType?: InputMaybe<BillExtractionSecondaryAccountIdentifierType>;
  serviceAddress?: InputMaybe<Scalars['String']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressState?: InputMaybe<Scalars['String']>;
  serviceAddressStreetOne?: InputMaybe<Scalars['String']>;
  serviceAddressStreetTwo?: InputMaybe<Scalars['String']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
  utilityAccountName?: InputMaybe<Scalars['String']>;
};

export type CreateUtilityCredentialSessionInput = {
  utilityCredentialId: Scalars['Int'];
};

export type CreateUtilityCredentialSessionOutput = {
  uuid: Scalars['String'];
};

/** Use utilityAccountId instead of accountId when creating a UtilityStatement */
export type CreateUtilityStatementInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  arcVnmBillCredits?: InputMaybe<Scalars['Float']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  carryForwardCredits?: InputMaybe<Scalars['Float']>;
  carryForwardKwh?: InputMaybe<Scalars['Int']>;
  carryoverCredits?: InputMaybe<Scalars['Float']>;
  cdgSubscriptionFee?: InputMaybe<Scalars['Float']>;
  closingCreditsBalance?: InputMaybe<Scalars['Float']>;
  creditsAppliedThisPeriod?: InputMaybe<Scalars['Float']>;
  creditsExpired?: InputMaybe<Scalars['Float']>;
  creditsReceived?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['String']>;
  expiringVnmKwh?: InputMaybe<Scalars['Int']>;
  fixedPercentage?: InputMaybe<Scalars['String']>;
  ignoreHighlights: Scalars['Boolean'];
  kwh: Scalars['Int'];
  meterNumbers?: InputMaybe<Array<Scalars['String']>>;
  openingCreditsBalance?: InputMaybe<Scalars['Float']>;
  preVnmServiceCharge?: InputMaybe<Scalars['Float']>;
  rawVnmData?: InputMaybe<Scalars['JSON']>;
  serviceEndDate: Scalars['String'];
  serviceStartDate: Scalars['String'];
  statementDate?: InputMaybe<Scalars['String']>;
  supplierStatementDetail?: InputMaybe<CreateAssociatedSupplierStatementDetailInput>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  utilityCharge?: InputMaybe<Scalars['Float']>;
  vnmAppliedKwh?: InputMaybe<Scalars['Int']>;
  vnmBillCredits?: InputMaybe<Scalars['Float']>;
  vnmProductionCredits?: InputMaybe<Scalars['Float']>;
  vnmProductionKwh?: InputMaybe<Scalars['Int']>;
};

export type CreateUtilityStatementMutationOutput = {
  highlights?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  utilityAccount?: Maybe<UtilityAccount>;
};

export type CreateVnmProductEligibilitiesExportInput = {
  filters?: InputMaybe<VnmProductEligibilitiesFilters>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateVnmProductEligibilitiesExportOutput = {
  id: Scalars['Int'];
};

export type CreateVnmCampaignBatchInput = {
  data: Array<CreateVnmCampaignBatchRowInput>;
};

export type CreateVnmCampaignBatchOutput = {
  id: Scalars['Int'];
};

export type CreateVnmCampaignBatchRowInput = {
  dfFile?: InputMaybe<Scalars['String']>;
  optOutEnd: Scalars['String'];
  optOutStart: Scalars['String'];
  saFile?: InputMaybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
  vnmSolarProjectName: Scalars['String'];
};

export type CreateVnmDeveloperMutationInput = {
  name: Scalars['String'];
};

export type CreateVnmSolarProjectExportInput = {
  filters?: InputMaybe<VnmSubscriptionFilters>;
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
  vnmSubscriptionIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateVnmSolarProjectExportOutput = {
  id: Scalars['Int'];
};

export type CreateVnmSubscriptionInput = {
  savingsRate?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  utilityAccountId: Scalars['Int'];
  vnmSolarProjectId: Scalars['Int'];
};

export type CreateVnmUtilitySubmissionExportInput = {
  columnKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vnmUtilitySubmissionId: Scalars['Int'];
};

export type CreateVnmUtilitySubmissionExportOutput = {
  id: Scalars['Int'];
};

export type CreateVnmUtilitySubmissionInput = {
  submissionDate: Scalars['String'];
  vnmSolarProjectId: Scalars['Int'];
};

export type CreateVnmUtilitySubmissionOutput = {
  vnmUtilitySubmissionId: Scalars['Int'];
};

export type CreateWinbackCallAttemptInput = {
  accountLeadId: Scalars['Int'];
  attemptedById?: InputMaybe<Scalars['Int']>;
  followUpDate?: InputMaybe<Scalars['Date']>;
  outcome: WinbackCallAttemptOutcome;
  voicemailSent?: InputMaybe<Scalars['Boolean']>;
};

export type CreateWinbackCampaignFiltersInput = {
  attributeName: Scalars['String'];
  criteria: CriteriaInput;
  partialMatch?: InputMaybe<Scalars['Boolean']>;
};

export type CreateWinbackCampaignInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  targetCompletionDate: Scalars['Datetime'];
  winbackCampaignFiltersAttributes: Array<InputMaybe<CreateWinbackCampaignFiltersInput>>;
};

export type CreateZippedFilesInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type CreateZippedFilesOutput = {
  errors: Scalars['JSON'];
  s3Key: Scalars['String'];
};

export type CreateZuoraLinkTokenInput = {
  methodType: ZuoraLinkTokenMethodType;
};

export type Credit = {
  amountCents: Scalars['Int'];
  appliedCents: Scalars['Int'];
  appliedStatements?: Maybe<Array<Maybe<AppliedCredit>>>;
  createdAt?: Maybe<Scalars['Datetime']>;
  createdEvent?: Maybe<AuditLogEvent>;
  creditType: CreditType;
  creditTypeId: Scalars['Int'];
  expiresAt?: Maybe<Scalars['Datetime']>;
  externalId?: Maybe<Scalars['String']>;
  externalType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  sandboxed: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  userExternalId: Scalars['String'];
  void: Scalars['Boolean'];
};

export type CreditCorrection = {
  adjustmentAmountCents: Scalars['Int'];
  appliedCents: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  creator: AdminUser;
  deletable: Scalars['Boolean'];
  id: Scalars['Int'];
  preSavingsAdjustmentAmountCents: Scalars['Int'];
  productionEndDate?: Maybe<Scalars['Date']>;
  productionStartDate?: Maybe<Scalars['Date']>;
  reason?: Maybe<Scalars['String']>;
  serviceEndDate?: Maybe<Scalars['Date']>;
  serviceStartDate?: Maybe<Scalars['Date']>;
  solarCreditAmountCents?: Maybe<Scalars['Int']>;
  sourceId: Scalars['Int'];
  sourceType: SourceType;
  statementIds?: Maybe<Array<Scalars['Int']>>;
  statements?: Maybe<Array<Statement>>;
  updatedAt: Scalars['Datetime'];
};

export type CreditItemElements = {
  amountCents: Scalars['Int'];
  creditTypeKey: Scalars['String'];
  externalId: Scalars['String'];
  externalType: Scalars['String'];
  metadata: Scalars['JSON'];
};

export type CreditItemInput = {
  amountCents: Scalars['Int'];
  creditTypeKey?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalType?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
};

export type CreditRating = {
  creditSafeScore?: Maybe<Scalars['Int']>;
  ficoScore?: Maybe<Scalars['Int']>;
  moodysScore?: Maybe<Scalars['String']>;
};

export type CreditType = {
  defaultAmountCents?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type CriteriaInput = {
  equals?: InputMaybe<Scalars['String']>;
  excludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from?: InputMaybe<Scalars['String']>;
  includes?: InputMaybe<Scalars['JSON']>;
  notEquals?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type CsCreditCalculation = {
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  allocatedGeneration?: Maybe<Scalars['Int']>;
  calculationErrors?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  currentBankedGeneration?: Maybe<Scalars['Int']>;
  daysOnNewRate?: Maybe<Scalars['Int']>;
  daysOnPreviousRate?: Maybe<Scalars['Int']>;
  deliveryCreditOnNewRate?: Maybe<Scalars['Float']>;
  deliveryCreditOnPreviousRate?: Maybe<Scalars['Float']>;
  energyChargeRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  kwhOnNewRate?: Maybe<Scalars['Int']>;
  kwhOnPreviousRate?: Maybe<Scalars['Int']>;
  meterReading?: Maybe<Scalars['Float']>;
  newRate?: Maybe<Scalars['Float']>;
  noOfDays?: Maybe<Scalars['Int']>;
  preVnmDeliveryCredit?: Maybe<Scalars['Float']>;
  preVnmDeliveryCreditOnNewRate?: Maybe<Scalars['Float']>;
  preVnmDeliveryCreditOnPreviousRate?: Maybe<Scalars['Float']>;
  preVnmServiceCharge?: Maybe<Scalars['Float']>;
  preVnmSupplyCredit?: Maybe<Scalars['Float']>;
  previousBankedGeneration?: Maybe<Scalars['Int']>;
  previousRate?: Maybe<Scalars['Float']>;
  priorMeterReading?: Maybe<Scalars['Float']>;
  priorReadDate?: Maybe<Scalars['Datetime']>;
  rateChangeDate?: Maybe<Scalars['Datetime']>;
  readDate?: Maybe<Scalars['Datetime']>;
  secondarySupplierRate?: Maybe<Scalars['Float']>;
  serviceEndDate?: Maybe<Scalars['Datetime']>;
  serviceStartDate?: Maybe<Scalars['Datetime']>;
  supplyCredit?: Maybe<Scalars['Float']>;
  totalDeliveryCredit?: Maybe<Scalars['Float']>;
  totalKwh?: Maybe<Scalars['Int']>;
  unusedExpiredCredits?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  utilityStatementId?: Maybe<Scalars['Int']>;
  vnmCredit?: Maybe<Scalars['Float']>;
};

export enum CustomerAccountType {
  Business = 'Business',
  Residential = 'Residential',
}

export enum CustomerClass {
  General = 'GENERAL',
  Proposed = 'PROPOSED',
  Residential = 'RESIDENTIAL',
  SpecialUse = 'SPECIAL_USE',
}

export type CustomerSnapshot = {
  id: Scalars['Int'];
};

export type DashboardNotifications = {
  currentNotifications: Array<Notification>;
  hasSomeHighPriority: Scalars['Boolean'];
  notifications: Array<Notification>;
  pastNotifications: Array<Notification>;
  totalCount: Scalars['Int'];
  totalCurrentNotifications: Scalars['Int'];
  totalPastNotifications: Scalars['Int'];
};

export type DashboardNotificationsInput = {
  currentTabPage?: InputMaybe<Scalars['Int']>;
  currentTabPageSize?: InputMaybe<Scalars['Int']>;
  pastTabPage?: InputMaybe<Scalars['Int']>;
  pastTabPageSize?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type DateRangeFilter = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type DateUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Date']>;
};

export type DatetimeUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Datetime']>;
};

export type DeactivateBillPayServiceProductSubscriptionInput = {
  attritionCategoryId?: InputMaybe<Scalars['Int']>;
  attritionComment?: InputMaybe<Scalars['String']>;
};

export type DeactivateProductSubscriptionInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};

export type DebitItemElements = {
  amountCents: Scalars['Int'];
  lineItemTypeKey: Scalars['String'];
  metadata: Scalars['JSON'];
  partnerAccountId?: Maybe<Scalars['String']>;
  remittanceAmountCents?: Maybe<Scalars['Int']>;
};

export type DelayStatementPaymentInput = {
  paymentScheduledAt: Scalars['String'];
  source: StatementOrigin;
  statementId: Scalars['Int'];
};

export type DeleteContractLinkInput = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};

export type DeleteHostReportOutput = {
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMoveRequestInput = {
  id: Scalars['Int'];
};

export type DeleteNoteInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
  type: NoteType;
  userId?: InputMaybe<Scalars['Int']>;
};

export type DeleteSessionInput = {
  app: SessionApp;
  id: Scalars['String'];
};

export type DeleteVnmSubscriptionInput = {
  vnmSubscriptionIds: Array<Scalars['Int']>;
};

export type DerivedStatementData = {
  /** the utility account's active billing settings when the utility statement was saved/updated */
  activeBillingSettings?: Maybe<ActiveBillingSettings>;
  /** the amount that a member would be charged for the banked credits being applied/removed */
  amortizedSolarCreditsCostCents?: Maybe<Scalars['Int']>;
  /**
   * the total value of credits that will be applied or removed using the credit bank
   * If this is positive we are increasing the total to use up previous credits.
   * If this is negative we are decreasing the total and banking the credits to be used later.
   */
  amortizedSolarCreditsValueAdjustmentCents?: Maybe<Scalars['Int']>;
  /** the savings amount the member would receives off the total value of the banked credits being applied/removed */
  amortizedSolarSavingsAmountCents?: Maybe<Scalars['Int']>;
  /**
   * the utility charge without any included solar credit charges
   * For arcadia remitting, this will be the same as the utility_bill_total_cents.
   * For utility remitting, we need to subtract what we believe the solar charge would be.
   */
  postCsUtilityChargeCents?: Maybe<Scalars['Int']>;
  /**
   * For utility remitting, we can end up with a negative amount for post_cs_utility_charge_cents.
   * If that happens the utility is applying some kind of credit from previously overcharging
   * which we capture with the presumed credit
   */
  presumedUtilityChargeCents?: Maybe<Scalars['Int']>;
  /** the balance in the credit bank when the utility statement was saved/updated. includes the previous balance + the sourceSolarCreditsValueCents from this utility statement */
  solarCreditsBalanceCents?: Maybe<Scalars['Int']>;
  /** the amount that a member would be charged for the credits (the total value with the savings rate applied) */
  solarCreditsCostCents?: Maybe<Scalars['Int']>;
  /** the total value of the credits including any amortized adjustments */
  solarCreditsValueCents?: Maybe<Scalars['Int']>;
  /** the savings amount the member would receive off the total value of the credits */
  solarSavingsAmountCents?: Maybe<Scalars['Int']>;
  /** the savings rate of the vnm subscription at the time of saving/updating */
  solarSavingsRate?: Maybe<Scalars['Float']>;
  /** the amount that a member would be charged for the credits on the source */
  sourceSolarCreditsCostCents?: Maybe<Scalars['Int']>;
  /** the total value of the credits defined on the source (amount deducted by utility) */
  sourceSolarCreditsValueCents?: Maybe<Scalars['Int']>;
  /** the savings amount the member would receive off the total value of the credits on the source */
  sourceSolarSavingsAmountCents?: Maybe<Scalars['Int']>;
  /**
   * the total amount on the member's utility bill
   * For utility remitting projects this total will include the solar credits cost.
   */
  utilityBillTotalCents?: Maybe<Scalars['Int']>;
  /** what the total amount on the member's utility bill would be without the solar credit deduction on their bill */
  utilityBillWithoutArcadiaTotalCents?: Maybe<Scalars['Int']>;
  /**
   * the total of both the isolated utility charge and solar charges
   * For arcadia remitting, we need to sum the two charges.
   * For utility remitting, this value is the same as utility_bill_total_cents.
   */
  utilityCsCombinedCents?: Maybe<Scalars['Int']>;
};

export type Dispute = {
  account?: Maybe<Account>;
  accountActive?: Maybe<Scalars['Boolean']>;
  closedStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  emailSentAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionDetails?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type DisputeResponse = {
  data: Array<Maybe<Dispute>>;
  resultCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DisputesFilterOptions = {
  accountActive?: InputMaybe<Scalars['Boolean']>;
  closedStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<DateRangeFilter>;
  reason?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type DocuSignClickwrap = {
  agreementId?: Maybe<Scalars['String']>;
  clickwrapId: Scalars['String'];
  contractVersionId: Scalars['Int'];
  docuSignAccountId: Scalars['String'];
  environment: Scalars['String'];
};

export type DocuSignClickwrapInput = {
  agreementId: Scalars['String'];
  clickwrapId: Scalars['String'];
  userId: Scalars['Int'];
};

export type DocuSignEnvelope = {
  completedFile?: Maybe<Scalars['String']>;
  contractVersionId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  externalEnvelopeId: Scalars['String'];
  id: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  submittedToIpa: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
};

export type DocuSignEnvelopeCreateInput = {
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  tabsData?: InputMaybe<NjTabsDataInput>;
  userId: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
};

export type DocuSignEnvelopeStatusInput = {
  envelopeId: Scalars['Int'];
  status: Scalars['String'];
  userId: Scalars['Int'];
};

export type DocuSignInstantAlertInput = {
  inviteCode?: InputMaybe<Scalars['String']>;
  track: FunnelTrack;
  userIp?: InputMaybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
};

export type DocuSignInstantAlertOutput = {
  success: Scalars['Boolean'];
};

export type Document = {
  archiveUrl?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentTitle: Scalars['String'];
  lseId: Scalars['ID'];
  lseName: Scalars['String'];
  sectionTypes?: Maybe<Scalars['String']>;
  sections: Array<DocumentSection>;
  sequenceNumber: Scalars['Int'];
  sourceContentType: Scalars['String'];
  sourceUrl: Scalars['String'];
  territoryId?: Maybe<Scalars['ID']>;
  territoryName?: Maybe<Scalars['String']>;
};

export type DocumentSection = {
  customerClass: CustomerClass;
  documentId: Scalars['ID'];
  documentSectionId: Scalars['ID'];
  revised: Scalars['Boolean'];
  sectionHeading: Scalars['String'];
  sectionType: UsageType;
  startPage: Scalars['Int'];
};

export type DowngradeProductSubscriptionInput = {
  id: Scalars['Int'];
  productId: Scalars['Int'];
};

export type Echeck = {
  accounts?: Maybe<Array<Account>>;
  amountCents?: Maybe<Scalars['Int']>;
  charges?: Maybe<Scalars['Int']>;
  checkNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  history?: Maybe<Array<Echeck>>;
  id: Scalars['Int'];
  payee?: Maybe<Scalars['String']>;
  reissued?: Maybe<Scalars['Boolean']>;
  remittanceItems: Array<RemittanceItem>;
  statements: Array<Statement>;
  status?: Maybe<Scalars['String']>;
};

export type EcheckFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  remittanceBatchId?: InputMaybe<Scalars['Int']>;
  specialCases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type EcheckRemittanceMethodDetails = {
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  multiplePaymentsPerCheck?: Maybe<Scalars['Boolean']>;
  payee?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type EchecksResponse = {
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Echeck>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EditContractMetadataInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type EgridSubregion = {
  abbreviation: Scalars['String'];
  energyBreakdown: EnergyBreakdown;
  energySummary: EnergySummary;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EmailDeviceShippingInformationInput = {
  accountId: Scalars['Int'];
  productSubscriptionId: Scalars['Int'];
};

export type EmailEventFailure = {
  data: Scalars['JSON'];
  message: Scalars['String'];
  name: Scalars['String'];
};

export type EmailEventInput = {
  data: Scalars['JSON'];
  name: Scalars['String'];
};

export type EmailEventResults = {
  failures: Array<EmailEventFailure>;
  totalFailed: Scalars['Int'];
  totalSent: Scalars['Int'];
};

export type EmailParsingResult = {
  id: Scalars['Int'];
  utilityAccountId?: Maybe<Scalars['Int']>;
  utilityAccountIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  utilityAccounts?: Maybe<Array<Maybe<UtilityAccount>>>;
  utilityCredentialId?: Maybe<Scalars['Int']>;
  utilityEmail?: Maybe<UtilityEmail>;
  utilityEmailId?: Maybe<Scalars['Int']>;
};

export type EmailStatementInput = {
  accountId: Scalars['Int'];
  source: StatementOrigin;
  statementId: Scalars['Int'];
};

export type EmailValidationOutput = {
  userExists: Scalars['Boolean'];
  valid: Scalars['Boolean'];
  validationErrorMessage: Scalars['String'];
};

/**
 * To confirm eligibility for a promo code, a new member may need to verify their
 * email address.  An EmailVerificationAttempt is a request to verify a particular
 * email address, for a particular promo code.
 */
export type EmailVerificationAttempt = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  promoCode: PromoCode;
  used: Scalars['Boolean'];
};

export type EmailVerificationAttemptInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  promoCode: Scalars['String'];
};

export type EmailVerificationOutput = {
  valid: Scalars['Boolean'];
  validationErrorMessage: Scalars['String'];
};

export type EndSessionResponse = {
  success: Scalars['Boolean'];
};

export type EnergyBreakdown = {
  biomass: Scalars['Float'];
  coal: Scalars['Float'];
  gas: Scalars['Float'];
  geothermal: Scalars['Float'];
  hydro: Scalars['Float'];
  nuclear: Scalars['Float'];
  oil: Scalars['Float'];
  otherFossil: Scalars['Float'];
  solar: Scalars['Float'];
  unknown: Scalars['Float'];
  wind: Scalars['Float'];
};

export type EnergySummary = {
  fossilFuels: Scalars['Float'];
  fossilFuelsAndNuclear: Scalars['Float'];
  nuclear: Scalars['Float'];
  renewables: Scalars['Float'];
};

export type EnrolledUser = {
  email: Scalars['String'];
  id: Scalars['Int'];
  signupFunnelLeadId?: Maybe<Scalars['Int']>;
};

export type EnrollingUserError = {
  projectId?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EnrollingUserInput = {
  budgetBilling?: InputMaybe<Scalars['Boolean']>;
  businessName?: InputMaybe<Scalars['String']>;
  businessPhone?: InputMaybe<Scalars['String']>;
  clickId?: InputMaybe<Scalars['String']>;
  communicationPreferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  contactAddressCity?: InputMaybe<Scalars['String']>;
  contactAddressState?: InputMaybe<Scalars['String']>;
  contactAddressStreetOne?: InputMaybe<Scalars['String']>;
  contactAddressStreetTwo?: InputMaybe<Scalars['String']>;
  contactAddressZipCode?: InputMaybe<Scalars['String']>;
  contractVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  countyId?: InputMaybe<Scalars['Int']>;
  customerType?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  dealerCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailVerificationCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  funnel?: InputMaybe<Scalars['String']>;
  funnelVnmProjectId?: InputMaybe<Scalars['Int']>;
  hasOffers?: InputMaybe<HasOffersInput>;
  inviteCode?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  kwh?: InputMaybe<Scalars['Int']>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  metaData?: InputMaybe<Scalars['JSON']>;
  originationSourceType?: InputMaybe<OriginationSource>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  planTemplateId?: InputMaybe<Scalars['Int']>;
  queryParams?: InputMaybe<Scalars['JSON']>;
  referrableCode?: InputMaybe<Scalars['String']>;
  rewardCode?: InputMaybe<Scalars['String']>;
  signupContractTemplateId?: InputMaybe<Scalars['Int']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<EnrollingUserSource>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  utilityId?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
  zohoReferenceNumber?: InputMaybe<Scalars['Int']>;
};

export type EnrollingUserOutput = {
  errors?: Maybe<EnrollingUserError>;
  id: Scalars['Int'];
  token?: Maybe<Scalars['String']>;
  user?: Maybe<EnrolledUser>;
};

export enum EnrollingUserSource {
  Admin = 'admin',
}

export type EnrollmentOption = {
  id: Scalars['Int'];
  name: EnrollmentOptionName;
};

export enum EnrollmentOptionName {
  BillCapture = 'bill_capture',
  CustomerProvided = 'customer_provided',
  None = 'none',
  PartnerProvided = 'partner_provided',
  UtilityConnect = 'utility_connect',
}

export enum EnrollmentStatus {
  Active = 'active',
  Available = 'available',
  Canceled = 'canceled',
  Ineligible = 'ineligible',
  Pending = 'pending',
  Unavailable = 'unavailable',
}

export type ExceptIn = {
  exceptIn: RuleContext;
};

export type ExecutedContract = {
  contractAgreement: ContractAgreement;
  contractAgreementId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  current: Scalars['Boolean'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  vnmSolarProject: VnmSolarProject;
};

export type Export = {
  data?: Maybe<Scalars['String']>;
  exportErrors: Scalars['JSON'];
  s3Key?: Maybe<Scalars['String']>;
};

export type ExportColumn = {
  key: Scalars['String'];
  label: Scalars['String'];
};

export type ExportCompleted = {
  errors?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type ExportDetail = {
  adminUser?: Maybe<AdminUser>;
  createdAt: Scalars['Datetime'];
  endDate?: Maybe<Scalars['Datetime']>;
  exportErrors: Scalars['JSON'];
  file?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  persistedUntil?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
};

export type ExternalSystemDataInput = {
  systemName?: InputMaybe<Scalars['String']>;
};

export type FacetedUtilityAccountLmiSourceTypeResponse = {
  count: Scalars['Int'];
  records: Array<UtilityAccountLmiSourceType>;
  totalCount: Scalars['Int'];
};

export type FacetedVnmProductEligibilitiesResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<VnmProductEligibility>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FacetedVnmSubscriptionsResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<VnmSubscription>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum FilterAccountStatus {
  Active = 'active',
  Deleted = 'deleted',
  Dormant = 'dormant',
  Inactive = 'inactive',
  Incomplete = 'incomplete',
  Moving = 'moving',
}

export type FilterInput = {
  equals?: InputMaybe<Scalars['String']>;
  excludes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from?: InputMaybe<Scalars['String']>;
  includes?: InputMaybe<Scalars['JSON']>;
  notEquals?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type FilteredNotifications = {
  notifications?: Maybe<Array<Maybe<Notification>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FinalizedUtilityAccountAllocations = {
  allocation: Scalars['Float'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  sourceFile: Scalars['String'];
  vnmSolarProjectId: Scalars['Int'];
  vnmSubscriptionId: Scalars['Int'];
};

export type FloatUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type FormattedLineItem = {
  amountCents: Scalars['Int'];
  entryType: LineItemEntryType;
  id: Scalars['String'];
  key: LineItemKey;
  name: Scalars['String'];
  sandboxed: Scalars['Boolean'];
};

export type ForwardUtilityEmailsInput = {
  ids: Array<Scalars['Int']>;
};

export type ForwardUtilityEmailsOutput = {
  ids: Array<Scalars['Int']>;
};

export type FuelType = {
  equivalency: Scalars['Float'];
  units: Scalars['String'];
};

export type FuelTypeEquivalency = {
  biomass: FuelType;
  coal: FuelType;
  naturalGas: FuelType;
  nuclear: FuelType;
  oil: FuelType;
};

export enum FunnelBillExperience {
  ArcadiaBilled = 'arcadia_billed',
  DualBilled = 'dual_billed',
  UtilityBilled = 'utility_billed',
}

export type FunnelBillingExperienceConfiguration = {
  funnelBillingExperience: NewBillingExperienceType;
  id: Scalars['Int'];
};

export type FunnelBillingExperienceConfigurationInput = {
  billing?: InputMaybe<Scalars['String']>;
  funnel?: InputMaybe<FunnelName>;
  userId?: InputMaybe<Scalars['Int']>;
  utilityId: Scalars['Int'];
};

export type FunnelConfiguration = {
  error?: Maybe<Scalars['String']>;
  showLmiScreens?: Maybe<Scalars['Boolean']>;
  signUpContractTemplate?: Maybe<SignUpContractTemplate>;
};

export enum FunnelName {
  Business = 'business',
  CommunitySolar = 'communitySolar',
  GoSolar = 'goSolar',
  Isolar = 'isolar',
  IsolarUcb = 'isolarUcb',
  MnLmi = 'mnLmi',
  NonAbp = 'nonABP',
  OregonTier1 = 'oregonTier1',
  OregonTier1Lmi = 'oregonTier1Lmi',
  OregonTier2 = 'oregonTier2',
  OregonTier2Lmi = 'oregonTier2Lmi',
  PerchEnergy = 'perchEnergy',
  Waitlist = 'waitlist',
}

export type FunnelPacket = {
  customPlan: Plan;
  enrollingUserId?: Maybe<Scalars['Int']>;
  funnelConfiguration?: Maybe<FunnelConfiguration>;
  funnelEnrollmentExperience?: Maybe<Scalars['String']>;
  funnelVnmProjectId?: Maybe<Scalars['Int']>;
  inviteCode?: Maybe<Scalars['String']>;
  meter?: Maybe<Meter>;
  nonLmi?: Maybe<Scalars['Boolean']>;
  onboardingRateClasses: Array<OnboardingRateClass>;
  projectSnapshot?: Maybe<ProjectSnapshot>;
  signedContractIds: Array<Maybe<Scalars['Int']>>;
  signupContractTemplate?: Maybe<SignUpContractTemplate>;
  signupContractTemplateId?: Maybe<Scalars['Int']>;
  unparsedQueryParams?: Maybe<UnparsedQueryParams>;
  utilityAccount: UtilityAccount;
};

export type FunnelQueryParamValues = {
  accountNumber: Scalars['String'];
  annualizedUsageEstimate: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  inviteCode?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  meterNumber?: Maybe<Scalars['String']>;
  partnerSource: Scalars['String'];
  phone: Scalars['String'];
  preferredEnrollment: EnrollmentOptionName;
  secondaryAccountIdentifier?: Maybe<Scalars['String']>;
  serviceAddressCity: Scalars['String'];
  serviceAddressState: Scalars['String'];
  serviceAddressStreetOne: Scalars['String'];
  serviceAddressStreetTwo?: Maybe<Scalars['String']>;
  serviceAddressZip: Scalars['String'];
  utilityId: Scalars['Int'];
  zipCode: Scalars['String'];
};

export type FunnelQueryParams = {
  error?: Maybe<Scalars['String']>;
  params?: Maybe<FunnelQueryParamValues>;
};

export type FunnelSignupPath = {
  billingExperience: BillingExperienceOptionName;
  enrollment: EnrollmentOptionName;
};

export enum FunnelTrack {
  Membership = 'membership',
  Solar = 'solar',
  Waitlist = 'waitlist',
}

export type GenPropertyChoice = {
  dataValue: Scalars['String'];
  displayValue: Scalars['String'];
  likelihood?: Maybe<Scalars['Float']>;
};

export type GenerateHostReportStatementsInput = {
  autoIssue?: InputMaybe<Scalars['Boolean']>;
  hostReportItemIds: Array<Scalars['Int']>;
};

export type GenerateIlDisclosureFormOutput = {
  enqueued: Scalars['Boolean'];
  utilityAccountId: Scalars['Int'];
};

export type GenerateIlDisclosureFormsOutput = {
  enqueued: Scalars['Boolean'];
  planId: Scalars['Int'];
};

export type GeoAddress = {
  accuracy?: Maybe<Scalars['Float']>;
  blockCode?: Maybe<Scalars['String']>;
  blockGroup?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  county: Scalars['String'];
  countyFips?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  formattedAddress: Scalars['String'];
  fullFips?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isInLmiArea?: Maybe<Scalars['Boolean']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  municipality?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  stateFips?: Maybe<Scalars['String']>;
  targetId: Scalars['Int'];
  targetType: Scalars['String'];
  tractCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  zipCode: Scalars['String'];
};

export type GeoAddressAccuracy = {
  accuracy?: Maybe<Scalars['Float']>;
};

export type GetLsEsRequest = {
  country?: InputMaybe<Scalars['String']>;
  ownerships?: InputMaybe<Array<InputMaybe<Ownership>>>;
  postCode?: InputMaybe<Scalars['String']>;
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type GetTariffRequest = {
  applicableRatesOnly?: InputMaybe<Scalars['Boolean']>;
  bundleRates?: InputMaybe<Scalars['Boolean']>;
  effectiveOn?: InputMaybe<Scalars['String']>;
  lookupVariableRates?: InputMaybe<Scalars['Boolean']>;
  populateDocuments?: InputMaybe<Scalars['Boolean']>;
  populateProperties?: InputMaybe<Scalars['Boolean']>;
  populateRates?: InputMaybe<Scalars['Boolean']>;
  territoryId?: InputMaybe<Scalars['ID']>;
};

export type GetTariffsRequest = {
  addressString?: InputMaybe<Scalars['String']>;
  applicableRatesOnly?: InputMaybe<Scalars['Boolean']>;
  bundleRates?: InputMaybe<Scalars['Boolean']>;
  chargeTypes?: InputMaybe<Array<InputMaybe<ChargeType>>>;
  consumption?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<Scalars['String']>;
  customerClasses?: InputMaybe<Array<InputMaybe<CustomerClass>>>;
  demand?: InputMaybe<Scalars['Float']>;
  effectiveOn?: InputMaybe<Scalars['String']>;
  filterRiderRates?: InputMaybe<Scalars['Boolean']>;
  fromDateTime?: InputMaybe<Scalars['String']>;
  hasContractedRates?: InputMaybe<Scalars['Boolean']>;
  hasNetMetering?: InputMaybe<Scalars['Boolean']>;
  hasTieredRates?: InputMaybe<Scalars['Boolean']>;
  hasTimeOfUseRates?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lseId?: InputMaybe<Scalars['ID']>;
  masterTariffId?: InputMaybe<Scalars['ID']>;
  openOn?: InputMaybe<Scalars['String']>;
  populateDocuments?: InputMaybe<Scalars['Boolean']>;
  populateProperties?: InputMaybe<Scalars['Boolean']>;
  populateRates?: InputMaybe<Scalars['Boolean']>;
  postCode?: InputMaybe<Scalars['String']>;
  privacyFlags?: InputMaybe<Array<InputMaybe<PrivacyFlag>>>;
  riderId?: InputMaybe<Scalars['ID']>;
  serviceTypes?: InputMaybe<Array<InputMaybe<ServiceType>>>;
  tariffTypes?: InputMaybe<Array<InputMaybe<TariffType>>>;
  territoryId?: InputMaybe<Scalars['ID']>;
  toDateTime?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type GlobalVnmSolarProjectStatistics = {
  eligibilityCountsByStatus?: Maybe<VnmEligibilityCountsByStatus>;
  eligibleCustomers?: Maybe<Scalars['Int']>;
  liveProjects?: Maybe<Scalars['Int']>;
  needsReviewCustomers?: Maybe<Scalars['Int']>;
  subscriptionCountsByStatus?: Maybe<VnmSubscriptionCountsByStatus>;
  totalMegawattHours?: Maybe<Scalars['Float']>;
};

export type GroupedPlans = {
  mergeable: Scalars['Boolean'];
  plans: Array<Plan>;
};

export type HasOffersInput = {
  affiliateIdentifier?: InputMaybe<Scalars['String']>;
  offerIdentifier?: InputMaybe<Scalars['String']>;
  promoCode: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  subIdentifiers?: InputMaybe<Scalars['String']>;
  transactionIdentifier: Scalars['String'];
};

export type HistoricalScrapeRequestOutput = {
  uuid: Scalars['String'];
};

export type HistoryRecord = {
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  itemType: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<HistoryRecordOwner>;
  prevValue?: Maybe<Scalars['String']>;
  resource?: Maybe<HistoryRecordResource>;
  value?: Maybe<Scalars['String']>;
};

export type HistoryRecordOwner = AdminUser | User;

export type HistoryRecordResource = VnmProductEligibility | VnmSubscription;

export type HostReport = {
  billableHostReportItemCount: Scalars['Int'];
  billedHostReportItemCount: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  downloadUrl: Scalars['String'];
  dualBilledHostReportItemCount: Scalars['Int'];
  errors: Array<HostReportError>;
  filename: Scalars['String'];
  generatingStatements: Scalars['Boolean'];
  hostReportItemCount: Scalars['Int'];
  hostReportItemStatementCount: Scalars['Int'];
  id: Scalars['Int'];
  invoicedItems: Array<HostReportItem>;
  needsAttentionItems: Array<HostReportItem>;
  projects: Array<VnmSolarProject>;
  receiptDate?: Maybe<Scalars['Date']>;
  reportMonth?: Maybe<Scalars['String']>;
  solarProject: VnmSolarProject;
  status: Scalars['String'];
  unbillableHostReportItemCount: Scalars['Int'];
  uncollectibleItems: Array<HostReportItem>;
  uploader?: Maybe<AdminUser>;
  utility: Utility;
};

export type HostReportInvoicedItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type HostReportNeedsAttentionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type HostReportUncollectibleItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type HostReportError = {
  data?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
};

export type HostReportFilterOptions = {
  developerIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  reportMonths?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type HostReportItem = {
  accountId?: Maybe<Scalars['Int']>;
  accountIdentifier?: Maybe<Scalars['String']>;
  additionalDetails?: Maybe<Scalars['JSON']>;
  billed: Scalars['Boolean'];
  billedAt?: Maybe<Scalars['Datetime']>;
  collectible: Scalars['Boolean'];
  correctedById?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  creditCorrectionAdjustmentAmountCents: Scalars['Int'];
  creditCorrectionPreSavingsAdjustmentAmountCents: Scalars['Int'];
  creditCorrections: Array<Maybe<CreditCorrection>>;
  dateReadingFrom?: Maybe<Scalars['Date']>;
  dateReadingTo?: Maybe<Scalars['Date']>;
  firstFailedStatementGenerationCheck?: Maybe<Scalars['String']>;
  hostReportId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  kwh?: Maybe<Scalars['Float']>;
  latestStatement?: Maybe<Statement>;
  latestStatementId?: Maybe<Scalars['Int']>;
  meterNumber?: Maybe<Scalars['String']>;
  nonBillableReasons?: Maybe<Array<Scalars['String']>>;
  planBillingSettingsDetails?: Maybe<BillingSettings>;
  planId?: Maybe<Scalars['Int']>;
  productionEndDate?: Maybe<Scalars['Date']>;
  productionStartDate?: Maybe<Scalars['Date']>;
  sgLineItemId?: Maybe<Scalars['Int']>;
  subscriberName?: Maybe<Scalars['String']>;
  uncollectibleReasons?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Datetime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  utilityAccountNumber?: Maybe<Scalars['String']>;
  utilityStatementId?: Maybe<Scalars['Int']>;
  vnmBillCredits?: Maybe<Scalars['Float']>;
  vnmSolarProject: VnmSolarProject;
  vnmSolarProjectId: Scalars['Int'];
  vnmSubscription?: Maybe<VnmSubscription>;
  vnmTariffRate?: Maybe<Scalars['Float']>;
};

export type HostReportsSearchResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<HostReport>;
};

export type IgnoreEmailParsingResultInput = {
  id: Scalars['Int'];
};

export type Impact = {
  carbonEquivalency: CarbonEquivalency;
  fuelTypeEquivalency: FuelTypeEquivalency;
};

export type ImpactCarbonEquivalencyArgs = {
  endDate?: InputMaybe<StringRangeFilter>;
  startDate?: InputMaybe<StringRangeFilter>;
};

export type ImpactFuelTypeEquivalencyArgs = {
  endDate?: InputMaybe<StringRangeFilter>;
  startDate?: InputMaybe<StringRangeFilter>;
};

export type ImpactStats = {
  vnmKwhCumulative: Scalars['Int'];
  /** If we have VNM kWh or expect to in the future, this field is true. */
  vnmKwhExpected: Scalars['Boolean'];
  vnmKwhLastStatement: Scalars['Int'];
  vnmSavingsCumulativeCents: Scalars['Int'];
  /**
   * NOTE: ImpactStats on type user is being deprecated in favor of ImpactStats on type Account.
   *
   * If we have VNM savings or expect to in the future, this field is true.
   * For example, a waitlisted VNM subscription will cause this to be true.
   */
  vnmSavingsExpected: Scalars['Boolean'];
  vnmSavingsLastStatementCents: Scalars['Int'];
};

export type Incentive = {
  cost?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  sponsoredMembership: Scalars['Boolean'];
};

export type IndividualPromoBatch = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  promoType: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  value: Scalars['Float'];
};

export type IndividualPromoCode = {
  code: Scalars['String'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  individualPromoBatch: IndividualPromoBatch;
  individualPromoBatchId: Scalars['Int'];
  status: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export type IneligibilityReason = {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  product: Scalars['String'];
  productEligibilityId: Scalars['Int'];
  reason: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type IneligibilityReasonOptions = {
  billPayService?: Maybe<Array<Maybe<Scalars['String']>>>;
  bundle?: Maybe<Array<Maybe<Scalars['String']>>>;
  vnm?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IngestionFileDownloadUrls = {
  auditReportFileDownloadUrl?: Maybe<Scalars['String']>;
  ingestionFileDownloadUrl: Scalars['String'];
  validationReportFileDownloadUrl?: Maybe<Scalars['String']>;
};

export type InitiateEdiBackfillInput = {
  clearHistoricalStatements?: InputMaybe<Scalars['Boolean']>;
  data: Scalars['String'];
};

export type InitiatePerchFreezeBackfillInput = {
  data: Scalars['String'];
};

export type InitiatePerchIdentifiersBackfillInput = {
  data: Scalars['String'];
};

export type InstantAlertInput = {
  event: Scalars['String'];
  properties?: InputMaybe<Scalars['JSON']>;
  utilityAccountId: Scalars['Int'];
};

export type InstantAlertOutput = {
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type IntRangeFilter = {
  gteq?: InputMaybe<Scalars['Int']>;
  lteq?: InputMaybe<Scalars['Int']>;
};

export type IntUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type IntervalUsage = {
  createdAt: Scalars['Datetime'];
  endsAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  numRecords?: Maybe<Scalars['Int']>;
  startsAt?: Maybe<Scalars['Datetime']>;
};

export type IntervalUsagePageType = {
  data: Array<IntervalUsage>;
  totalCount: Scalars['Int'];
};

export enum InvoicingType {
  NeedsAttention = 'needs_attention',
  Offline = 'offline',
  Online = 'online',
}

export enum ItemType {
  City = 'CITY',
  County = 'COUNTY',
  State = 'STATE',
  Zipcode = 'ZIPCODE',
}

export type Kwh = {
  total?: Maybe<Scalars['Int']>;
};

export type KwhStatistics = {
  clean?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Int']>;
};

export type LmiProofDocUpload = {
  documentType: Scalars['String'];
  id: Scalars['Int'];
  image: LmiProofDocUploadImage;
  type?: Maybe<Scalars['String']>;
};

export enum LmiProofDocUploadDocumentType {
  AccountStatement = 'account_statement',
  Card = 'card',
  Letter = 'letter',
  Other = 'other',
  Unknown = 'unknown',
  UtilityBill = 'utility_bill',
}

export type LmiProofDocUploadImage = {
  url: Scalars['String'];
};

export type LmiProofDocUploadInput = {
  documentType: Scalars['String'];
  image: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  proofType?: InputMaybe<LmiProofDocUploadDocumentType>;
  relationship?: InputMaybe<LmiProofDocUploadRelationship>;
  source?: InputMaybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
};

export enum LmiProofDocUploadRelationship {
  Other = 'other',
  Self = 'self',
}

export type LmiSourceType = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  requiresValidation: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
};

export type LseSearchResults = {
  count?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<LoadServingEntity>>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum Level {
  CityLevelRepresentatives = 'cityLevelRepresentatives',
  StateLevelRepresentatives = 'stateLevelRepresentatives',
}

export type LineItem = {
  amountCents: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  entryType: Scalars['String'];
  id: Scalars['String'];
  key: LineItemKey;
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  remittanceAmountCents: Scalars['Int'];
  utilityRemittanceId?: Maybe<Scalars['Int']>;
  vnmSavingsCents?: Maybe<Scalars['Int']>;
  void: Scalars['Boolean'];
};

export type LineItemElements = {
  creditItems: Array<CreditItemElements>;
  lineItems: Array<DebitItemElements>;
};

export enum LineItemEntryType {
  Credit = 'credit',
  Debit = 'debit',
}

export type LineItemInput = {
  amountCents: Scalars['Int'];
  lineItemTypeKey?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  partnerAccountId?: InputMaybe<Scalars['String']>;
  remittanceAmountCents?: InputMaybe<Scalars['Int']>;
};

export enum LineItemKey {
  ArcCharge = 'arc_charge',
  ArcChargeWithUtilityRemittance = 'arc_charge_with_utility_remittance',
  ArcCredit = 'arc_credit',
  ArcTax = 'arc_tax',
  BrokerageAdjustmentCredit = 'brokerage_adjustment_credit',
  CommunitySolarPanelPurchase = 'community_solar_panel_purchase',
  ConsolidatedWindEnergyCharge = 'consolidated_wind_energy_charge',
  CreditAdjustment = 'credit_adjustment',
  CustomBonus = 'custom_bonus',
  CustomCredit = 'custom_credit',
  DebitAdjustment = 'debit_adjustment',
  DormantBonus = 'dormant_bonus',
  DormantCredit = 'dormant_credit',
  EarlyTerminationFeeCredit = 'early_termination_fee_credit',
  EvergreenWindEnergyCharge = 'evergreen_wind_energy_charge',
  FeeAdjustmentCredit = 'fee_adjustment_credit',
  FlatBillCharge = 'flat_bill_charge',
  FlatBillRebate = 'flat_bill_rebate',
  FootprintDonation = 'footprint_donation',
  FreeMembership = 'free_membership',
  FreeMonthCredit = 'free_month_credit',
  GoodEnergyCredit = 'good_energy_credit',
  GoodEnergyDonation = 'good_energy_donation',
  January_2020Debit = 'january_2020_debit',
  LatePaymentAdjustmentCredit = 'late_payment_adjustment_credit',
  LocalUtilityCharge = 'local_utility_charge',
  MemberSatisfactionCredit = 'member_satisfaction_credit',
  MigrationBalanceCredit = 'migration_balance_credit',
  MindfulMembership = 'mindful_membership',
  MindfulMembershipCredit = 'mindful_membership_credit',
  MissingPromotionCredit = 'missing_promotion_credit',
  NationalSolar = 'national_solar',
  OnBillFinanceCharge = 'on_bill_finance_charge',
  OverchargeCorrection = 'overcharge_correction',
  OverdraftAdjustmentCredit = 'overdraft_adjustment_credit',
  PaidPlanUpgradeBonus = 'paid_plan_upgrade_bonus',
  PartialRefundAdjustmentCredit = 'partial_refund_adjustment_credit',
  PortablePanelCredit = 'portable_panel_credit',
  ProcessingFee = 'processing_fee',
  RefereeWindUpgradeCredit = 'referee_wind_upgrade_credit',
  ReferralBonus = 'referral_bonus',
  ReferralCredit = 'referral_credit',
  ReferralPaidUpgradeBonus = 'referral_paid_upgrade_bonus',
  ReferrerWindUpgradeCredit = 'referrer_wind_upgrade_credit',
  SignupBonus = 'signup_bonus',
  SignupCredit = 'signup_credit',
  SolarSavings = 'solar_savings',
  SponsoredMembershipCredit = 'sponsored_membership_credit',
  StatementBonus = 'statement_bonus',
  StatementCredit = 'statement_credit',
  UnderchargeCorrection = 'undercharge_correction',
  Unknown = 'unknown',
  VnmPastDueCredit = 'vnm_past_due_credit',
  VnmPreProjectCredit = 'vnm_pre_project_credit',
  VnmRetentionBonus = 'vnm_retention_bonus',
  VnmRetentionCredit = 'vnm_retention_credit',
  VnmSolarCharge = 'vnm_solar_charge',
}

/**
 * A summary of the line item data, broken down into categories.
 * All of this data is calculated from the line items, not from other data,
 * such as the statement itself or any associated utility statements.
 */
export type LineItemSummary = {
  /**
   * The solar savings rate % from the solar line items. If there are no solar line items with a savings rate
   * or there are multiple solar line items with different savings rates, this value will be null.
   */
  headlineSolarSavingsRate?: Maybe<Scalars['Int']>;
  /** Amount charged by Arcadia, due to dual billing VNM subscription(s), on this statement. */
  totalDualBillingChargeCents: Scalars['Int'];
  /** Amount the member should see as bill credits, due to dual billing VNM subscription(s), on this statement. */
  totalDualBillingUtilityCreditCents: Scalars['Int'];
  /** Amount the member should pay, due to non-solar utility charges, on this statement. */
  totalOtherUtilityChargeCents: Scalars['Int'];
  /** % of the "without Arcadia" total that is due to other utility charges. */
  totalOtherUtilityChargePercent: Scalars['Int'];
  /**
   * Amount the member should pay, due to their VNM subscription(s), on this statement.
   * This includes both utility-remitted and Arcadia-remitted solar charges.
   */
  totalSolarChargeCents: Scalars['Int'];
  /** % of the "without Arcadia" total that is due to solar charge. */
  totalSolarChargePercent: Scalars['Int'];
  /** Amount the member saved, due to their VNM subscription(s), on this statement. */
  totalSolarSavingsCents: Scalars['Int'];
  /** % of the "without Arcadia" total that is due to solar savings. */
  totalSolarSavingsPercent: Scalars['Int'];
  /**
   * Amount the member would pay, "without Arcadia", for all utility statements / host reports on this statement.
   * Calculated as (totalSolarSavingsCents + totalSolarChargeCents + totalOtherUtilityChargeCents)
   * Ignores "extra" line items such as membership fees, discounts, etc.
   */
  totalWithoutArcadia: Scalars['Int'];
};

/**
 * A check whether this is a valid link - generally used for emails.
 * This check needs to be server-side due to CORS.
 */
export type LinkCheck = {
  originalUrl: Scalars['String'];
  responseOk: Scalars['Boolean'];
  responseStatusCode?: Maybe<Scalars['Int']>;
  validUrl: Scalars['Boolean'];
};

export type LmiProofDocLabelOptionsResponse = {
  data?: Maybe<Scalars['JSON']>;
};

export type LmiProofDocs = {
  proofDocName?: Maybe<Scalars['String']>;
  proofDocStatus?: Maybe<Scalars['String']>;
  proofDocTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  proofDocUploadedAt?: Maybe<Scalars['String']>;
  proofDocUrls: Array<Maybe<Scalars['String']>>;
  reasonMessage?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  uaLmiSourceTypeId?: Maybe<Scalars['Int']>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  utilityAccountNumber?: Maybe<Scalars['String']>;
  utilityName?: Maybe<Scalars['String']>;
  utilityServiceAddress?: Maybe<Scalars['String']>;
};

export type LmiZoneArea = {
  dacZone?: Maybe<Scalars['Boolean']>;
  empowerZone?: Maybe<Scalars['Boolean']>;
};

export type LmiZoneLookup = {
  error: Scalars['Boolean'];
  isAddressPresent: Scalars['Boolean'];
  isInCensusTract: Scalars['Boolean'];
  isInLmiArea: Scalars['Boolean'];
  lmiZoneArea: LmiZoneArea;
};

export type LmiZoneOptions = {
  error: Scalars['Boolean'];
  isInCensusTract: Scalars['Boolean'];
  isInLmiArea: Scalars['Boolean'];
};

export type LoadServingEntity = {
  billingPeriodRepresentation?: Maybe<Array<Maybe<BillingPeriodRepresentation>>>;
  code: Scalars['String'];
  commercialCustomers?: Maybe<Scalars['Int']>;
  commercialRevenues?: Maybe<Scalars['Float']>;
  commercialSales?: Maybe<Scalars['Float']>;
  commercialServiceTypes?: Maybe<Scalars['String']>;
  industrialCustomers?: Maybe<Scalars['Int']>;
  industrialRevenues?: Maybe<Scalars['Float']>;
  industrialSales?: Maybe<Scalars['Float']>;
  industrialServiceTypes?: Maybe<Scalars['String']>;
  lseId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  offeringType?: Maybe<OfferingType>;
  ownership?: Maybe<Ownership>;
  residentialCustomers?: Maybe<Scalars['Int']>;
  residentialRevenues?: Maybe<Scalars['Float']>;
  residentialSales?: Maybe<Scalars['Float']>;
  residentialServiceTypes?: Maybe<Scalars['String']>;
  serviceTypes?: Maybe<Array<Maybe<ServiceType>>>;
  totalCustomers?: Maybe<Scalars['Int']>;
  totalRevenues?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
  transportationCustomers?: Maybe<Scalars['Int']>;
  transportationRevenues?: Maybe<Scalars['Float']>;
  transportationSales?: Maybe<Scalars['Float']>;
  transportationServiceTypes?: Maybe<Scalars['String']>;
  websiteHome: Scalars['String'];
};

export type LoadZone = {
  code?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isVNMEligible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  state: State;
  utility: Utility;
};

export type MappedTariff = {
  rateCriteria?: Maybe<Array<NormalizationPropertyKey>>;
  tariffCode: Scalars['String'];
  tariffId: Scalars['ID'];
  tariffName: Scalars['String'];
  utilityId: Scalars['ID'];
  utilityLabel: Scalars['String'];
  utilityName: Scalars['String'];
};

export type MappedUtility = {
  numMappings: Scalars['Int'];
  utilityId: Scalars['ID'];
  utilityLabel: Scalars['String'];
  utilityName: Scalars['String'];
};

export type MappingRequestCount = {
  dateLastRequested: Scalars['String'];
  numRequests: Scalars['Int'];
};

export type MarkHostReportItemsAsBilledInput = {
  ids: Array<Scalars['String']>;
};

export enum MembershipStatus {
  Active = 'active',
  Pending = 'pending',
}

export type Message = {
  body: Scalars['String'];
  dateSent: Scalars['String'];
  status: Scalars['String'];
};

export type Meter = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  meterNumber: Scalars['String'];
  mostRecentUsage?: Maybe<Usage>;
  serviceType: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  utility: Utility;
  utilityAccount: UtilityAccount;
  utilityAccountId: Scalars['Int'];
  utilityId: Scalars['Int'];
};

export type MonthlyUsageInput = {
  month: Scalars['Int'];
  usageValue: Scalars['Int'];
  year: Scalars['Int'];
};

export type MoveRequest = {
  id: Scalars['Int'];
  isPending?: Maybe<Scalars['Boolean']>;
  mailingAddress?: Maybe<MoveRequestAddress>;
  newPlanNickname?: Maybe<Scalars['String']>;
  newUtilityAccount?: Maybe<UtilityAccount>;
  newUtilityAccountId?: Maybe<Scalars['Int']>;
  oldUtilityAccount?: Maybe<UtilityAccount>;
  oldUtilityAccountId?: Maybe<Scalars['Int']>;
  serviceAddress?: Maybe<MoveRequestAddress>;
  serviceEndDate?: Maybe<Scalars['Date']>;
  serviceStartDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  utility: Utility;
  utilityAccountNumber?: Maybe<Scalars['String']>;
  utilityId: Scalars['Int'];
};

export type MoveRequestAddress = {
  city?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MultiUtilityAccountEnrollmentInput = {
  utilityAccounts: Array<UtilityAccountInput>;
};

export type Mutation = {
  _empty?: Maybe<Scalars['String']>;
  acceptBillUpload: BillUpload;
  addAccountEmail: Account;
  applyDormantPromoCode: User;
  assignTasks?: Maybe<MutationOutput>;
  assignWinbackAccountLeads?: Maybe<MutationOutput>;
  attachBillingQueueItem?: Maybe<MutationOutput>;
  attachEmailParsingResult?: Maybe<MutationOutput>;
  bulkAddBillPay?: Maybe<Scalars['Boolean']>;
  bulkRemoveBillPay?: Maybe<Scalars['Boolean']>;
  bulkScrapeLatestBilling: Array<BulkScraperRequestOutput>;
  calculateTariffCosts: CalculateTariffCostsOutput;
  clearDisputes: Plan;
  closeAccount: Account;
  closeAccountsAndPlans: CloseAccountsAndPlansOutput;
  closeWinbackCampaigns?: Maybe<MutationOutput>;
  createAccountClosureRequest: CreateAccountClosureRequestOutput;
  createAdminReview: CommunitySolarAdminReviewResponse;
  createAdvocacyCampaignSubmission: AdvocacyCampaignSubmission;
  createBillPayServiceProductEligibility: MutationOutput;
  createBillPayServiceProductSubscription?: Maybe<MutationOutput>;
  createBulkProcessingRequest: CreateBulkProcessingRequestOutput;
  createCommunitySolarUtilityAccountExport: CreateCommunitySolarUtilityAccountExportOutput;
  createCommunitySolarUtilityAccountUpdate: CommunitySolarUtilityAccountUpdate;
  createContract: Contract;
  createContractAgreementExport: CreateContractAgreementExportOutput;
  createContractAgreementZippedFiles: CreateContractAgreementZippedFilesOutput;
  createContractAgreements: Array<CreateContractAgreementOutput>;
  createContractAgreementsPerch: CreateContractAgreementOutput;
  createContractFileIngestionRequest: ContractFileIngestionRequest;
  createContractLink: ContractLink;
  createContractVersion: ContractVersion;
  createContractVersionPersonalizationRequest: CreateContractVersionPersonalizationRequestOutput;
  createCredit: MutationOutput;
  createCreditCorrection: CreditCorrection;
  createCsCreditCalculation?: Maybe<CsCreditCalculation>;
  createEmailVerificationAttempt: CreateEmailVerificationAttemptResponse;
  createEnrollingUser: EnrollingUserOutput;
  createExecutedContractExport: CreateExecutedContractExportOutput;
  createFinalizedUtilityAccountAllocations?: Maybe<Scalars['String']>;
  createFunnelPacket: FunnelPacket;
  createHostReport: CreateHostReportOutput;
  createLMIProofDocUploadExport: CreateLmiProofDocUploadExportOutput;
  createLMIProofDocZippedFiles: CreateLmiProofDocZippedFilesOutput;
  createManualExtraction?: Maybe<CreateManualExtractionOutput>;
  createMeter: Meter;
  createMoveRequest: MutationOutput;
  createNote: MutationOutput;
  createOptOutPeriod: MutationOutput;
  createPartnerSubscriberIngestionRequest: CreatePartnerSubscriberIngestionRequestOutput;
  createPerchContractAgreements: Array<CreateContractAgreementOutput>;
  createPersonalizedContractPreview: PersonalizedContractPreviewOutput;
  createPlan: Plan;
  createPlanWithUtilityAccount: CreatePlanWithUtilityAccountOutput;
  createProductLead: MutationOutput;
  /** Create a prospect user. zipCode is the actual zip code string (e.g. "12345"), not an id. */
  createProspectUser: ProspectUser;
  createRefundTransaction: MutationOutput;
  createSession: Session;
  createSetupIntent: CreateSetupIntentOutput;
  /** Create and send a SignNow envelope for a personalized contract. */
  createSignNowEnvelope: SignNowEnvelope;
  createStatement?: Maybe<MutationOutput>;
  createSupplierStatementDetail: SupplierStatementDetail;
  createTariffNormalization: TariffNormalization;
  createTemporaryPaymentHold: CreateTemporaryPaymentHoldOutput;
  createUaLmiSourceTypeWithContracts: UtilityAccountLmiSourceType;
  createUpdateRefund?: Maybe<MutationOutput>;
  createUserEmail: CreateUserEmailOutput;
  createUserTip: UserTipOutput;
  createUtilityAccountBillExtraction: UtilityAccountBillExtractionOutput;
  createUtilityCredentialSession: CreateUtilityCredentialSessionOutput;
  createUtilityStatement?: Maybe<CreateUtilityStatementMutationOutput>;
  createVNMProductEligibilitiesExport: CreateVnmProductEligibilitiesExportOutput;
  createVnmAttritions: CreateAttritionOutput;
  createVnmCampaignBatch: CreateVnmCampaignBatchOutput;
  createVnmDeveloper: MutationOutput;
  createVnmSolarProjectExport: CreateVnmSolarProjectExportOutput;
  createVnmSubscriptions: MutationOutput;
  createVnmUtilitySubmission: CreateVnmUtilitySubmissionOutput;
  createVnmUtilitySubmissionExport: CreateVnmUtilitySubmissionExportOutput;
  createWinbackCallAttempt?: Maybe<MutationOutput>;
  createWinbackCampaign: WinbackCampaign;
  createZippedFiles: CreateZippedFilesOutput;
  /** Request a Zuora link token for the hosted payment page (ACH or card). */
  createZuoraLinkToken: ZuoraLinkToken;
  deactivateBillPayServiceProductSubscription?: Maybe<MutationOutput>;
  deactivateProductSubscription?: Maybe<MutationOutput>;
  delayStatementPayment: MutationOutput;
  deleteAccountEmail: Account;
  deleteBillUpload: BillUpload;
  deleteContractLink?: Maybe<MutationOutput>;
  deleteCreditCorrection?: Maybe<MutationOutput>;
  deleteHostReport: DeleteHostReportOutput;
  deleteLMIProofDocUpload: LmiProofDocUpload;
  deleteMeter: Scalars['Boolean'];
  deleteMoveRequest: MutationOutput;
  deleteNote: MutationOutput;
  deletePaymentMethod: MutationOutput;
  deleteSession: Session;
  deleteTariffNormalization?: Maybe<NormalizationDeleteSuccess>;
  deleteUtilityStatement?: Maybe<MutationOutput>;
  deleteVnmSubscriptions: MutationOutput;
  docusignInstantAlert: DocuSignInstantAlertOutput;
  editContractMetadata: Array<ContractMetadata>;
  emailDeviceShippingInformation?: Maybe<SendEmailResponse>;
  emailStatement?: Maybe<MutationOutput>;
  emitPaymentFailed?: Maybe<MutationOutput>;
  emitPaymentSuccess?: Maybe<MutationOutput>;
  emitStatementIssued?: Maybe<MutationOutput>;
  endSession: EndSessionResponse;
  /** Fetch current status from SignNow API and sync to DB; returns updated document group. */
  fetchSignNowDocumentGroupStatus: SignNowDocumentGroup;
  /** Fetch current status from SignNow API and sync to DB; returns updated envelope. */
  fetchSignNowEnvelopeStatus: SignNowEnvelope;
  forwardUtilityEmails: ForwardUtilityEmailsOutput;
  /**
   * Creates a new envelope for the given user/utilityAccount if
   * there isn't already one signed or available to be signed. Sends
   * back the utilityAccountId as there isn't any immediate response
   * from the backend.
   */
  generateDocuSignEnvelope: Scalars['Int'];
  generateHostReportItemStatements: MutationOutput;
  generateHostReportStatements: MutationOutput;
  generateHostReportStatementsV2: MutationOutput;
  /**
   * Enqueue job to generate IL disclosure form for a utility account.
   * Optional redirectUri is used for iframe redirects (success, decline, close).
   */
  generateIlDisclosureForm: GenerateIlDisclosureFormOutput;
  /**
   * Enqueue job to generate IL disclosure forms for all utility accounts on a plan.
   * Optional redirectUri is used for iframe redirects (success, decline, close).
   */
  generateIlDisclosureForms: GenerateIlDisclosureFormsOutput;
  ignoreEmailParsingResult?: Maybe<MutationOutput>;
  initiateEdiBackfill?: Maybe<Scalars['String']>;
  initiatePerchFreezeBackfill?: Maybe<Scalars['String']>;
  initiatePerchIdentifiersBackfill?: Maybe<Scalars['String']>;
  markHostReportItemsAsBilled: MutationOutput;
  mergePlans: Array<Plan>;
  multiUtilityAccountEnrollment?: Maybe<MutationOutput>;
  reactivatePlan: ReactivatePlan;
  recordPayment?: Maybe<MutationOutput>;
  /**
   * Regenerate a SignNow document group from existing envelopes.
   * Finds or creates a document group and generates a fresh signing link.
   * Used for regenerating expired/declined document groups.
   */
  regenerateSignNowDocumentGroup: SignNowDocumentGroup;
  reissueEcheck: MutationOutput;
  rejectBillUpload: BillUpload;
  removeDormantPromoCode: RemovePromoCodeOutput;
  removePromoCode: RemovePromoCodeOutput;
  replaceLmiSourceType: UtilityAccountLmiSourceType;
  replaceStagingPaymentMethods?: Maybe<MutationOutput>;
  /** Resend the email for a given envelope */
  resendDocuSignEmail: ResendDocuSignEmailOutput;
  resetPartnerSubscriberIngestionRequest: PartnerSubscriberIngestionRequest;
  resolveTasks?: Maybe<MutationOutput>;
  resolveWinbackAccountLead?: Maybe<MutationOutput>;
  scrapeAccountDetails: ScraperRequestOutput;
  scrapeAccountDetailsV2: ScraperRequestOutput;
  scrapeHistoricalStatements: HistoricalScrapeRequestOutput;
  scrapeHistoricalStatementsV2: ScraperRequestOutput;
  scrapeLatestBilling: ScraperRequestOutput;
  scrapeLatestBillingV2: ScraperRequestOutput;
  sendAdvocacyEmails?: Maybe<Array<Maybe<SendEmailResponse>>>;
  sendAuthEmail?: Maybe<SendEmailResponse>;
  /** Sends an event that will trigger an email. */
  sendEmailEvents: EmailEventResults;
  /**
   * Given the CSV outputted after a bulk upload in the IPA portal,
   * creates and sends an Envelope for each IPA form
   * in the CSV. The IPA forms must be findable in S3.
   * See IPA::SendEnvelopesFromPortalReport in EP
   */
  sendEnvelopesFromPortalReport: SendEnvelopesFromPortalReportOutput;
  sendInstantAlert: InstantAlertOutput;
  sendSponsorshipInvitation: SponsorshipAvailability;
  sendVnmCampaignContracts?: Maybe<Scalars['Boolean']>;
  setBillingAddress: SetBillingAddressPayload;
  setPaymentMethod: Plan;
  setPaymentMethodOnPlans?: Maybe<SetPaymentMethodOnPlansOutput>;
  signUpUser: Plan;
  snoozeTasks?: Maybe<MutationOutput>;
  statementAction?: Maybe<MutationOutput>;
  syncLmiSourceTypes: SyncLmiSourceTypesOutput;
  syncVnmSolarProject?: Maybe<MutationOutput>;
  toggleSkipRemittance?: Maybe<MutationOutput>;
  triggerVnmUtilitySubmissionScraper?: Maybe<MutationOutput>;
  unassignTasks?: Maybe<MutationOutput>;
  unassignWinbackAccountLeads?: Maybe<MutationOutput>;
  unsnoozeTasks?: Maybe<MutationOutput>;
  updateAccount: Account;
  updateAccountClosureRequest?: Maybe<MutationOutput>;
  updateAccountKwh?: Maybe<MutationOutput>;
  updateAnnualizedUsageEstimate: MutationOutput;
  updateBillPayServiceProductEligibility: MutationOutput;
  updateBillPayServiceProductSubscription?: Maybe<MutationOutput>;
  updateBulkProcessingRequest?: Maybe<MutationOutput>;
  updateContract: Contract;
  updateContractVersionPersonalizationRequest: MutationOutput;
  updateCredit: MutationOutput;
  updateCustomerSnapshot: UpdateCustomerSnapshotResponse;
  updateDocuSignClickwrap: DocuSignClickwrap;
  /** Updates the status of a given envelope for a user */
  updateDocuSignEnvelopeStatus: DocuSignEnvelope;
  updateEnrollingUser: EnrollingUserOutput;
  updateMeter: Meter;
  updateMoveRequest: MutationOutput;
  updateNote: MutationOutput;
  updateNotification: Notification;
  /** applies the same update to all notifications whose ids are passed (i.e. marks all as "read") */
  updateNotifications: Array<Notification>;
  updatePlan: Plan;
  updateProductLead: MutationOutput;
  updateRule: UpdateRuleResponse;
  updateSession: Session;
  /** Update a SignNow envelope (e.g. status). */
  updateSignNowEnvelope: SignNowEnvelope;
  updateSignupFunnelLead: SignupFunnelLead;
  updateStatement?: Maybe<MutationOutput>;
  updateSupplierStatementDetail: SupplierStatementDetail;
  updateUser: User;
  updateUserPreferences: MutationOutput;
  updateUserTip: UserTipOutput;
  /** userId should be deprecated after Osprey is updated to not send it */
  updateUtilityAccount: MutationOutput;
  updateUtilityAccountDetails: UtilityAccountDetailOutput;
  updateUtilityAccountLmiSourceType: UtilityAccountLmiSourceType;
  updateUtilityCredential: UtilityCredential;
  updateUtilityEmails: UpdateUtilityEmailsOutput;
  updateUtilityStatement: UtilityStatement;
  updateVNMProductEligibilities: Array<UpdateVnmProductEligibilityOutput>;
  updateVnmSolarProject: MutationOutput;
  updateVnmSubscriptions: MutationOutput;
  updateWinbackUtilityAccountLeadStatus?: Maybe<MutationOutput>;
  uploadBillImage: BillUpload;
  uploadFile: UploadFileOutput;
  /**
   * Upload individual IPA forms to S3 to make them
   * available to a bulk Envelope send.
   */
  uploadIpaForm?: Maybe<UploadIpaFormOutput>;
  uploadLMIProofDoc: LmiProofDocUpload;
  uploadThinkFile?: Maybe<MutationOutput>;
  voidCredit: MutationOutput;
};

export type MutationAcceptBillUploadArgs = {
  id: Scalars['Int'];
};

export type MutationAddAccountEmailArgs = {
  id: Scalars['Int'];
  input: AddAccountEmailInput;
};

export type MutationApplyDormantPromoCodeArgs = {
  input: ApplyPromoCodeInput;
};

export type MutationAssignTasksArgs = {
  input?: InputMaybe<AssignTasksInput>;
};

export type MutationAssignWinbackAccountLeadsArgs = {
  input?: InputMaybe<AssignWinbackAccountLeadsInput>;
};

export type MutationAttachBillingQueueItemArgs = {
  input: AttachBillingQueueItemInput;
};

export type MutationAttachEmailParsingResultArgs = {
  input: AttachEmailParsingResultInput;
};

export type MutationBulkAddBillPayArgs = {
  input: BulkAddBillPayInput;
};

export type MutationBulkRemoveBillPayArgs = {
  input: BulkRemoveBillPayInput;
};

export type MutationBulkScrapeLatestBillingArgs = {
  input: UtilityAccountIdsInput;
};

export type MutationCalculateTariffCostsArgs = {
  input: CalculateTariffCostsInput;
};

export type MutationClearDisputesArgs = {
  input: ClearDisputesInput;
};

export type MutationCloseAccountArgs = {
  id: Scalars['Int'];
  input: CloseAccountInput;
};

export type MutationCloseAccountsAndPlansArgs = {
  input: CloseAccountsAndPlansInput;
};

export type MutationCloseWinbackCampaignsArgs = {
  input: CloseWinbackCampaignsInput;
};

export type MutationCreateAccountClosureRequestArgs = {
  input: CreateAccountClosureRequestInput;
};

export type MutationCreateAdminReviewArgs = {
  reviewOutcome: AdminReviewOutcome;
  utilityAccountId: Scalars['Int'];
};

export type MutationCreateAdvocacyCampaignSubmissionArgs = {
  input: CreateAdvocacyCampaignSubmissionInput;
};

export type MutationCreateBillPayServiceProductEligibilityArgs = {
  input?: InputMaybe<CreateBillPayServiceProductEligibilityInput>;
};

export type MutationCreateBillPayServiceProductSubscriptionArgs = {
  input: CreateBillPayServiceProductSubscriptionInput;
};

export type MutationCreateBulkProcessingRequestArgs = {
  input: CreateBulkProcessingRequestInput;
};

export type MutationCreateCommunitySolarUtilityAccountExportArgs = {
  input: CreateCommunitySolarUtilityAccountExportInput;
};

export type MutationCreateCommunitySolarUtilityAccountUpdateArgs = {
  input: CreateCommunitySolarUtilityAccountUpdateInput;
  utilityAccountId: Scalars['Int'];
};

export type MutationCreateContractArgs = {
  input: CreateContractInput;
};

export type MutationCreateContractAgreementExportArgs = {
  input: CreateContractAgreementExportInput;
};

export type MutationCreateContractAgreementZippedFilesArgs = {
  input: CreateContractAgreementZippedFilesInput;
};

export type MutationCreateContractAgreementsArgs = {
  input: Array<CreateContractAgreementInput>;
};

export type MutationCreateContractAgreementsPerchArgs = {
  input: CreateContractAgreementsPerchInput;
};

export type MutationCreateContractFileIngestionRequestArgs = {
  input: CreateContractFileIngestionRequestInput;
};

export type MutationCreateContractLinkArgs = {
  input: CreateContractLinkInput;
};

export type MutationCreateContractVersionArgs = {
  contractId: Scalars['Int'];
  input: CreateContractVersionInput;
};

export type MutationCreateContractVersionPersonalizationRequestArgs = {
  input: CreateContractVersionPersonalizationRequestInput;
};

export type MutationCreateCreditArgs = {
  input: CreateCreditInput;
};

export type MutationCreateCreditCorrectionArgs = {
  input: CreateCreditCorrectionInput;
};

export type MutationCreateCsCreditCalculationArgs = {
  input: CreateCsCreditCalculationInput;
};

export type MutationCreateEmailVerificationAttemptArgs = {
  input: EmailVerificationAttemptInput;
};

export type MutationCreateEnrollingUserArgs = {
  input: EnrollingUserInput;
};

export type MutationCreateExecutedContractExportArgs = {
  input: CreateExecutedContractExportInput;
};

export type MutationCreateFinalizedUtilityAccountAllocationsArgs = {
  input: CreateFinalizedUtilityAccountAllocationsInput;
};

export type MutationCreateFunnelPacketArgs = {
  input: CreateFunnelPacketInput;
};

export type MutationCreateHostReportArgs = {
  input: CreateHostReportInput;
};

export type MutationCreateLmiProofDocUploadExportArgs = {
  input: CreateLmiProofDocUploadExportInput;
};

export type MutationCreateLmiProofDocZippedFilesArgs = {
  input: CreateLmiProofDocZippedFilesInput;
};

export type MutationCreateManualExtractionArgs = {
  input: CreateManualExtractionInput;
};

export type MutationCreateMeterArgs = {
  input: CreateMeterInput;
};

export type MutationCreateMoveRequestArgs = {
  input: CreateMoveRequestInput;
};

export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};

export type MutationCreateOptOutPeriodArgs = {
  input: CreateOptOutPeriodInput;
};

export type MutationCreatePartnerSubscriberIngestionRequestArgs = {
  input: CreatePartnerSubscriberIngestionRequestInput;
};

export type MutationCreatePerchContractAgreementsArgs = {
  input: Array<CreatePerchContractAgreementInput>;
};

export type MutationCreatePersonalizedContractPreviewArgs = {
  input: CreatePersonalizedContractPreviewInput;
};

export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};

export type MutationCreatePlanWithUtilityAccountArgs = {
  input: CreatePlanWithUtilityAccountInput;
};

export type MutationCreateProductLeadArgs = {
  input: CreateProductLeadInput;
};

export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput;
};

export type MutationCreateRefundTransactionArgs = {
  input: CreateRefundTransactionInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};

export type MutationCreateSetupIntentArgs = {
  accountId: Scalars['Int'];
  achMicrodepositVerification?: InputMaybe<Scalars['Boolean']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateSignNowEnvelopeArgs = {
  input: CreateSignNowEnvelopeInput;
};

export type MutationCreateStatementArgs = {
  input?: InputMaybe<CreateStatementInput>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateSupplierStatementDetailArgs = {
  input: CreateSupplierStatementDetailInput;
};

export type MutationCreateTariffNormalizationArgs = {
  loadServiceAreaZips?: InputMaybe<Scalars['Boolean']>;
  mappedPropertyInputs?: InputMaybe<Array<NormalizationPropertyKeyInput>>;
  mappedTariffId: Scalars['ID'];
  sourceTariffName: Scalars['String'];
  sourceUtilityId: Scalars['ID'];
};

export type MutationCreateTemporaryPaymentHoldArgs = {
  input: CreateTemporaryPaymentHoldInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateUaLmiSourceTypeWithContractsArgs = {
  input: CreateUaLmiSourceTypeWithContractInput;
  utilityAccountId: Scalars['Int'];
};

export type MutationCreateUpdateRefundArgs = {
  input: RefundInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationCreateUserEmailArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: CreateUserEmailInput;
};

export type MutationCreateUserTipArgs = {
  input: CreateUserTipInput;
};

export type MutationCreateUtilityAccountBillExtractionArgs = {
  input: CreateUtilityAccountBillExtractionInput;
};

export type MutationCreateUtilityCredentialSessionArgs = {
  input: CreateUtilityCredentialSessionInput;
};

export type MutationCreateUtilityStatementArgs = {
  input: CreateUtilityStatementInput;
};

export type MutationCreateVnmProductEligibilitiesExportArgs = {
  input: CreateVnmProductEligibilitiesExportInput;
};

export type MutationCreateVnmAttritionsArgs = {
  input: CreateAttritionInput;
};

export type MutationCreateVnmCampaignBatchArgs = {
  input: CreateVnmCampaignBatchInput;
};

export type MutationCreateVnmDeveloperArgs = {
  input: CreateVnmDeveloperMutationInput;
};

export type MutationCreateVnmSolarProjectExportArgs = {
  input: CreateVnmSolarProjectExportInput;
};

export type MutationCreateVnmSubscriptionsArgs = {
  input: Array<InputMaybe<CreateVnmSubscriptionInput>>;
};

export type MutationCreateVnmUtilitySubmissionArgs = {
  input: CreateVnmUtilitySubmissionInput;
};

export type MutationCreateVnmUtilitySubmissionExportArgs = {
  input: CreateVnmUtilitySubmissionExportInput;
};

export type MutationCreateWinbackCallAttemptArgs = {
  input?: InputMaybe<CreateWinbackCallAttemptInput>;
};

export type MutationCreateWinbackCampaignArgs = {
  input: CreateWinbackCampaignInput;
};

export type MutationCreateZippedFilesArgs = {
  input: CreateZippedFilesInput;
};

export type MutationCreateZuoraLinkTokenArgs = {
  input: CreateZuoraLinkTokenInput;
};

export type MutationDeactivateBillPayServiceProductSubscriptionArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<DeactivateBillPayServiceProductSubscriptionInput>;
};

export type MutationDeactivateProductSubscriptionArgs = {
  input: DeactivateProductSubscriptionInput;
};

export type MutationDelayStatementPaymentArgs = {
  input: DelayStatementPaymentInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationDeleteAccountEmailArgs = {
  emailId: Scalars['Int'];
  id: Scalars['Int'];
};

export type MutationDeleteBillUploadArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteContractLinkArgs = {
  input: DeleteContractLinkInput;
};

export type MutationDeleteCreditCorrectionArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteHostReportArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteLmiProofDocUploadArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteMeterArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteMoveRequestArgs = {
  input: DeleteMoveRequestInput;
};

export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};

export type MutationDeletePaymentMethodArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationDeleteSessionArgs = {
  input: DeleteSessionInput;
};

export type MutationDeleteTariffNormalizationArgs = {
  mappedTariffId: Scalars['ID'];
  sourceTariffName: Scalars['String'];
  sourceUtilityId: Scalars['ID'];
};

export type MutationDeleteUtilityStatementArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteVnmSubscriptionsArgs = {
  input: DeleteVnmSubscriptionInput;
};

export type MutationDocusignInstantAlertArgs = {
  input: DocuSignInstantAlertInput;
};

export type MutationEditContractMetadataArgs = {
  contractVersionId: Scalars['Int'];
  input: Array<EditContractMetadataInput>;
};

export type MutationEmailDeviceShippingInformationArgs = {
  input: EmailDeviceShippingInformationInput;
};

export type MutationEmailStatementArgs = {
  input?: InputMaybe<EmailStatementInput>;
};

export type MutationEmitPaymentFailedArgs = {
  input: PaymentFailedInput;
};

export type MutationEmitPaymentSuccessArgs = {
  input: PaymentSuccessInput;
};

export type MutationEmitStatementIssuedArgs = {
  input: StatementIssuedInput;
};

export type MutationFetchSignNowDocumentGroupStatusArgs = {
  id: Scalars['Int'];
};

export type MutationFetchSignNowEnvelopeStatusArgs = {
  id: Scalars['Int'];
};

export type MutationForwardUtilityEmailsArgs = {
  input: ForwardUtilityEmailsInput;
};

export type MutationGenerateDocuSignEnvelopeArgs = {
  input: DocuSignEnvelopeCreateInput;
};

export type MutationGenerateHostReportItemStatementsArgs = {
  input: GenerateHostReportStatementsInput;
};

export type MutationGenerateHostReportStatementsArgs = {
  id: Scalars['Int'];
  input: GenerateHostReportStatementsInput;
};

export type MutationGenerateHostReportStatementsV2Args = {
  id: Scalars['Int'];
};

export type MutationGenerateIlDisclosureFormArgs = {
  redirectUri?: InputMaybe<Scalars['String']>;
  utilityAccountId: Scalars['Int'];
};

export type MutationGenerateIlDisclosureFormsArgs = {
  planId: Scalars['Int'];
  redirectUri?: InputMaybe<Scalars['String']>;
};

export type MutationIgnoreEmailParsingResultArgs = {
  input: IgnoreEmailParsingResultInput;
};

export type MutationInitiateEdiBackfillArgs = {
  input: InitiateEdiBackfillInput;
};

export type MutationInitiatePerchFreezeBackfillArgs = {
  input: InitiatePerchFreezeBackfillInput;
};

export type MutationInitiatePerchIdentifiersBackfillArgs = {
  input: InitiatePerchIdentifiersBackfillInput;
};

export type MutationMarkHostReportItemsAsBilledArgs = {
  input: MarkHostReportItemsAsBilledInput;
};

export type MutationMergePlansArgs = {
  accountId: Scalars['Int'];
  planIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type MutationMultiUtilityAccountEnrollmentArgs = {
  input: MultiUtilityAccountEnrollmentInput;
  planId: Scalars['Int'];
};

export type MutationReactivatePlanArgs = {
  id: Scalars['Int'];
};

export type MutationRecordPaymentArgs = {
  input: RecordPaymentInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationRegenerateSignNowDocumentGroupArgs = {
  envelopeIds: Array<Scalars['Int']>;
  isEmbedded?: InputMaybe<Scalars['Boolean']>;
  redirectUri?: InputMaybe<Scalars['String']>;
};

export type MutationReissueEcheckArgs = {
  input: ReissueEcheckInput;
};

export type MutationRejectBillUploadArgs = {
  id: Scalars['Int'];
};

export type MutationRemoveDormantPromoCodeArgs = {
  input: RemovePromoCodeInput;
};

export type MutationRemovePromoCodeArgs = {
  input: RemovePromoCodeInput;
};

export type MutationReplaceLmiSourceTypeArgs = {
  id: Scalars['Int'];
  input: UpdateUtilityAccountLmiSourceTypeInput;
};

export type MutationReplaceStagingPaymentMethodsArgs = {
  accountId: Scalars['Int'];
};

export type MutationResendDocuSignEmailArgs = {
  input: ResendDocuSignEmailInput;
};

export type MutationResetPartnerSubscriberIngestionRequestArgs = {
  id: Scalars['Int'];
};

export type MutationResolveTasksArgs = {
  input: ResolveTasksInput;
};

export type MutationResolveWinbackAccountLeadArgs = {
  input?: InputMaybe<ResolveWinbackAccountLeadInput>;
};

export type MutationScrapeAccountDetailsArgs = {
  input: UtilityAccountIdInput;
};

export type MutationScrapeAccountDetailsV2Args = {
  input: ScraperRequestInput;
};

export type MutationScrapeHistoricalStatementsArgs = {
  input: UtilityAccountIdInput;
};

export type MutationScrapeHistoricalStatementsV2Args = {
  input: ScraperRequestInput;
};

export type MutationScrapeLatestBillingArgs = {
  input: UtilityAccountIdInput;
};

export type MutationScrapeLatestBillingV2Args = {
  input: ScraperRequestInput;
};

export type MutationSendAdvocacyEmailsArgs = {
  input: AdvocacyInput;
};

export type MutationSendAuthEmailArgs = {
  email: Scalars['String'];
};

export type MutationSendEmailEventsArgs = {
  inputs: Array<EmailEventInput>;
};

export type MutationSendEnvelopesFromPortalReportArgs = {
  input: SendEnvelopesFromPortalReportInput;
};

export type MutationSendInstantAlertArgs = {
  input: InstantAlertInput;
};

export type MutationSendSponsorshipInvitationArgs = {
  invitation: SponsorshipInvitationInput;
};

export type MutationSendVnmCampaignContractsArgs = {
  input?: InputMaybe<VnmCampaignContractsInput>;
};

export type MutationSetBillingAddressArgs = {
  input: AddressInput;
  planId: Scalars['Int'];
};

export type MutationSetPaymentMethodArgs = {
  input: SetPaymentMethodInput;
};

export type MutationSetPaymentMethodOnPlansArgs = {
  accountId: Scalars['Int'];
  input: SetPaymentMethodOnPlansInput;
};

export type MutationSignUpUserArgs = {
  input: SignUpUserInput;
};

export type MutationSnoozeTasksArgs = {
  input?: InputMaybe<SnoozeTasksInput>;
};

export type MutationStatementActionArgs = {
  input?: InputMaybe<StatementActionInput>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationSyncLmiSourceTypesArgs = {
  input: SyncLmiSourceTypesInput;
};

export type MutationSyncVnmSolarProjectArgs = {
  salesforceId: Scalars['String'];
};

export type MutationToggleSkipRemittanceArgs = {
  input: ToggleSkipRemittanceInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationTriggerVnmUtilitySubmissionScraperArgs = {
  input: TriggerVnmUtilitySubmissionScraperInput;
};

export type MutationUnassignTasksArgs = {
  input?: InputMaybe<UnassignTasksInput>;
};

export type MutationUnassignWinbackAccountLeadsArgs = {
  input?: InputMaybe<UnassignWinbackAccountLeadsInput>;
};

export type MutationUnsnoozeTasksArgs = {
  input?: InputMaybe<UnsnoozeTasksInput>;
};

export type MutationUpdateAccountArgs = {
  id: Scalars['Int'];
  input: UpdateAccountInput;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateAccountClosureRequestArgs = {
  input: UpdateAccountClosureRequestInput;
};

export type MutationUpdateAccountKwhArgs = {
  id: Scalars['Int'];
  input: UpdateAccountKwhInput;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateAnnualizedUsageEstimateArgs = {
  input: UpdateAnnualizedUsageEstimateInput;
  utilityAccountId: Scalars['Int'];
};

export type MutationUpdateBillPayServiceProductEligibilityArgs = {
  id: Scalars['Int'];
  input: UpdateBillPayServiceProductEligibilityInput;
};

export type MutationUpdateBillPayServiceProductSubscriptionArgs = {
  input: UpdateBillPayServiceProductSubscriptionInput;
};

export type MutationUpdateBulkProcessingRequestArgs = {
  input: UpdateBulkProcessingRequestInput;
};

export type MutationUpdateContractArgs = {
  id: Scalars['Int'];
  input: UpdateContractInput;
};

export type MutationUpdateContractVersionPersonalizationRequestArgs = {
  id: Scalars['Int'];
  input: UpdateContractVersionPersonalizationRequestInput;
};

export type MutationUpdateCreditArgs = {
  input: UpdateCreditInput;
};

export type MutationUpdateCustomerSnapshotArgs = {
  input: UpdateCustomerSnapshotInput;
  utilityAccountId: Scalars['Int'];
};

export type MutationUpdateDocuSignClickwrapArgs = {
  input: DocuSignClickwrapInput;
};

export type MutationUpdateDocuSignEnvelopeStatusArgs = {
  input: DocuSignEnvelopeStatusInput;
};

export type MutationUpdateEnrollingUserArgs = {
  id: Scalars['Int'];
  input: EnrollingUserInput;
};

export type MutationUpdateMeterArgs = {
  input: UpdateMeterInput;
};

export type MutationUpdateMoveRequestArgs = {
  input: UpdateMoveRequestInput;
};

export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};

export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};

export type MutationUpdateNotificationsArgs = {
  input: UpdateNotificationsInput;
};

export type MutationUpdatePlanArgs = {
  id: Scalars['Int'];
  input: UpdatePlanInput;
};

export type MutationUpdateProductLeadArgs = {
  input: UpdateProductLeadInput;
};

export type MutationUpdateRuleArgs = {
  input: UpdateRuleInput;
};

export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};

export type MutationUpdateSignNowEnvelopeArgs = {
  id: Scalars['Int'];
  input: UpdateSignNowEnvelopeInput;
};

export type MutationUpdateSignupFunnelLeadArgs = {
  id: Scalars['Int'];
  input: UpdateSignupFunnelLeadInput;
};

export type MutationUpdateStatementArgs = {
  input: UpdateStatementInput;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type MutationUpdateSupplierStatementDetailArgs = {
  input: UpdateSupplierStatementDetailInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['Int'];
  input: UpdateUserInput;
};

export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};

export type MutationUpdateUserTipArgs = {
  input: UpdateUserTipInput;
};

export type MutationUpdateUtilityAccountArgs = {
  id: Scalars['Int'];
  input: UpdateUtilityAccountInput;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateUtilityAccountDetailsArgs = {
  input: UpdateUtilityAccountDetailInput;
  utilityAccountId: Scalars['Int'];
};

export type MutationUpdateUtilityAccountLmiSourceTypeArgs = {
  id: Scalars['Int'];
  input: UpdateUtilityAccountLmiSourceTypeInput;
};

export type MutationUpdateUtilityCredentialArgs = {
  id: Scalars['Int'];
  input: UpdateUtilityCredentialInput;
};

export type MutationUpdateUtilityEmailsArgs = {
  input: UpdateUtilityEmailsInput;
};

export type MutationUpdateUtilityStatementArgs = {
  input: UpdateUtilityStatementInput;
};

export type MutationUpdateVnmProductEligibilitiesArgs = {
  input: Array<UpdateVnmProductEligibilityInput>;
};

export type MutationUpdateVnmSolarProjectArgs = {
  id: Scalars['Int'];
  input: UpdateVnmSolarProjectInput;
};

export type MutationUpdateVnmSubscriptionsArgs = {
  input: Array<InputMaybe<UpdateVnmSubscriptionInput>>;
};

export type MutationUpdateWinbackUtilityAccountLeadStatusArgs = {
  input?: InputMaybe<UpdateWinbackUtilityAccountLeadStatusInput>;
};

export type MutationUploadBillImageArgs = {
  input: BillUploadInput;
};

export type MutationUploadFileArgs = {
  input: S3UploadInput;
};

export type MutationUploadIpaFormArgs = {
  input: UploadIpaFormInput;
};

export type MutationUploadLmiProofDocArgs = {
  input: LmiProofDocUploadInput;
};

export type MutationUploadThinkFileArgs = {
  input: CreateThinkSyncCsvInput;
};

export type MutationVoidCreditArgs = {
  input: VoidCreditInput;
};

export type MutationOutput = {
  id?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  message?: Maybe<Scalars['String']>;
  query: Query;
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type NeedsReviewReason = {
  active: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  product: Scalars['String'];
  productEligibilityId?: Maybe<Scalars['Int']>;
  reason: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export enum NewBillingExperienceType {
  DualBilled = 'dual_billed',
  UtilityBilled = 'utility_billed',
}

/** TODO: Remove this field and replace with the tabsData field once funnel is updated */
export type NjTabsDataInput = {
  county?: InputMaybe<Scalars['String']>;
  houseIncome?: InputMaybe<Scalars['String']>;
  houseOccupancy?: InputMaybe<Scalars['String']>;
  lmiProgram?: InputMaybe<Scalars['String']>;
};

export type NormalizationDeleteSuccess = {
  numDeleted?: Maybe<Scalars['Int']>;
};

export type NormalizationPropertyKey = {
  dataType: PropertyDataType;
  defaultValue?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  summary: Scalars['String'];
};

export type NormalizationPropertyKeyInput = {
  dataType: Scalars['String'];
  id: Scalars['String'];
  value: Scalars['String'];
};

export type Note = {
  /** some notes are specifically about a user account */
  accountId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  /** date indicates the day that a specific interaction with a customer took place vs. the createdAt timestamp */
  date?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  owner?: Maybe<AdminUser>;
  targetType: Scalars['String'];
  taskId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  type: Scalars['String'];
  userId?: Maybe<Scalars['Int']>;
};

export enum NoteType {
  Billing = 'billing',
  Chat = 'chat',
  Email = 'email',
  Note = 'note',
  Phone = 'phone',
  Task = 'task',
}

export type Notification = {
  actionType: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  displayValues?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  notifiableId?: Maybe<Scalars['Int']>;
  notifiablePlanId?: Maybe<Scalars['Int']>;
  notifiableType?: Maybe<Scalars['String']>;
  /** same as notification.key, renamed because React does not pass key prop to children */
  notificationKey: Scalars['String'];
  notificationTypeId?: Maybe<Scalars['Int']>;
  priorityType: Scalars['String'];
  read: Scalars['Boolean'];
  targetId?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  utilityAccountDetails?: Maybe<NotificationUtilityAccountDetails>;
};

export type NotificationFilterInput = {
  notifiableType?: InputMaybe<Scalars['String']>;
  notificationKey?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priorityType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationUtilityAccountDetails = {
  accountNumber?: Maybe<Scalars['String']>;
  displayServiceAddress?: Maybe<Scalars['String']>;
  utilityDisplayName?: Maybe<Scalars['String']>;
};

export type NyLmiZoneOptions = {
  dacZone?: Maybe<Scalars['Boolean']>;
  empowerZone?: Maybe<Scalars['Boolean']>;
  isAddressPresent?: Maybe<Scalars['Boolean']>;
};

export enum OfferingType {
  Bundled = 'BUNDLED',
  Delivery = 'DELIVERY',
  Energy = 'ENERGY',
}

export type OnBillItem = {
  costCents?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  financeRate?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  orderLimit?: Maybe<Scalars['Int']>;
  shortName?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  termLength?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type OnBillSubscription = {
  balanceCents?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  onBillItem: OnBillItem;
  payInLumpSum?: Maybe<Scalars['Boolean']>;
  shipmentStatus?: Maybe<Scalars['String']>;
  termEndDate?: Maybe<Scalars['Date']>;
  termStartDate?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type OnboardingRateClass = {
  displayName: Scalars['String'];
  id: Scalars['Int'];
};

export type OnlyIn = {
  onlyIn: RuleContext;
};

export type OptOutPeriod = {
  createdAt?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  startDate?: Maybe<Scalars['Date']>;
  vnmSubscriptionStatusCounts?: Maybe<VnmSubscriptionStatusCounts>;
  vnmSubscriptions: Array<VnmSubscription>;
};

export enum OriginationSource {
  DirectMarketing = 'direct_marketing',
  DirectSales = 'direct_sales',
  Organic = 'organic',
  PerchEnergy = 'perch_energy',
  SponsoredSolar = 'sponsored_solar',
  Unknown = 'unknown',
  Waitlist = 'waitlist',
}

export type OtherLineItem = FormattedLineItem & {
  amountCents: Scalars['Int'];
  entryType: LineItemEntryType;
  id: Scalars['String'];
  key: LineItemKey;
  name: Scalars['String'];
  sandboxed: Scalars['Boolean'];
};

export type OutboundEmail = {
  bouncedAt?: Maybe<Scalars['Datetime']>;
  campaign?: Maybe<OutboundEmailCampaign>;
  clickedAt?: Maybe<Scalars['Datetime']>;
  deliveredAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['String'];
  openedAt?: Maybe<Scalars['Datetime']>;
  recipient: Scalars['String'];
  sentAt?: Maybe<Scalars['Datetime']>;
  spammedAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  suppressedAt?: Maybe<Scalars['Datetime']>;
  tags: Array<Maybe<Scalars['String']>>;
  template?: Maybe<OutboundEmailTemplate>;
  unsubscribedAt?: Maybe<Scalars['Datetime']>;
  url?: Maybe<Scalars['String']>;
};

export type OutboundEmailCampaign = {
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type OutboundEmailTemplate = {
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  layout?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum Owner {
  Arcadia = 'Arcadia',
  Perch = 'Perch',
}

export enum Ownership {
  BehindMeter = 'BEHIND_METER',
  CommunityChoiceAggregator = 'COMMUNITY_CHOICE_AGGREGATOR',
  Coop = 'COOP',
  Federal = 'FEDERAL',
  Investor = 'INVESTOR',
  Muni = 'MUNI',
  PoliticalSubdivision = 'POLITICAL_SUBDIVISION',
  RetailEnergyMarketer = 'RETAIL_ENERGY_MARKETER',
  State = 'STATE',
  Transmission = 'TRANSMISSION',
  Unregulated = 'UNREGULATED',
  WholesaleEnergyMarketer = 'WHOLESALE_ENERGY_MARKETER',
}

export type PaginatedSolarProject = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PaginatedSolarProjectFilters = {
  developerIds?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type PaginatedSolarProjectResults = {
  hasMore: Scalars['Boolean'];
  page: Scalars['Int'];
  result: Array<PaginatedSolarProject>;
  resultCount: Scalars['Int'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type PartnerSubscriberIngestionRequest = {
  adminUser?: Maybe<AdminUser>;
  adminUserId?: Maybe<Scalars['Int']>;
  auditReportFile?: Maybe<Scalars['String']>;
  auditReportFileDownloadUrl?: Maybe<Scalars['String']>;
  auditReportFileExists: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  ingestionFile?: Maybe<Scalars['String']>;
  ingestionFileDownloadUrl?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  validationReportFile?: Maybe<Scalars['String']>;
  validationReportFileDownloadUrl?: Maybe<Scalars['String']>;
  validationReportFileExists: Scalars['Boolean'];
};

export type PaymentDetails = {
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bankRoutingNumber?: Maybe<Scalars['String']>;
  paymentAddress?: Maybe<Scalars['String']>;
};

export type PaymentFailedInput = {
  accountId?: InputMaybe<Scalars['String']>;
  adminUserId?: InputMaybe<Scalars['String']>;
  billAmountDollars?: InputMaybe<Scalars['Int']>;
  finishedAt?: InputMaybe<Scalars['String']>;
  initialStatementDate?: InputMaybe<Scalars['Datetime']>;
  maxDeclines?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  r01Response?: InputMaybe<Scalars['Boolean']>;
  requestCount?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  utilityStatementId?: InputMaybe<Scalars['String']>;
};

export type PaymentFile = {
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum PaymentHoldResult {
  Error = 'error',
  Failure = 'failure',
  Success = 'success',
}

export type PaymentMethod = {
  countOfPlans?: Maybe<Scalars['Int']>;
  dateAdded?: Maybe<Scalars['String']>;
  /** normalized for display, e.g. Visa 1234 */
  description: Scalars['String'];
  expirationDate?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  /**
   * indicates if the payment method has an associated transaction with an accepted or canceled status
   * which means it's a valid payment and can be charged
   */
  hasSuccessfulTransactions: Scalars['Boolean'];
  id: Scalars['Int'];
  lastFour: Scalars['String'];
  mostRecentPaymentTransaction?: Maybe<PaymentTransaction>;
  plans: Array<Plan>;
  routingNumber?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  walletType?: Maybe<Scalars['String']>;
};

export enum PaymentMethodType {
  Ach = 'ach',
  Cashapp = 'cashapp',
  CreditCard = 'credit_card',
}

export enum PaymentProvider {
  Stripe = 'stripe',
  Zuora = 'zuora',
}

export type PaymentSuccessInput = {
  accountId?: InputMaybe<Scalars['String']>;
};

export type PaymentTransaction = {
  account?: Maybe<Account>;
  amountCents?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  dispute?: Maybe<Dispute>;
  disputeId?: Maybe<Scalars['Int']>;
  finishedAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  /** @deprecated Not a real field, always empty */
  issuedAt?: Maybe<Scalars['Datetime']>;
  lastFour?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodDescription?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  paymentMethodType?: Maybe<Scalars['String']>;
  refundTransactions?: Maybe<Array<Maybe<RefundTransaction>>>;
  remittanceProcessed?: Maybe<Scalars['Boolean']>;
  sandboxed?: Maybe<Scalars['Boolean']>;
  settlementCode?: Maybe<Scalars['String']>;
  settlementDetails?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  statement?: Maybe<Statement>;
  statementId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  transferAmountCents?: Maybe<Scalars['Int']>;
};

export type PerchPersonalizedFileEntry = {
  base64PerchPersonalizedFile?: Maybe<Scalars['String']>;
  perchPersonalizedError?: Maybe<Scalars['String']>;
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type PerchProductOption = {
  name: Scalars['String'];
  salesforceId: Scalars['String'];
};

export enum PerchProductProofDocRequirement {
  NotNeeded = 'not_needed',
  Optional = 'optional',
  Required = 'required',
}

export type PersonalizedContractPreviewOutput = {
  base64: Scalars['String'];
};

export type PersonalizedSignupContractSetInput = {
  languageShortCode: Scalars['String'];
  planId: Scalars['Int'];
  signupContractTemplateId: Scalars['Int'];
};

export type Plan = {
  account: Account;
  accountId?: Maybe<Scalars['Int']>;
  /**
   * Note that this is currently "faking" this data by just pulling
   * it off of the account that the plan is associated with.
   * TODO: remove this https://arcadiapower.atlassian.net/browse/DASH-2427
   */
  accountNumber?: Maybe<Scalars['Int']>;
  active: Scalars['Boolean'];
  activeMembershipProductSubscription?: Maybe<ProductSubscription>;
  allowedPlanTemplates: Array<PlanTemplate>;
  balances?: Maybe<PlanBalances>;
  billable: Scalars['Boolean'];
  billingAddress?: Maybe<Address>;
  billingSettingsDetails: BillingSettings;
  cleanKilowattHours: Array<CleanKilowattHour>;
  createdAt: Scalars['Datetime'];
  cumulativeVnmSavings?: Maybe<Scalars['Float']>;
  /**
   * Name displayed in frontend apps. Defaults to the plan name (nickname) if it exists.
   * Falls back to Utility Account serviceAddressStreetOne, then Utility Account serviceAddressCity serviceAddressState,
   * then planId. (Utility Account here refers to the first existing utility account on the plan's
   * product subscriptions and leads.)
   */
  displayName: Scalars['String'];
  disputeStatus: Scalars['String'];
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  fee?: Maybe<Scalars['Float']>;
  generatingStatements: Scalars['Boolean'];
  highlights: Array<Maybe<Scalars['String']>>;
  hostReportItems: Array<HostReportItem>;
  id: Scalars['Int'];
  impact: Impact;
  isDefault?: Maybe<Scalars['Boolean']>;
  isExclusiveMembershipPlan?: Maybe<Scalars['Boolean']>;
  isMoved?: Maybe<Scalars['Boolean']>;
  lastBilledAt?: Maybe<Scalars['Datetime']>;
  minimumFee?: Maybe<Scalars['Float']>;
  mostRecentStatement?: Maybe<Statement>;
  name?: Maybe<Scalars['String']>;
  netPaymentTerms?: Maybe<Scalars['Int']>;
  nextBillDate?: Maybe<Scalars['Date']>;
  openTasks: Array<Task>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  originalPlanTemplateId?: Maybe<Scalars['Int']>;
  overdueStatements?: Maybe<Array<StatementV2>>;
  paymentLink?: Maybe<PlanPaymentLink>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['Int']>;
  perchManaged: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  planTemplate?: Maybe<PlanTemplate>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  planTemplateId?: Maybe<Scalars['Int']>;
  planType: Scalars['String'];
  productLeads: Array<ProductLead>;
  productStatuses: PlanProductStatuses;
  productSubscriptions: Array<ProductSubscription>;
  propertyAccountSalesforceId?: Maybe<Scalars['String']>;
  reactivationEligibility: ReactivationEligibility;
  recRatio?: Maybe<Scalars['Float']>;
  sandboxed?: Maybe<Scalars['Boolean']>;
  seagullPlan?: Maybe<SeagullPlan>;
  sgPlanId?: Maybe<Scalars['String']>;
  smbDualBilling: Scalars['Boolean'];
  statements: Array<Statement>;
  /** @deprecated use active instead */
  status: PlanStatus;
  type: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  upsellProducts: Array<Product>;
  utilityAccounts: Array<UtilityAccount>;
  utilityAccountsCount: Scalars['Int'];
  utilityCredentials: Array<UtilityCredential>;
  vnmEligible?: Maybe<Scalars['Boolean']>;
  /** @deprecated use vnmProductSubscriptions instead */
  vnmProductSubscription?: Maybe<VnmProductSubscription>;
  vnmProductSubscriptions?: Maybe<Array<Maybe<VnmProductSubscription>>>;
  waitlistStatusText?: Maybe<Scalars['String']>;
};

export type PlanCleanKilowattHoursArgs = {
  endDate?: InputMaybe<StringRangeFilter>;
  startDate?: InputMaybe<StringRangeFilter>;
};

export type PlanProductLeadsArgs = {
  productType?: InputMaybe<Scalars['String']>;
};

export type PlanProductSubscriptionsArgs = {
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PlanUtilityAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type PlanAttributes = {
  evergreenKwh?: Maybe<Scalars['Int']>;
  evergreenNextBillDate?: Maybe<Scalars['Date']>;
  hasEvergreenSubscription: Scalars['Boolean'];
  isEvergreen: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
};

export type PlanBalances = {
  balanceCents: Scalars['Int'];
  balanceDueCents: Scalars['Int'];
  id: Scalars['Int'];
  pastDueCents: Scalars['Int'];
  pendingBalanceCents: Scalars['Int'];
};

export type PlanPaymentLink = {
  id: Scalars['Int'];
  stripeCheckoutUrl?: Maybe<Scalars['String']>;
};

export type PlanProductStatuses = {
  billPay: ProductStatus;
  connectedWind: ProductStatus;
  giving: ProductStatus;
  membership: ProductStatus;
  usageBasedWind: ProductStatus;
  vnm: ProductStatus;
  wind: ProductStatus;
};

/** Providing these options for now we can add newer options if needed. */
export enum PlanSortOptions {
  CreatedAt = 'created_at',
  Status = 'status',
  UpdatedAt = 'updated_at',
}

export enum PlanStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export type PlanStatusCounts = {
  active: Scalars['Int'];
  inactive: Scalars['Int'];
};

export type PlanTemplate = {
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  active: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  billingExperienceType?: Maybe<Scalars['String']>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  contractVersions: Array<Maybe<ContractVersion>>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  createdAt: Scalars['Date'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  description?: Maybe<Scalars['String']>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  enrollmentDataSourceName?: Maybe<Scalars['String']>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  externalName: Scalars['String'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  id: Scalars['Int'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  internalName: Scalars['String'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  products: Array<Product>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  requiresPaymentMethod: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  updatedAt: Scalars['String'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  utilities: Array<Utility>;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  visibility?: Maybe<Scalars['String']>;
};

export type PlanTemplateContractVersionsArgs = {
  stateId?: InputMaybe<Scalars['Int']>;
};

export enum PlanTypes {
  Evergreen = 'evergreen',
  FlatBill = 'flat_bill',
  Free = 'free',
  Premium = 'premium',
}

export type PlansFilterOptions = {
  accountId: Scalars['Int'];
  onlyPlansWithValidUtilityAccounts?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

export type PlansResponse = {
  count: Scalars['Int'];
  plans: Array<Plan>;
};

export enum PredominanceRule {
  Predominant = 'PREDOMINANT',
  Subservient = 'SUBSERVIENT',
}

export type PreviewFileDownloadUrl = {
  personalizedContractPreviewFileDownloadUrl: Scalars['String'];
};

export type PreviousUsage = {
  id: Scalars['Int'];
  readingType?: Maybe<Scalars['String']>;
  supplierRate?: Maybe<Scalars['Float']>;
};

export type PreviousUtilityStatement = {
  carryForwardKwh?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  usages?: Maybe<Array<PreviousUsage>>;
};

export enum PrivacyFlag {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED',
}

export type ProcessCreateOptOutPeriod = {
  errors?: Maybe<Array<Maybe<ProcessCreateOptOutPeriodError>>>;
  optOutPeriodId: Scalars['Int'];
  processedAt?: Maybe<Scalars['Datetime']>;
};

export type ProcessCreateOptOutPeriodError = {
  createdAt?: Maybe<Scalars['Datetime']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  recordId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
};

export type Product = {
  active: Scalars['Boolean'];
  arcProduct: Scalars['Boolean'];
  attritionCategories?: Maybe<Array<AttritionCategory>>;
  billable: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  defaultAmountCents?: Maybe<Scalars['Int']>;
  details?: Maybe<ProductDetails>;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  productType: Scalars['String'];
};

export type ProductDetails = {
  creditTypeKey?: Maybe<Scalars['String']>;
  lineItemTypeKey?: Maybe<Scalars['String']>;
};

export type ProductLead = {
  active: Scalars['Boolean'];
  billPayServiceProductEligibility?: Maybe<BillPayServiceProductEligibility>;
  createdAt: Scalars['Date'];
  details?: Maybe<Scalars['JSON']>;
  eligibilityCheck?: Maybe<ProductLeadEligibilityCheck>;
  id: Scalars['Int'];
  plan: Plan;
  product: Product;
  productType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  utilityAccount?: Maybe<UtilityAccount>;
};

export type ProductLeadEligibilityCheck = {
  eligible?: Maybe<Scalars['Boolean']>;
  ineligibilityReasons?: Maybe<Scalars['JSON']>;
};

export type ProductStatus = {
  product?: Maybe<Product>;
  status: EnrollmentStatus;
};

/** TODO: make ProductSubscription an interface */
export type ProductSubscription = {
  amountCents?: Maybe<Scalars['Int']>;
  attrition?: Maybe<Attrition>;
  capacityBlockCategory?: Maybe<Scalars['String']>;
  capacityBlockLink?: Maybe<Scalars['String']>;
  capacityBlockSubCategory?: Maybe<Scalars['String']>;
  cleanKilowattHours: Array<CleanKilowattHour>;
  createdAt: Scalars['Datetime'];
  deactivatedAt?: Maybe<Scalars['Datetime']>;
  details?: Maybe<Scalars['JSON']>;
  formId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  meterNumber?: Maybe<Scalars['String']>;
  participantId?: Maybe<Scalars['String']>;
  plan: Plan;
  processHistory: Array<Scalars['Datetime']>;
  product?: Maybe<Product>;
  salesforceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  utilityAccount?: Maybe<UtilityAccount>;
  vnmSubscription?: Maybe<VnmSubscription>;
};

/** TODO: make ProductSubscription an interface */
export type ProductSubscriptionCleanKilowattHoursArgs = {
  endDate?: InputMaybe<StringRangeFilter>;
  startDate?: InputMaybe<StringRangeFilter>;
};

export type ProductSubscriptionStatus = {
  status?: Maybe<SubscriptionStatus>;
};

export enum ProductionDataBreakdown {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Year = 'year',
}

export type ProjectSnapshot = {
  ciCapacityAvailable?: Maybe<Scalars['Boolean']>;
  collectPayment?: Maybe<Scalars['Boolean']>;
  ira?: Maybe<Scalars['Boolean']>;
  lmiCapacityAvailable?: Maybe<Scalars['Boolean']>;
  lmiProductId?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  resiCapacityAvailable?: Maybe<Scalars['Boolean']>;
  salesforceUtilityId?: Maybe<Scalars['String']>;
  savingsPercent?: Maybe<Scalars['Float']>;
  smallCsCapacityAvailable?: Maybe<Scalars['Boolean']>;
  waitlist?: Maybe<Scalars['Boolean']>;
};

export type ProjectedVnmSolarProjectStatistics = {
  projectedAllocation?: Maybe<Scalars['Float']>;
  projectedCoverage?: Maybe<Scalars['Float']>;
  projectedLmiCoverage?: Maybe<Scalars['Float']>;
  projectedUsageFactor?: Maybe<Scalars['Float']>;
};

export type PromoCode = {
  code: Scalars['String'];
  developerSourcesAcceptedDevelopers?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayText: Scalars['String'];
  emailVerificationDomains?: Maybe<Array<Scalars['String']>>;
  freeCost?: Maybe<Scalars['Int']>;
  fulfillmentAvailable: Scalars['Boolean'];
  fulfillmentExpirationDate?: Maybe<Scalars['Date']>;
  fulfillmentStep?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incentives: Array<Incentive>;
  isDeveloperSourced: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  ownerDeveloperName?: Maybe<Scalars['String']>;
  paymentAttributionWindow?: Maybe<Scalars['Int']>;
  premiumCost?: Maybe<Scalars['Int']>;
  referredUsers: ReferredUsersResponse;
  requiresEmailVerification: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  requiresFreePlanTemplateOption: Scalars['Boolean'];
  requiresPhoenixFunnel: Scalars['Boolean'];
  requiresRefreshedQuickWinsFunnel: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  requiresWindPlanTemplate: Scalars['Boolean'];
  sponsorName?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  utilityConnectCost?: Maybe<Scalars['Int']>;
  utilityConnectText?: Maybe<Scalars['String']>;
};

export type PromoCodeReferredUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export enum PropertyDataType {
  Boolean = 'BOOLEAN',
  Choice = 'CHOICE',
  Date = 'DATE',
  Decimal = 'DECIMAL',
  Demand = 'DEMAND',
  Formula = 'FORMULA',
  Integer = 'INTEGER',
  Lookup = 'LOOKUP',
  String = 'STRING',
}

export enum ProrationRule {
  SingleDemandSeasonChange = 'SINGLE_DEMAND_SEASON_CHANGE',
  SplitDemandVersionChange = 'SPLIT_DEMAND_VERSION_CHANGE',
}

export type ProspectUser = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  utilityId: Scalars['Int'];
  zipcode?: Maybe<Scalars['String']>;
};

export enum PurposeCode {
  SubMgmtAccountDetails = 'sub_mgmt_account_details',
  SubMgmtBillingHistory = 'sub_mgmt_billing_history',
  SubMgmtIntervalData = 'sub_mgmt_interval_data',
  SubMgmtLatestBilling = 'sub_mgmt_latest_billing',
}

export type Query = {
  _empty?: Maybe<Scalars['String']>;
  account: Account;
  accountClosureRequestFileDownloadUrls?: Maybe<AccountClosureRequestFileDownloadUrls>;
  accountClosureRequests: AccountClosureRequestResponse;
  adminLogin: AuthedAdminUser;
  adminSamlLoginLinks: AdminSamlLoginLinks;
  adminTokenExchange: TokenExchangeOutput;
  adminUser: AdminUser;
  adminUsers: Array<AdminUser>;
  advocacyRepresentatives: Array<Representative>;
  allSuppliers: Array<Maybe<AllSuppliersItem>>;
  allUtilities: Array<Maybe<AllUtilitiesItem>>;
  attritionCategories?: Maybe<Array<AttritionCategory>>;
  averageUsage: Array<Maybe<AverageUsageByMonth>>;
  billPayServiceProductSubscription?: Maybe<BillPayServiceProductSubscription>;
  billingExperienceOptions: Array<BillingExperienceOption>;
  bulkProcessingRequestFileDownloadUrls?: Maybe<BulkProcessingRequestFileDownloadUrls>;
  bulkProcessingRequestTypes?: Maybe<Array<BulkProcessingRequestTypes>>;
  bulkProcessingRequests: BulkProcessingRequestResponse;
  calculateCsCredit?: Maybe<CsCreditCalculation>;
  cancelUserReward: UserRewardResponse;
  cleanKilowattHour: CleanKilowattHour;
  communitySolarLead: CommunitySolarLead;
  communitySolarProgramEligiblityRuleKeys: Array<Scalars['String']>;
  communitySolarProjectGroups: Array<CommunitySolarProjectGroup>;
  communitySolarQualificationRuleKeys: Array<Scalars['String']>;
  communitySolarStaticRuleGraph: CategoryKeys;
  communitySolarUtilityAccount: CommunitySolarUtilityAccount;
  completedAdvocacyCampaign: CompletedAdvocacyCampaign;
  contract: Contract;
  contractAgreement: ContractAgreement;
  /** Every run of one user ingestion request, newest first, across all types. */
  contractFileIngestionHistory: Array<ContractFileIngestionRequest>;
  contractFileIngestionOverview: ContractFileIngestionOverviewPage;
  contractSetContractVersions: Array<ContractVersion>;
  contractVersion: ContractVersion;
  contractVersionLanguage: ContractVersionLanguage;
  contractVersionLanguages: Array<Maybe<ContractVersionLanguage>>;
  contractVersionPersonalizationRequests?: Maybe<
    Array<Maybe<ContractVersionPersonalizationRequest>>
  >;
  contractVersions: Array<ContractVersion>;
  contracts: Array<Contract>;
  countiesByZip: Array<SalesforceCountyOption>;
  countyData?: Maybe<CountyData>;
  credit?: Maybe<Credit>;
  creditCorrection: CreditCorrection;
  creditType: CreditType;
  creditTypes?: Maybe<Array<Maybe<CreditType>>>;
  csCreditCalculation?: Maybe<CsCreditCalculation>;
  currentContractVersion?: Maybe<ContractVersion>;
  currentContractVersions: Array<ContractVersion>;
  developerNames: Array<Scalars['String']>;
  dispute?: Maybe<Dispute>;
  egridSubregion: EgridSubregion;
  eligibleWinbackLeadsForCampaign: WinbackAccountLeadsResponse;
  emailVerificationAttempt: EmailVerificationAttempt;
  enrollUserReward: UserRewardResponse;
  enrollmentOptions: Array<EnrollmentOption>;
  /** Must have bearer authentication with an Entra ID (Azure AD) OAuth access token */
  entraLogin: TokenExchangeOutput;
  executedContract?: Maybe<ExecutedContract>;
  export: Export;
  exports: Array<ExportDetail>;
  featuredWindProject: WindProject;
  featuredWindProjects: Array<Maybe<WindProject>>;
  funnelBillingExperienceConfiguration?: Maybe<FunnelBillingExperienceConfiguration>;
  funnelConfiguration: FunnelConfiguration;
  funnelPacket: FunnelPacket;
  funnelQueryParams: FunnelQueryParams;
  generalContractVersions: Array<ContractVersion>;
  getTokenUserReward: UserRewardResponse;
  getUserReward?: Maybe<UserReward>;
  googleLoginUrl: Scalars['String'];
  hasAdvocacyCampaignSubmission: Scalars['Boolean'];
  hostReport?: Maybe<HostReport>;
  hostReportItems: Array<HostReportItem>;
  ineligibilityReason: IneligibilityReason;
  ineligibilityReasonOptions?: Maybe<IneligibilityReasonOptions>;
  ingestionFileDownloadUrls?: Maybe<IngestionFileDownloadUrls>;
  lineItemElements: LineItemElements;
  linkCheck: LinkCheck;
  lmiProofDocLabelOptions: LmiProofDocLabelOptionsResponse;
  lmiSourceTypes: Array<LmiSourceType>;
  loadZone: LoadZone;
  loadZones: Array<LoadZone>;
  lookupUserReward: UserRewardResponse;
  lse: LoadServingEntity;
  mappingRequests?: Maybe<Array<TariffNormalization>>;
  needsReviewReason: NeedsReviewReason;
  nextTask?: Maybe<Task>;
  /** Must have bearer authentication with an Okta OAuth access token */
  oktaLogin: TokenExchangeOutput;
  originationSource?: Maybe<UserOriginationSource>;
  outboundEmail?: Maybe<OutboundEmail>;
  paginatedSolarProjects: PaginatedSolarProjectResults;
  partnerSubscriberIngestionRequest?: Maybe<PartnerSubscriberIngestionRequest>;
  partnerSubscriberIngestionRequests: Array<Maybe<PartnerSubscriberIngestionRequest>>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTransaction: PaymentTransaction;
  perchProductsForUtilityOrState: Array<PerchProductOption>;
  personalizedSignupContractSet: SignupContractTemplate;
  plan: Plan;
  planBalances: PlanBalances;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  planTemplate: PlanTemplate;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  planTemplates: Array<Maybe<PlanTemplate>>;
  plans: Array<Plan>;
  previewFileDownloadUrl?: Maybe<PreviewFileDownloadUrl>;
  productLead: ProductLead;
  productSubscription?: Maybe<ProductSubscription>;
  products: Array<Product>;
  promoCode: PromoCode;
  promoCodes: Array<Maybe<PromoCode>>;
  rateClass: RateClass;
  rateClasses: Array<RateClass>;
  refundReason: RefundReason;
  refundReasons: Array<RefundReason>;
  remittanceMethods: Array<RemittanceMethod>;
  representatives?: Maybe<Array<Representative>>;
  resolveFunnelConfig?: Maybe<ResolveFunnelConfig>;
  resumeUserAdmin?: Maybe<AuthedAdminUser>;
  s3Directories: Array<S3Directory>;
  search: Search;
  serviceUserLogin: AuthedServiceUser;
  sessions: Array<Session>;
  /** Fetch a SignNow document group by id. */
  signNowDocumentGroup?: Maybe<SignNowDocumentGroup>;
  /** Fetch the most recent SignNow document group for a plan. */
  signNowDocumentGroupByPlan?: Maybe<SignNowDocumentGroup>;
  /** Fetch a SignNow envelope by id. */
  signNowEnvelope?: Maybe<SignNowEnvelope>;
  /** Fetch the most recent SignNow envelope for a utility account and contract type. */
  signNowEnvelopeByUtilityAccount?: Maybe<SignNowEnvelope>;
  signupContractSets: SignupContractTemplate;
  signupContractTemplateContractVersions: Array<ContractVersion>;
  smsLogs: FetchedMessages;
  smsOfPage: FetchedPaginatedMessages;
  state: State;
  stateContractVersions: Array<ContractVersion>;
  statement: Statement;
  statementTransactions: StatementTransactionsResponse;
  states: Array<State>;
  supplier: Supplier;
  supplierStatementDetail: SupplierStatementDetail;
  supplierStatementDetails?: Maybe<Array<Maybe<SupplierStatementDetail>>>;
  supportedAppVersion: SupportedAppVersion;
  /**
   * All contracts of the given types matching the given tags, for the specified
   * state.
   */
  taggedContractVersions: Array<ContractVersion>;
  tariff: Tariff;
  tariffNormalization?: Maybe<Array<AdminTariffNormalization>>;
  tariffNormalizations?: Maybe<Array<AdminTariffNormalizations>>;
  tariffs?: Maybe<Array<Tariff>>;
  task?: Maybe<Task>;
  taskType: TaskType;
  taskTypes: Array<TaskType>;
  tenants?: Maybe<Array<Tenant>>;
  thinkFileContents?: Maybe<ThinkFileContents>;
  thirdPartyUser?: Maybe<ThirdPartyUser>;
  thirdPartyUserLogin: AuthedUser;
  timeZones: Array<TimeZone>;
  tokenExchange: TokenExchangeOutput;
  user: User;
  userContractAgreements: Array<ContractAgreement>;
  userDuplicates: Array<User>;
  userExists: Scalars['Boolean'];
  userLogin: AuthedUser;
  userPromoCode: UserPromoCode;
  /** @deprecated use Search.users instead */
  users: UsersResponse;
  utilities: Array<Maybe<Utility>>;
  utilitiesAndSuppliersByTariffCounts: Array<Maybe<UtilityOrSupplierWithTariffCount>>;
  utilitiesByUniqueRateClassStrings: Array<Maybe<UtilityForUniqueRateClassStrings>>;
  utilitiesByZip: UtilitiesForZip;
  utility: Utility;
  utilityAccount: UtilityAccount;
  utilityAccountHighlightsOptions?: Maybe<Array<Scalars['String']>>;
  utilityAccountLmiSourceType: UtilityAccountLmiSourceType;
  utilityAccountLmiSourceTypes: Array<UtilityAccountLmiSourceType>;
  utilityAccounts?: Maybe<Array<UtilityAccount>>;
  utilityCredential: UtilityCredential;
  utilityCredentialConnectToken: Scalars['String'];
  utilityCredentialHighlightsOptions?: Maybe<Array<Scalars['String']>>;
  utilityCredentialSession: UtilityCredentialSession;
  utilityEmail: UtilityEmail;
  /** @deprecated use utilityEmail instead */
  utilityEmailBody: UtilityEmailBody;
  utilityMapping?: Maybe<UtilityMapping>;
  utilityStatement: UtilityStatement;
  utilityStatements: Array<UtilityStatement>;
  validateEmail: EmailValidationOutput;
  validation: Validation;
  verifyEmail: EmailVerificationOutput;
  vnmCampaign: VnmCampaign;
  vnmCampaignBatch: VnmCampaignBatch;
  vnmCampaignBatches: VnmCampaignBatchesOutput;
  vnmCampaigns: VnmCampaignsOutput;
  vnmContractUrls: Array<VnmContractUrl>;
  vnmDevelopers?: Maybe<Array<VnmDeveloper>>;
  vnmPartners: Array<VnmPartner>;
  vnmProductEligibilities?: Maybe<Array<Maybe<VnmProductEligibility>>>;
  vnmSolarProject?: Maybe<VnmSolarProject>;
  vnmSolarProjectDASSources: Array<Scalars['String']>;
  vnmSolarProjectGlobalStatistics: GlobalVnmSolarProjectStatistics;
  vnmSolarProjects?: Maybe<Array<VnmSolarProject>>;
  vnmSolarProjectsByState?: Maybe<Array<VnmSolarProject>>;
  vnmSolarProjectsByUtility?: Maybe<Array<VnmSolarProject>>;
  vnmSubscription?: Maybe<VnmSubscription>;
  vnmSubscriptionUtilitySubmission: VnmSubscriptionUtilitySubmission;
  vnmSubscriptionUtilitySubmissions?: Maybe<Array<VnmSubscriptionUtilitySubmission>>;
  vnmUtilitySubmission?: Maybe<VnmUtilitySubmission>;
  vnmUtilitySubmissions?: Maybe<Array<VnmUtilitySubmission>>;
  winbackAccountLead?: Maybe<WinbackAccountLead>;
  winbackAccountLeads: WinbackAccountLeadsResponse;
  winbackCallAttempts: Array<Maybe<WinbackCallAttempt>>;
  winbackCampaign?: Maybe<WinbackCampaign>;
  winbackCampaigns: WinbackCampaignsResponse;
  winbackUtilityAccountLeads: Array<Maybe<WinbackUtilityAccountLead>>;
  windProjects: Array<Maybe<WindProject>>;
  zipCode: ZipCode;
};

export type QueryAccountArgs = {
  id: Scalars['Int'];
  includeShellAccounts?: InputMaybe<Scalars['Boolean']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAccountClosureRequestFileDownloadUrlsArgs = {
  id: Scalars['Int'];
};

export type QueryAccountClosureRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryAdminLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type QueryAdminSamlLoginLinksArgs = {
  relayUrl: Scalars['String'];
};

export type QueryAdminTokenExchangeArgs = {
  loginToken: Scalars['String'];
};

export type QueryAdminUserArgs = {
  id: Scalars['Int'];
};

export type QueryAdminUsersArgs = {
  input?: InputMaybe<AdminUserInput>;
};

export type QueryAdvocacyRepresentativesArgs = {
  address: Scalars['String'];
};

export type QueryAttritionCategoriesArgs = {
  productId?: InputMaybe<Scalars['Int']>;
  productTarget?: InputMaybe<AttritionProductTarget>;
  productType?: InputMaybe<Scalars['String']>;
};

export type QueryBillPayServiceProductSubscriptionArgs = {
  id: Scalars['Int'];
};

export type QueryBillingExperienceOptionsArgs = {
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  enrollmentDataSourceName: EnrollmentOptionName;
  utilityId: Scalars['Int'];
};

export type QueryBulkProcessingRequestFileDownloadUrlsArgs = {
  id: Scalars['Int'];
};

export type QueryBulkProcessingRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryCalculateCsCreditArgs = {
  input: CreateCsCreditCalculationInput;
};

export type QueryCancelUserRewardArgs = {
  userId: Scalars['Int'];
};

export type QueryCleanKilowattHourArgs = {
  id: Scalars['Int'];
};

export type QueryCommunitySolarLeadArgs = {
  id: Scalars['Int'];
};

export type QueryCommunitySolarProjectGroupsArgs = {
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type QueryCommunitySolarStaticRuleGraphArgs = {
  input?: InputMaybe<StaticKeysInput>;
};

export type QueryCommunitySolarUtilityAccountArgs = {
  id: Scalars['Int'];
};

export type QueryCompletedAdvocacyCampaignArgs = {
  advocacyCampaignId: Scalars['Int'];
};

export type QueryContractArgs = {
  id: Scalars['Int'];
};

export type QueryContractAgreementArgs = {
  id: Scalars['Int'];
};

export type QueryContractFileIngestionHistoryArgs = {
  partnerSubscriberIngestionRequestId: Scalars['Int'];
};

export type QueryContractFileIngestionOverviewArgs = {
  input?: InputMaybe<ContractFileIngestionOverviewInput>;
};

export type QueryContractSetContractVersionsArgs = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  customerType: Scalars['String'];
  languageShortCode?: InputMaybe<Scalars['String']>;
  perchSfProductId: Scalars['String'];
  requireFico: Scalars['Boolean'];
};

export type QueryContractVersionArgs = {
  id: Scalars['Int'];
};

export type QueryContractVersionLanguageArgs = {
  id: Scalars['Int'];
};

export type QueryContractVersionLanguagesArgs = {
  contractVersionId?: InputMaybe<Scalars['Int']>;
  languageShortCode?: InputMaybe<Scalars['String']>;
};

export type QueryContractVersionPersonalizationRequestsArgs = {
  adminUserId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

export type QueryContractVersionsArgs = {
  contractType: ContractType;
  languageShortCode?: InputMaybe<Scalars['String']>;
};

export type QueryCountiesByZipArgs = {
  zipCode: Scalars['String'];
};

export type QueryCountyDataArgs = {
  id: Scalars['Int'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type QueryCreditArgs = {
  id?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCreditCorrectionArgs = {
  id: Scalars['Int'];
};

export type QueryCreditTypeArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCreditTypesArgs = {
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCsCreditCalculationArgs = {
  utilityStatementId: Scalars['Int'];
};

export type QueryCurrentContractVersionArgs = {
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  contractType: ContractType;
  languageShortCode?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Array<ContractTag>>;
};

export type QueryCurrentContractVersionsArgs = {
  contractType?: InputMaybe<ContractType>;
  internalName?: InputMaybe<Array<Scalars['String']>>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
};

export type QueryDisputeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryEgridSubregionArgs = {
  abbreviation: Scalars['String'];
};

export type QueryEligibleWinbackLeadsForCampaignArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  winbackCampaignFiltersAttributes: Array<InputMaybe<WinbackCampaignFiltersInput>>;
};

export type QueryEmailVerificationAttemptArgs = {
  promoCode: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type QueryEnrollUserRewardArgs = {
  input?: InputMaybe<EnrollUserRewardInput>;
  userId: Scalars['Int'];
};

export type QueryEnrollmentOptionsArgs = {
  utilityId: Scalars['Int'];
};

export type QueryExecutedContractArgs = {
  id: Scalars['Int'];
};

export type QueryExportArgs = {
  id: Scalars['Int'];
};

export type QueryFeaturedWindProjectArgs = {
  id: Scalars['Int'];
};

export type QueryFeaturedWindProjectsArgs = {
  month?: InputMaybe<StringRangeFilter>;
  monthEq?: InputMaybe<Scalars['String']>;
};

export type QueryFunnelBillingExperienceConfigurationArgs = {
  input: FunnelBillingExperienceConfigurationInput;
};

export type QueryFunnelConfigurationArgs = {
  customerType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  requireFico?: InputMaybe<Scalars['Boolean']>;
  utilityId: Scalars['Int'];
  zipCode: Scalars['Int'];
};

export type QueryFunnelPacketArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  customPlanId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type QueryFunnelQueryParamsArgs = {
  token: Scalars['String'];
};

export type QueryGeneralContractVersionsArgs = {
  contractType?: InputMaybe<Array<ContractType>>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Owner>;
};

export type QueryGetTokenUserRewardArgs = {
  userId: Scalars['Int'];
};

export type QueryGetUserRewardArgs = {
  userId: Scalars['Int'];
};

export type QueryGoogleLoginUrlArgs = {
  app: ArcadiaApp;
  language?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type QueryHasAdvocacyCampaignSubmissionArgs = {
  advocacyCampaignId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type QueryHostReportArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryHostReportItemsArgs = {
  ids: Array<Scalars['Int']>;
};

export type QueryIneligibilityReasonArgs = {
  id: Scalars['Int'];
};

export type QueryIngestionFileDownloadUrlsArgs = {
  id: Scalars['Int'];
};

export type QueryLineItemElementsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  utilityStatementId?: InputMaybe<Scalars['Int']>;
};

export type QueryLinkCheckArgs = {
  url: Scalars['String'];
};

export type QueryLmiProofDocLabelOptionsArgs = {
  category: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  utilityId: Scalars['Int'];
};

export type QueryLoadZoneArgs = {
  id: Scalars['Int'];
};

export type QueryLoadZonesArgs = {
  isVNMEligible?: InputMaybe<Scalars['Boolean']>;
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type QueryLookupUserRewardArgs = {
  userId: Scalars['Int'];
};

export type QueryLseArgs = {
  lseId: Scalars['ID'];
};

export type QueryMappingRequestsArgs = {
  sourceTariffName?: InputMaybe<Scalars['String']>;
  sourceUtilityId?: InputMaybe<Scalars['String']>;
};

export type QueryNeedsReviewReasonArgs = {
  id: Scalars['Int'];
};

export type QueryNextTaskArgs = {
  id: Scalars['Int'];
};

export type QueryOriginationSourceArgs = {
  userId: Scalars['Int'];
};

export type QueryOutboundEmailArgs = {
  id: Scalars['String'];
};

export type QueryPaginatedSolarProjectsArgs = {
  filters: PaginatedSolarProjectFilters;
};

export type QueryPartnerSubscriberIngestionRequestArgs = {
  id: Scalars['Int'];
};

export type QueryPaymentMethodArgs = {
  id: Scalars['Int'];
};

export type QueryPaymentTransactionArgs = {
  id: Scalars['Int'];
};

export type QueryPerchProductsForUtilityOrStateArgs = {
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type QueryPersonalizedSignupContractSetArgs = {
  input: PersonalizedSignupContractSetInput;
};

export type QueryPlanArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPlanBalancesArgs = {
  planId: Scalars['Int'];
};

export type QueryPlanTemplateArgs = {
  id: Scalars['Int'];
};

export type QueryPlanTemplatesArgs = {
  utilityId?: InputMaybe<Scalars['Int']>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryPreviewFileDownloadUrlArgs = {
  id: Scalars['Int'];
};

export type QueryProductLeadArgs = {
  id: Scalars['Int'];
};

export type QueryProductSubscriptionArgs = {
  id: Scalars['Int'];
};

export type QueryProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  productType?: InputMaybe<Scalars['String']>;
};

export type QueryPromoCodeArgs = {
  id: Scalars['Int'];
};

export type QueryPromoCodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryRateClassArgs = {
  id: Scalars['Int'];
};

export type QueryRateClassesArgs = {
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type QueryRefundReasonArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRefundReasonsArgs = {
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRemittanceMethodsArgs = {
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  type: RemittanceMethodType;
};

export type QueryRepresentativesArgs = {
  address: Scalars['String'];
  levels?: InputMaybe<Array<InputMaybe<Level>>>;
  roles?: InputMaybe<Array<InputMaybe<RepresentativeRole>>>;
};

export type QueryResolveFunnelConfigArgs = {
  countyId?: InputMaybe<Scalars['Int']>;
  customerType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  perchSfProductId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  requireFico?: InputMaybe<Scalars['Boolean']>;
  stateId?: InputMaybe<Scalars['Int']>;
  utilityId?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type QueryServiceUserLoginArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
};

export type QuerySessionsArgs = {
  app?: InputMaybe<SessionApp>;
  location?: InputMaybe<Scalars['String']>;
};

export type QuerySignNowDocumentGroupArgs = {
  id: Scalars['Int'];
};

export type QuerySignNowDocumentGroupByPlanArgs = {
  planId: Scalars['Int'];
};

export type QuerySignNowEnvelopeArgs = {
  id: Scalars['Int'];
};

export type QuerySignNowEnvelopeByUtilityAccountArgs = {
  contractType: Scalars['String'];
  utilityAccountId: Scalars['Int'];
};

export type QuerySignupContractSetsArgs = {
  id: Scalars['Int'];
};

export type QuerySignupContractTemplateContractVersionsArgs = {
  contractTypes?: InputMaybe<Array<ContractType>>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  signupContractTemplateId: Scalars['Int'];
};

export type QuerySmsLogsArgs = {
  inbound: Scalars['Boolean'];
  pageSize?: InputMaybe<Scalars['Int']>;
  to: Scalars['String'];
};

export type QuerySmsOfPageArgs = {
  pageUrl: Scalars['String'];
};

export type QueryStateArgs = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryStateContractVersionsArgs = {
  contractType?: InputMaybe<Array<ContractType>>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  stateId: Scalars['Int'];
};

export type QueryStatementArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};

export type QueryStatementTransactionsArgs = {
  filters?: InputMaybe<StatementTransactionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QuerySupplierArgs = {
  id: Scalars['Int'];
};

export type QuerySupplierStatementDetailArgs = {
  id: Scalars['Int'];
};

export type QuerySupplierStatementDetailsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryTaggedContractVersionsArgs = {
  contractType?: InputMaybe<Array<ContractType>>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  tag: Array<ContractTag>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
};

export type QueryTariffArgs = {
  masterTariffId: Scalars['ID'];
  options?: InputMaybe<GetTariffRequest>;
};

export type QueryTariffNormalizationArgs = {
  sourceTariffName: Scalars['String'];
  sourceUtilityId: Scalars['ID'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type QueryTariffNormalizationsArgs = {
  resolveQueries?: InputMaybe<Array<ResolutionParams>>;
};

export type QueryTariffsArgs = {
  masterTariffIds?: InputMaybe<Array<Scalars['ID']>>;
  options?: InputMaybe<GetTariffRequest>;
};

export type QueryTaskArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryTaskTypeArgs = {
  id: Scalars['Int'];
};

export type QueryThinkFileContentsArgs = {
  directory?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  nestedSubdirectory?: InputMaybe<Scalars['String']>;
  subdirectory?: InputMaybe<Scalars['String']>;
};

export type QueryThirdPartyUserArgs = {
  accessCode: Scalars['String'];
  app: ArcadiaApp;
  platform: ThirdPartyPlatform;
  state: Scalars['String'];
};

export type QueryThirdPartyUserLoginArgs = {
  accessCode: Scalars['String'];
  app: ArcadiaApp;
  platform: ThirdPartyPlatform;
  state: Scalars['String'];
};

export type QueryTokenExchangeArgs = {
  loginToken: Scalars['String'];
};

export type QueryUserArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryUserContractAgreementsArgs = {
  userId: Scalars['Int'];
};

export type QueryUserDuplicatesArgs = {
  input: UserDuplicatesInput;
};

export type QueryUserExistsArgs = {
  email: Scalars['String'];
};

export type QueryUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type QueryUserPromoCodeArgs = {
  promoCode: Scalars['String'];
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};

export type QueryUtilitiesArgs = {
  brokerable?: InputMaybe<Scalars['Boolean']>;
  manualBillExtractionEnabled?: InputMaybe<Scalars['Boolean']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  thinkEligible?: InputMaybe<Scalars['Boolean']>;
  vnmEligible?: InputMaybe<Scalars['Boolean']>;
};

export type QueryUtilitiesByZipArgs = {
  zipCode: Scalars['String'];
};

export type QueryUtilityArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryUtilityAccountArgs = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type QueryUtilityAccountLmiSourceTypeArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityAccountLmiSourceTypesArgs = {
  ids: Array<Scalars['Int']>;
};

export type QueryUtilityAccountsArgs = {
  accountId?: InputMaybe<Scalars['Int']>;
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  accountNumbers?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryUtilityCredentialArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityCredentialConnectTokenArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityCredentialSessionArgs = {
  utilityCredentialId: Scalars['Int'];
  uuid: Scalars['String'];
};

export type QueryUtilityEmailArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityEmailBodyArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityMappingArgs = {
  sourceUtilityId: Scalars['ID'];
};

export type QueryUtilityStatementArgs = {
  id: Scalars['Int'];
};

export type QueryUtilityStatementsArgs = {
  ids: Array<Scalars['Int']>;
};

export type QueryValidateEmailArgs = {
  email: Scalars['String'];
};

export type QueryVerifyEmailArgs = {
  email: Scalars['String'];
};

export type QueryVnmCampaignArgs = {
  id: Scalars['Int'];
};

export type QueryVnmCampaignBatchArgs = {
  id: Scalars['Int'];
};

export type QueryVnmCampaignBatchesArgs = {
  input: VnmCampaignBatchesInput;
};

export type QueryVnmCampaignsArgs = {
  input: VnmCampaignsInput;
};

export type QueryVnmContractUrlsArgs = {
  keys: Array<Scalars['String']>;
};

export type QueryVnmProductEligibilitiesArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryVnmSolarProjectArgs = {
  id: Scalars['Int'];
};

export type QueryVnmSolarProjectsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stateIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryVnmSolarProjectsByStateArgs = {
  stateId: Scalars['Int'];
};

export type QueryVnmSolarProjectsByUtilityArgs = {
  utilityConsolidatedBilling?: InputMaybe<Scalars['Boolean']>;
  utilityId: Scalars['Int'];
};

export type QueryVnmSubscriptionArgs = {
  id: Scalars['Int'];
};

export type QueryVnmSubscriptionUtilitySubmissionArgs = {
  id: Scalars['Int'];
};

export type QueryVnmSubscriptionUtilitySubmissionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryVnmUtilitySubmissionArgs = {
  id: Scalars['Int'];
};

export type QueryVnmUtilitySubmissionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryWinbackAccountLeadArgs = {
  id: Scalars['Int'];
};

export type QueryWinbackAccountLeadsArgs = {
  filters?: InputMaybe<WinbackAccountLeadFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryWinbackCallAttemptsArgs = {
  accountLeadId: Scalars['Int'];
};

export type QueryWinbackCampaignArgs = {
  id: Scalars['Int'];
};

export type QueryWinbackCampaignsArgs = {
  filters?: InputMaybe<WinbackCampaignFilterOptions>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryWinbackUtilityAccountLeadsArgs = {
  accountLeadId: Scalars['Int'];
};

export type QueryZipCodeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type RateClass = {
  id: Scalars['Int'];
  isBrokerable: Scalars['Boolean'];
  isVnmEligible: Scalars['Boolean'];
  masterTariffId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  utility: Utility;
};

export type RateClassString = {
  lastUsed: Scalars['String'];
  numUsages: Scalars['Int'];
  rateClassName?: Maybe<Scalars['String']>;
  utilityId: Scalars['Int'];
  utilityName: Scalars['String'];
};

export enum RateUnit {
  Block = 'BLOCK',
  BlockSellBack = 'BLOCK_SELL_BACK',
  CostPerUnit = 'COST_PER_UNIT',
  Percentage = 'PERCENTAGE',
}

export type ReactivatePlan = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ReactivationEligibility = {
  eligible: Scalars['Boolean'];
  reasons?: Maybe<Array<Scalars['String']>>;
};

export type RecordPaymentInput = {
  amountCents: Scalars['Int'];
  paidOn: Scalars['Date'];
  paymentMethodDetails?: InputMaybe<Scalars['JSON']>;
  paymentMethodType: Scalars['String'];
  statementId: Scalars['Int'];
};

export type Referral = {
  bonusEarned: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  referredUser?: Maybe<ReferredUser>;
  sentDate?: Maybe<Scalars['Date']>;
  signedUp: Scalars['Boolean'];
  status: Scalars['String'];
};

export type ReferralSummary = {
  eligibleForThousandBonusCount: Scalars['Int'];
  /** The total number of referrals with 'Joined' status */
  joinedCount: Scalars['Int'];
  /** Total number of referral requests sent, with no matching signup */
  notSignedUpCount: Scalars['Int'];
  /** The total number of referrals with 'Pending' status - which means they signed up, but are not yet active */
  pendingCount: Scalars['Int'];
  /** The total number of referrals that have signed up (joined and pending) */
  signedUpCount: Scalars['Int'];
  totalBonusEarnedCents: Scalars['Int'];
  /** Total potential referrals - includes both referral requests sent, and actual signups */
  totalCount: Scalars['Int'];
};

export type ReferredAccount = {
  id: Scalars['Int'];
  planType: Scalars['String'];
  status: Scalars['String'];
};

export type ReferredUser = {
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  referredAccounts: Array<Maybe<ReferredAccount>>;
  signUpDate?: Maybe<Scalars['Date']>;
};

export type RefundInput = {
  amountCents: Scalars['Int'];
  statementId: Scalars['Int'];
};

export type RefundReason = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type RefundTransaction = {
  amountCents: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  refundReason: RefundReason;
  sandboxed: Scalars['Boolean'];
  status: Scalars['String'];
  stripeRefundId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

export type ReissueEcheckInput = {
  id: Scalars['Int'];
  remittanceItemIds?: InputMaybe<Array<Scalars['Int']>>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  statementIds: Array<Scalars['Int']>;
};

export enum RejectionReason {
  BlurryImg = 'blurry_img',
  CannotReadRequiredInfo = 'cannot_read_required_info',
  CustomerInfoCutoff = 'customer_info_cutoff',
  ExpiredProof = 'expired_proof',
  IllegibleImg = 'illegible_img',
  ImageDoesNotIncludePrgName = 'image_does_not_include_prg_name',
  InvalidSignature = 'invalid_signature',
  LastNameMismatched = 'last_name_mismatched',
  MedicareCardUploaded = 'medicare_card_uploaded',
  MissingIssueDateOrExpirationDate = 'missing_issue_date_or_expiration_date',
  NoLiheapFound = 'no_liheap_found',
  NoMatchNameOrId = 'no_match_name_or_id',
  NotEligibleForIra = 'not_eligible_for_ira',
  NotMedicaid = 'not_medicaid',
  NotValidProgram = 'not_valid_program',
  Other = 'other',
  ProofDoesNotHaveName = 'proof_does_not_have_name',
  ProofTypeDoesNotMatchProgramType = 'proof_type_does_not_match_program_type',
  SmallImg = 'small_img',
  WrongState = 'wrong_state',
}

export type RemittanceBatch = {
  achAmountCents?: Maybe<Scalars['Int']>;
  achPaymentFile?: Maybe<AchPaymentFile>;
  createdAt: Scalars['Datetime'];
  echeckAmountCents?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  tenantId: Scalars['Int'];
  totalAmountCents?: Maybe<Scalars['Int']>;
};

export type RemittanceBatchFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type RemittanceBatchesResponse = {
  count: Scalars['Int'];
  records: Array<Maybe<RemittanceBatch>>;
  totalCount: Scalars['Int'];
};

export type RemittanceDetails = {
  checkNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  effectiveEntryDate?: Maybe<Scalars['Datetime']>;
  increaseAchTransferId?: Maybe<Scalars['String']>;
  paymentFileName?: Maybe<Scalars['String']>;
  remittanceMethodType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  utility?: Maybe<Utility>;
  utilityId?: Maybe<Scalars['Int']>;
  utilityRemittanceId?: Maybe<Scalars['Int']>;
};

export type RemittanceItem = {
  account?: Maybe<Account>;
  amountCents: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  remittedAt?: Maybe<Scalars['Datetime']>;
  scheduledAt?: Maybe<Scalars['Datetime']>;
  status: Scalars['String'];
  utilityAccountNumber: Scalars['String'];
  utilityStatement: UtilityStatement;
};

export type RemittanceMethod = {
  details: RemittanceMethodDetails;
  id: Scalars['Int'];
  seagullUtilityId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

export type RemittanceMethodDetails = AchRemittanceMethodDetails | EcheckRemittanceMethodDetails;

export enum RemittanceMethodType {
  Ach = 'ach',
  Echeck = 'echeck',
}

export type RemovePromoCodeInput = {
  userId: Scalars['Int'];
};

export type RemovePromoCodeOutput = {
  user?: Maybe<User>;
};

export type Representative = {
  email?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type RepresentativeInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export enum RepresentativeRole {
  CityCouncilMember = 'cityCouncilMember',
  HouseRepresentative = 'houseRepresentative',
  Senator = 'senator',
}

export type ResendDocuSignEmailInput = {
  contractType?: InputMaybe<Scalars['String']>;
  tabsData?: InputMaybe<TabsDataInput>;
  userId: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
};

export type ResendDocuSignEmailOutput = {
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ResolutionParams = {
  sourceTariffName?: InputMaybe<Scalars['String']>;
  sourceUtilityId?: InputMaybe<Scalars['ID']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ResolveFunnelConfig = {
  countyProjectMatch?: Maybe<CountyProjectMatch>;
  isCapacityAvailable?: Maybe<Scalars['Boolean']>;
  paymentProvider?: Maybe<PaymentProvider>;
  perchSfProductId?: Maybe<Scalars['String']>;
  productSignupContractTemplateIds?: Maybe<Scalars['JSON']>;
  projectDetails?: Maybe<Scalars['JSON']>;
  proofDocRequirement?: Maybe<PerchProductProofDocRequirement>;
  requireFicoCheck?: Maybe<Scalars['Boolean']>;
  requireFicoCheckForDefaultProduct?: Maybe<Scalars['Boolean']>;
  requireFicoCheckForLmiProduct?: Maybe<Scalars['Boolean']>;
  savingsPercentage?: Maybe<Scalars['Float']>;
  signUpContractTemplateId?: Maybe<Scalars['Int']>;
  supportedCustomerTypes?: Maybe<Array<Scalars['String']>>;
};

export type ResolveTasksInput = {
  taskIds: Array<Scalars['Int']>;
};

export type ResolveWinbackAccountLeadInput = {
  id: Scalars['Int'];
};

export enum Role {
  AdvancedManager = 'advanced_manager',
  BillingTaskManager = 'billing_task_manager',
  BillingsManager = 'billings_manager',
  BulkCancelationManager = 'bulk_cancelation_manager',
  CustomerManager = 'customer_manager',
  Deactivated = 'deactivated',
  Engineer = 'engineer',
  None = 'none',
  RetentionAdmin = 'retention_admin',
  RetentionManager = 'retention_manager',
  Service = 'service',
  SolarAdvancedManager = 'solar_advanced_manager',
  SolarUserManager = 'solar_user_manager',
  Superadmin = 'superadmin',
  User = 'user',
  UtilityRemittanceAuditor = 'utility_remittance_auditor',
}

export type RuleContext = {
  projectGroups?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<Scalars['String']>>;
  utilities?: Maybe<Array<Scalars['String']>>;
};

export type RuleStatusFilter = {
  ruleKey: Scalars['String'];
  ruleStatuses: Array<Scalars['String']>;
};

export type S3Directory = {
  bucketName: Scalars['String'];
  contents?: Maybe<S3DirectoryContents>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type S3DirectoryContents = {
  files: Array<S3File>;
  folders?: Maybe<Array<S3Folder>>;
};

export type S3File = {
  displayUrl?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type S3Folder = {
  name?: Maybe<Scalars['String']>;
};

export type S3UploadInput = {
  data: Scalars['String'];
  fileName: Scalars['String'];
  key: Scalars['String'];
};

export type SalesforceCountyOption = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SalesforceInstance {
  Arcadia = 'Arcadia',
  Perch = 'Perch',
}

export type ScraperActivity = {
  activityType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  details?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorUrl?: Maybe<Scalars['String']>;
  htmlUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  screenshotUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ScraperRequest = {
  createdAt: Scalars['Datetime'];
  executionTime?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  scraperIdentifier?: Maybe<Scalars['String']>;
  scraperType?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  success?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['Datetime']>;
  uuid?: Maybe<Scalars['String']>;
  waitTime?: Maybe<Scalars['Float']>;
};

export type ScraperRequestFinished = {
  scraperRequestUuid: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ScraperRequestInput = {
  purposeCode: PurposeCode;
  utilityAccountId: Scalars['Int'];
};

export type ScraperRequestOutput = {
  error?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export enum ScraperStatus {
  Error = 'error',
  Neutral = 'neutral',
  Pending = 'pending',
  Unknown = 'unknown',
  Valid = 'valid',
}

export type SeagullPlan = {
  id: Scalars['Int'];
  signedGlobalId: Scalars['String'];
};

export type Search = {
  _empty?: Maybe<Scalars['String']>;
  achTransfers: AchTransfersSearchResponse;
  achUtilityRemittances: AchUtilityRemittancesResponse;
  billPayServiceProductLeads: BillPayServiceProductLeadSearchResult;
  billingChangeHistory: VersionHistoryResponse;
  communitySolarRuleStatuses: CommunitySolarRuleStatusesResponse;
  disputes: DisputeResponse;
  echecks: EchecksResponse;
  hostReports: HostReportsSearchResponse;
  lses: LseSearchResults;
  plans: PlansResponse;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  remittanceBatches: RemittanceBatchesResponse;
  statements: StatementSearchResult;
  tariffs: TariffSearchResults;
  tasks: TasksResponse;
  userChangeHistory: VersionHistoryResponse;
  users: UsersResponse;
  utilities: UtilitiesResponse;
  utilityAccountLmiSourceTypes: FacetedUtilityAccountLmiSourceTypeResponse;
  utilityAccounts: UtilityAccountsSearchResponse;
  utilityEmails: UtilityEmailsResponse;
  vnmProductEligibilities?: Maybe<FacetedVnmProductEligibilitiesResponse>;
  vnmSolarProjects?: Maybe<VnmSolarProjectsSearchResponse>;
  vnmSubscriptions?: Maybe<FacetedVnmSubscriptionsResponse>;
};

export type SearchAchTransfersArgs = {
  filters?: InputMaybe<AchTransferFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchAchUtilityRemittancesArgs = {
  filters?: InputMaybe<AchUtilityRemittanceFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchBillPayServiceProductLeadsArgs = {
  filters: BillPayServiceProductLeadFilters;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort: SortBillPayServiceProductLeadOptions;
};

export type SearchBillingChangeHistoryArgs = {
  filters: BillingChangeHistoryFilters;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchCommunitySolarRuleStatusesArgs = {
  filters: CommunitySolarRuleFilters;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type SearchDisputesArgs = {
  filters?: InputMaybe<DisputesFilterOptions>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchEchecksArgs = {
  filters?: InputMaybe<EcheckFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type SearchHostReportsArgs = {
  filters?: InputMaybe<HostReportFilterOptions>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type SearchLsesArgs = {
  filters?: InputMaybe<GetLsEsRequest>;
  requestOptions?: InputMaybe<BaseRequest>;
};

export type SearchPlansArgs = {
  filters: PlansFilterOptions;
  limit: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  page: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<PlanSortOptions>;
};

export type SearchReferralsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type SearchRemittanceBatchesArgs = {
  filters?: InputMaybe<RemittanceBatchFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchStatementsArgs = {
  filters?: InputMaybe<StatementSearchFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type SearchTariffsArgs = {
  filters?: InputMaybe<GetTariffsRequest>;
  requestOptions?: InputMaybe<BaseRequest>;
};

export type SearchTasksArgs = {
  filters?: InputMaybe<TasksFilterOptions>;
  limit: Scalars['Int'];
  order?: InputMaybe<TasksOrder>;
  page: Scalars['Int'];
  sort?: InputMaybe<TasksSortOptions>;
};

export type SearchUserChangeHistoryArgs = {
  filters?: InputMaybe<UserChangeHistoryFilters>;
  id: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
};

export type SearchUsersArgs = {
  filters?: InputMaybe<UserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  sort?: InputMaybe<UserSortOptions>;
};

export type SearchUtilitiesArgs = {
  filters?: InputMaybe<UtilityFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<UtilitySortOption>;
};

export type SearchUtilityAccountLmiSourceTypesArgs = {
  filters: UtilityAccountLmiSourceTypeFilters;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type SearchUtilityAccountsArgs = {
  filters: UtilityAccountsSearchFilterOptions;
  limit: Scalars['Int'];
  order?: InputMaybe<UtilityAccountsOrder>;
  page: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<UtilityAccountsSortOption>;
};

export type SearchUtilityEmailsArgs = {
  filters?: InputMaybe<UtilityEmailFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  preFivePM?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UtilityEmailStatus>;
};

export type SearchVnmProductEligibilitiesArgs = {
  filters: VnmProductEligibilitiesFilters;
  limit: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  page: Scalars['Int'];
  sort?: InputMaybe<Scalars['String']>;
};

export type SearchVnmSolarProjectsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  search: Scalars['String'];
};

export type SearchVnmSubscriptionsArgs = {
  filters: VnmSubscriptionFilters;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type Season = {
  fromEdgePredominance?: Maybe<PredominanceRule>;
  lseId?: Maybe<Scalars['ID']>;
  seasonFromDay?: Maybe<Scalars['Int']>;
  seasonFromMonth?: Maybe<Scalars['Int']>;
  seasonGroupId?: Maybe<Scalars['ID']>;
  seasonId: Scalars['ID'];
  seasonName?: Maybe<Scalars['String']>;
  seasonToDay?: Maybe<Scalars['Int']>;
  seasonToMonth?: Maybe<Scalars['Int']>;
  toEdgePredominance?: Maybe<PredominanceRule>;
};

export type SendEmailResponse = {
  message?: Maybe<Scalars['String']>;
};

export type SendEnvelopesFromPortalReportInput = {
  csv: Scalars['JSON'];
};

export type SendEnvelopesFromPortalReportOutput = {
  notFound?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ServiceAddressInput = {
  city: Scalars['String'];
  state: Scalars['String'];
  streetOne: Scalars['String'];
  streetTwo?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export enum ServiceType {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
  SolarPv = 'SOLAR_PV',
}

export type Session = {
  adminUser?: Maybe<AdminUser>;
  adminUserId: Scalars['Int'];
  app: SessionApp;
  expiration: Scalars['Datetime'];
  id: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
};

export enum SessionApp {
  Osprey = 'osprey',
}

export type SessionsPresent = {
  app: SessionApp;
  sessions: Array<Session>;
};

export type SetBillingAddressPayload = {
  success: Scalars['Boolean'];
};

export type SetPaymentMethodInput = {
  paymentMethodId: Scalars['Int'];
  planId: Scalars['Int'];
};

export type SetPaymentMethodOnPlansInput = {
  paymentMethodId: Scalars['Int'];
  planIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type SetPaymentMethodOnPlansOutput = {
  updatedPlans: Array<Plan>;
};

export type SignNowDocumentGroup = {
  envelopeIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
  inviteExpiresAt?: Maybe<Scalars['Datetime']>;
  signingUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  userId: Scalars['Int'];
};

export type SignNowEnvelope = {
  id: Scalars['Int'];
  inviteExpiresAt?: Maybe<Scalars['Datetime']>;
  personalizedContractId: Scalars['Int'];
  signingUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type SignUpContractTemplate = {
  id?: Maybe<Scalars['Int']>;
  paymentProvider?: Maybe<PaymentProvider>;
  proofDocRequirement: PerchProductProofDocRequirement;
  savingsPercentage?: Maybe<Scalars['Float']>;
  supportedCustomerTypes?: Maybe<Array<Scalars['String']>>;
};

export type SignUpUserInput = {
  billingExperienceType: BillingExperienceOptionName;
  enrollmentDataSourceName: EnrollmentOptionName;
  funnelVnmProjectId?: InputMaybe<Scalars['Int']>;
  planId: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
  track: Scalars['String'];
  utilityAccountId: Scalars['Int'];
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
};

export type SignupContractSet = {
  contracts: Array<Maybe<ContractVersion>>;
};

export type SignupContractTemplate = {
  contractSet?: Maybe<SignupContractSet>;
};

export type SignupFunnelLead = {
  docusignService?: Maybe<Scalars['JSON']>;
  enrollmentScreen?: Maybe<Scalars['JSON']>;
  esignScreen?: Maybe<Scalars['JSON']>;
  esignService?: Maybe<Scalars['JSON']>;
  funnelPlanId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  legalScreen?: Maybe<Scalars['JSON']>;
  lmiZoneVerificationService?: Maybe<Scalars['JSON']>;
  mailingAddressScreen?: Maybe<Scalars['JSON']>;
  otherAttributes?: Maybe<Scalars['JSON']>;
  paymentScreen?: Maybe<Scalars['JSON']>;
  paymentService?: Maybe<Scalars['JSON']>;
  proofDocUploadScreen?: Maybe<Scalars['JSON']>;
  selfAttestationScreen?: Maybe<Scalars['JSON']>;
  userId: Scalars['Int'];
  userScreen?: Maybe<Scalars['JSON']>;
  utilityAccountsDetailsScreen?: Maybe<Scalars['JSON']>;
  utilityConnectService?: Maybe<Scalars['JSON']>;
  utilityScreen?: Maybe<Scalars['JSON']>;
};

export type SnoozeTasksInput = {
  adminUserId: Scalars['Int'];
  snoozeUntil: Scalars['String'];
  taskIds: Array<Scalars['Int']>;
};

export type SolarDeveloperRemittanceItem = {
  amountCents: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  hostReportItemId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lineItemId?: Maybe<Scalars['Int']>;
  partnerStripeId?: Maybe<Scalars['String']>;
  projectIdentifier?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  remittedAt?: Maybe<Scalars['Datetime']>;
  serviceEndDate?: Maybe<Scalars['Datetime']>;
  serviceStartDate?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  stripeDestinationPaymentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  utilityAccountId?: Maybe<Scalars['String']>;
  utilityAccountNumber?: Maybe<Scalars['String']>;
  utilityStatementId?: Maybe<Scalars['String']>;
  vnmSubscriptionId?: Maybe<Scalars['Int']>;
};

export type SolarLineItem = FormattedLineItem & {
  amountCents: Scalars['Int'];
  beforeSavings: Scalars['Int'];
  entryType: LineItemEntryType;
  id: Scalars['String'];
  /**
   * Indicates a line item with $0 amount, but with a VNM subscription in "billed" status,
   * which means there will probably be credits in the future.
   */
  isDelayedCredit: Scalars['Boolean'];
  isPreCredit: Scalars['Boolean'];
  key: LineItemKey;
  name: Scalars['String'];
  sandboxed: Scalars['Boolean'];
  savings: Scalars['Int'];
  savingsPercentage: Scalars['Float'];
  /**
   * may not be present depending on statement metadata captured at the time
   * or if on dual billing
   */
  utilityStatement?: Maybe<UtilityStatement>;
  /**
   * may not be present depending on statement metadata captured at the time
   * or if on dual billing
   */
  utilityStatementId?: Maybe<Scalars['Int']>;
  vnmSolarProject?: Maybe<VnmSolarProject>;
  vnmSolarProjectId?: Maybe<Scalars['Int']>;
  vnmSubscriptionStatus?: Maybe<VnmEnrollmentStatus>;
};

export enum SolarProjectType {
  ArcadiaRemittingProject = 'arcadia_remitting_project',
  UtilityRemittingProject = 'utility_remitting_project',
}

export enum SortBillPayServiceProductLeadOptions {
  UserCreatedAt = 'user_created_at',
  UserFirstName = 'user_first_name',
  UtilityName = 'utility_name',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SourceFile = {
  url: Scalars['String'];
};

export enum SourceType {
  HostReportItem = 'HostReportItem',
  ProductSubscription = 'ProductSubscription',
}

export type SponsorshipAvailability = {
  availableSponsorshipSpots: Scalars['Int'];
  filledSponsorshipSpots: Scalars['Int'];
  totalSponsorshipSpots: Scalars['Int'];
};

export type SponsorshipInvitationInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  sponsorAccountId: Scalars['Int'];
};

export type State = {
  abbreviation: Scalars['String'];
  activeAdvocacyCampaign?: Maybe<AdvocacyCampaign>;
  /** @deprecated use avgKwhCost instead */
  avgKwh: Scalars['Float'];
  avgKwhCost: Scalars['Float'];
  /** average cost in cents per kwh */
  avgKwhUsage: Scalars['Float'];
  /** average kwh usage per month */
  coal: Scalars['Float'];
  id: Scalars['Int'];
  medicaidCardRequiresThirdPartyVerification: Scalars['Boolean'];
  mostRecentCompletedAdvocacyCampaign?: Maybe<CompletedAdvocacyCampaign>;
  name: Scalars['String'];
  naturalGas: Scalars['Float'];
  nuclear: Scalars['Float'];
  petroleum: Scalars['Float'];
  renewables: Scalars['Float'];
  requireCommunicationPreference: Scalars['Boolean'];
  utilities: Array<Maybe<Utility>>;
  vnmSolarProjectsStatistics: VnmStateStatistics;
};

export type Statement = {
  account: Account;
  collectAutomatically: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  createdEvent?: Maybe<AuditLogEvent>;
  csv: Scalars['String'];
  cumulativeSolarSavingsCents: Scalars['Int'];
  delayPaymentUrl: Scalars['String'];
  delayable: Scalars['Boolean'];
  dueDate?: Maybe<Scalars['Date']>;
  /**
   * True when this statement is the FIRST statement which includes solar savings
   * for this plan.
   * See includesSolarSavings
   */
  firstStatementWithSolarSavings: Scalars['Boolean'];
  hostReportItemIds: Array<Scalars['Int']>;
  hostReportItems: Array<HostReportItem>;
  hostReportSolarKwh?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /**
   * True when this statement includes a utility charge line item, aka "bundled billing"
   * May be false if non-utility charges are in a separate statement, for some reason,
   * even if the account normally uses "bundled billing"
   */
  includesBundledUtilityCharge: Scalars['Boolean'];
  /**
   * True when this statement includes savings due to a solar project, aka VNM
   * May be false even if the account is enrolled in VNM, if there are no solar savings
   * in this statement.
   */
  includesSolarSavings: Scalars['Boolean'];
  invoicePDFDetails: StatementPdfDetails;
  invoiceUrl?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  issuedEvents?: Maybe<Array<Maybe<AuditLogEvent>>>;
  kwh: Kwh;
  lineItemCount: Scalars['Int'];
  lineItemSummary: LineItemSummary;
  lineItems: Array<LineItem>;
  lineItemsFormatted: Array<FormattedLineItem>;
  maxDelayDate?: Maybe<Scalars['Date']>;
  mostRecentPaymentTransaction?: Maybe<PaymentTransaction>;
  paidAmountCents: Scalars['Int'];
  paidAt?: Maybe<Scalars['Date']>;
  paymentScheduledAt?: Maybe<Scalars['Date']>;
  paymentTransactions: Array<PaymentTransaction>;
  plan: Plan;
  refundableAmountCents: Scalars['Int'];
  refundedAmountCents: Scalars['Int'];
  remittanceDetails?: Maybe<RemittanceDetails>;
  reviewFlags: Array<StatementReviewFlag>;
  sandboxed: Scalars['Boolean'];
  serviceAddresses: Array<Scalars['String']>;
  /**
   * Use this field to handle the common "special case" when a Statement is tied
   * to one (and only one) UtilityStatement.
   * If there are multiple UtilityStatements, this field is null
   */
  singleUtilityStatement?: Maybe<UtilityStatement>;
  skipRemittance?: Maybe<Scalars['Boolean']>;
  solarDeveloperRemittanceItems: Array<SolarDeveloperRemittanceItem>;
  source: Scalars['String'];
  statistics?: Maybe<StatementStatistics>;
  status: StatementStatus;
  stripeTransfers: Array<StripeTransfer>;
  total: Scalars['Int'];
  /**
   * Includes all line items (such as discounts and membership fees), so slightly different than
   * lineItemSummary.totalWithoutArcadia
   */
  totalBeforeSolarSavings: Scalars['Int'];
  /**
   * Amount the member saved, due to their VNM subscription(s), on this statement.
   * @deprecated use lineItemSummary.totalSolarSavingsCents
   */
  totalSolarSavingsCents: Scalars['Int'];
  unpaidAmountCents: Scalars['Int'];
  utilityRemittances?: Maybe<Array<RemittanceDetails>>;
  /** @deprecated A Statement may have multiple UtilityStatements - use the utilityStatements field */
  utilityStatement?: Maybe<UtilityStatement>;
  utilityStatementIds: Array<Scalars['Int']>;
  utilityStatements: Array<UtilityStatement>;
};

export enum StatementAction {
  Collect = 'collect',
  Delay = 'delay',
  Issue = 'issue',
  IssueAndCollect = 'issue_and_collect',
  Pause = 'pause',
  Stop = 'stop',
  Void = 'void',
}

export type StatementActionInput = {
  action: StatementAction;
  paymentScheduledAt?: InputMaybe<Scalars['String']>;
  statementId: Scalars['Int'];
};

export type StatementIssuedInput = {
  accountId?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum StatementOrigin {
  Penguin = 'PENGUIN',
  Seagull = 'SEAGULL',
}

export type StatementPdfDetails = {
  invoicePdfFile?: Maybe<Scalars['String']>;
  invoicePdfGeneratedAt?: Maybe<Scalars['Datetime']>;
  invoicePdfUrl?: Maybe<Scalars['String']>;
  statementId: Scalars['Int'];
};

export type StatementReviewFlag = {
  id: Scalars['Int'];
  reason: Scalars['String'];
};

export type StatementSearchFilters = {
  accountId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<DateRangeFilter>;
  issuedAt?: InputMaybe<DateRangeFilter>;
  planId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

export type StatementSearchResult = {
  data: Array<Statement>;
  resultCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type StatementStatistics = {
  totalCharge?: Maybe<TotalChargeStatistics>;
};

export enum StatementStatus {
  Collecting = 'collecting',
  Issued = 'issued',
  Paid = 'paid',
  Paused = 'paused',
  PaymentFailed = 'payment_failed',
  PendingApproval = 'pending_approval',
  PendingIssue = 'pending_issue',
  Stopped = 'stopped',
  Unissued = 'unissued',
  Unknown = 'unknown',
  Void = 'void',
}

export type StatementTransaction = {
  account?: Maybe<Account>;
  amountCents: Scalars['Int'];
  declineCount?: Maybe<Scalars['Int']>;
  finishedAt?: Maybe<Scalars['Date']>;
  paymentMethod?: Maybe<PaymentMethodType>;
  paymentScheduledAt?: Maybe<Scalars['Date']>;
  settlementCode?: Maybe<Scalars['String']>;
  settlementDetails?: Maybe<Scalars['String']>;
  statementCreatedAt: Scalars['Date'];
  statementId: Scalars['Int'];
  statementStatus: Scalars['String'];
  transactionCreatedAt?: Maybe<Scalars['Date']>;
  transactionStatus?: Maybe<Scalars['String']>;
};

export type StatementTransactionFilters = {
  accountStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  finishedAt?: InputMaybe<DateRangeFilter>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethodType>>>;
  settlementCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statementStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StatementTransactionsResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<Maybe<StatementTransaction>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StatementV2 = {
  accountId?: Maybe<Scalars['Int']>;
  balanceCents: Scalars['Int'];
  collectAutomatically: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  dueDate?: Maybe<Scalars['Date']>;
  epAccountId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoicePdfGeneratedAt?: Maybe<Scalars['Datetime']>;
  invoiceUrl?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  netPaymentTerms?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['Datetime']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentScheduledAt?: Maybe<Scalars['Datetime']>;
  planId: Scalars['Int'];
  scheduledIssueDate?: Maybe<Scalars['Datetime']>;
  sgAccountId: Scalars['Int'];
  status: Scalars['String'];
  stoppedReason?: Maybe<Scalars['String']>;
  totalAmountCents: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

export type StaticKeysInput = {
  projectGroupName?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  utilityName?: InputMaybe<Scalars['String']>;
};

export type StaticRule = {
  context?: Maybe<ContextScope>;
  key: Scalars['String'];
};

export type StringRangeFilter = {
  gteq?: InputMaybe<Scalars['String']>;
  lteq?: InputMaybe<Scalars['String']>;
};

export type StringUpdate = UtilityAccountUpdate & {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type StripeTransfer = {
  amountCents: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  feeCents?: Maybe<Scalars['Int']>;
  fundApplicationId: Scalars['Int'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['JSON']>;
  stripeId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SubscriberRequirement = {
  dependencies: Array<SubscriberRequirement>;
  key: Scalars['String'];
  status: SubscriberRequirementStatus;
};

export enum SubscriberRequirementStatus {
  Invalid = 'invalid',
  Pending = 'pending',
  Valid = 'valid',
}

export type Subscription = {
  _empty?: Maybe<Scalars['String']>;
  accountDetailsScrapeFinished: ScraperRequestFinished;
  billingHistoriesScrapeFinished: BillingHistoryFinished;
  exportCompleted: ExportCompleted;
  latestBillingScrapeFinished: ScraperRequestFinished;
  paymentMethodCreated: PaymentMethod;
  processCreateOptOutPeriod?: Maybe<ProcessCreateOptOutPeriod>;
  sessionsPresent: SessionsPresent;
  /** subscribe to all resolved tasks or a specific task id */
  taskCreated?: Maybe<TaskCreated>;
  taskResolved?: Maybe<TaskResolved>;
  updateAccountSettingsScrapeFinished: ScraperRequestFinished;
  utilityCredentialScrapeFinished: UtilityCredentialScrapeFinished;
  vnmCampaignBatchCompleted: VnmCampaignBatchCompletedOutput;
  vnmCampaignCompleted: VnmCampaignCompletedOutput;
  vnmUtilitySubmissionCompleted?: Maybe<VnmUtilitySubmissionCompleted>;
  vnmUtilitySubmissionScraperCompleted?: Maybe<VnmUtilitySubmissionScraperCompleted>;
};

export type SubscriptionAccountDetailsScrapeFinishedArgs = {
  scraperRequestUuid: Scalars['String'];
};

export type SubscriptionBillingHistoriesScrapeFinishedArgs = {
  scraperRequestUuid: Scalars['String'];
};

export type SubscriptionExportCompletedArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionLatestBillingScrapeFinishedArgs = {
  scraperRequestUuid: Scalars['String'];
};

export type SubscriptionPaymentMethodCreatedArgs = {
  accountId: Scalars['Int'];
};

export type SubscriptionProcessCreateOptOutPeriodArgs = {
  optOutPeriodId?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionSessionsPresentArgs = {
  app?: InputMaybe<SessionApp>;
};

export type SubscriptionTaskCreatedArgs = {
  assigneeId?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionTaskResolvedArgs = {
  assigneeId?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionUpdateAccountSettingsScrapeFinishedArgs = {
  scraperRequestUuid: Scalars['String'];
};

export type SubscriptionUtilityCredentialScrapeFinishedArgs = {
  id?: InputMaybe<Scalars['Int']>;
  scraperRequestUuid?: InputMaybe<Scalars['String']>;
};

export type SubscriptionVnmCampaignBatchCompletedArgs = {
  adminUserId?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionVnmCampaignCompletedArgs = {
  vnmCampaignBatchId?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionVnmUtilitySubmissionCompletedArgs = {
  id: Scalars['Int'];
};

export type SubscriptionVnmUtilitySubmissionScraperCompletedArgs = {
  id: Scalars['Int'];
};

export type SubscriptionStatistics = {
  allocated?: Maybe<Scalars['Int']>;
  billed?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Int']>;
  dropRequested?: Maybe<Scalars['Int']>;
  droppedFromProject?: Maybe<Scalars['Int']>;
  enrolled?: Maybe<Scalars['Int']>;
  optedOut?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
  pendingCancelation?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  sentToUtility?: Maybe<Scalars['Int']>;
  waitlist?: Maybe<Scalars['Int']>;
};

export enum SubscriptionStatus {
  Active = 'active',
  Available = 'available',
  Inactive = 'inactive',
  Ineligible = 'ineligible',
  Pending = 'pending',
  Unavailable = 'unavailable',
}

export type Supplier = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  supplierTariffs?: Maybe<Array<Maybe<TariffString>>>;
};

export type SupplierStatementDetail = {
  accountNumber?: Maybe<Scalars['String']>;
  budgetBill?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  currentSupplyRate?: Maybe<Scalars['Float']>;
  disconnectionNotice?: Maybe<Scalars['Boolean']>;
  finalBill?: Maybe<Scalars['Boolean']>;
  firstBill?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  loadZone?: Maybe<LoadZone>;
  municipalAggregation?: Maybe<Scalars['Boolean']>;
  netMetered?: Maybe<Scalars['Boolean']>;
  pastDue?: Maybe<Scalars['Boolean']>;
  pastDueAmount?: Maybe<Scalars['Float']>;
  rateClass?: Maybe<RateClass>;
  rateClassId?: Maybe<Scalars['Int']>;
  rateClassName?: Maybe<Scalars['String']>;
  secondaryAccountIdentifier?: Maybe<Scalars['String']>;
  serviceAddressCity?: Maybe<Scalars['String']>;
  serviceAddressState?: Maybe<Scalars['String']>;
  serviceAddressStreetOne?: Maybe<Scalars['String']>;
  serviceAddressStreetTwo?: Maybe<Scalars['String']>;
  serviceAddressZip?: Maybe<Scalars['String']>;
  serviceCustomerName?: Maybe<Scalars['String']>;
  sosSupply?: Maybe<Scalars['Boolean']>;
  statementDate: Scalars['Date'];
  supplier?: Maybe<Supplier>;
  supplierName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  utilityStatement?: Maybe<UtilityStatement>;
};

export type SupportedAppVersion = {
  appStoreLink?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  minimumBuildNumber: Scalars['Float'];
  playStoreLink?: Maybe<Scalars['String']>;
  showLink: Scalars['Boolean'];
  title: Scalars['String'];
};

export type SyncLmiSourceTypesInput = {
  userId: Scalars['Int'];
};

export type SyncLmiSourceTypesOutput = {
  synced: Scalars['Boolean'];
};

export type TabsDataInput = {
  county?: InputMaybe<Scalars['String']>;
  houseIncome?: InputMaybe<Scalars['String']>;
  houseOccupancy?: InputMaybe<Scalars['String']>;
  lmiProgram?: InputMaybe<Scalars['String']>;
};

export type Tariff = {
  billingPeriod?: Maybe<ChargePeriod>;
  chargePeriod?: Maybe<Array<Maybe<ChargePeriod>>>;
  chargeTypes?: Maybe<Array<Maybe<ChargeType>>>;
  closedDate?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customerClass?: Maybe<CustomerClass>;
  customerCount?: Maybe<Scalars['Int']>;
  customerCountSource?: Maybe<Scalars['String']>;
  customerLikelihood?: Maybe<Scalars['Float']>;
  distributionLseId?: Maybe<Scalars['ID']>;
  documents?: Maybe<Array<Maybe<TariffDocument>>>;
  effectiveDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  hasContractedRates?: Maybe<Scalars['Boolean']>;
  hasNetMetering?: Maybe<Scalars['Boolean']>;
  hasRateApplicability?: Maybe<Scalars['Boolean']>;
  hasTariffApplicability?: Maybe<Scalars['Boolean']>;
  hasTieredRates?: Maybe<Scalars['Boolean']>;
  hasTimeOfUseRates?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lseCode?: Maybe<Scalars['String']>;
  lseId: Scalars['ID'];
  lseName: Scalars['String'];
  masterTariffId: Scalars['ID'];
  maxMonthlyConsumption?: Maybe<Scalars['Float']>;
  maxMonthlyDemand?: Maybe<Scalars['Float']>;
  minMonthlyConsumption?: Maybe<Scalars['Float']>;
  minMonthlyDemand?: Maybe<Scalars['Float']>;
  priorTariffId?: Maybe<Scalars['ID']>;
  privacy?: Maybe<PrivacyFlag>;
  properties?: Maybe<Array<Maybe<TariffProperty>>>;
  rates?: Maybe<Array<Maybe<TariffRate>>>;
  serviceType?: Maybe<ServiceType>;
  tariffBookName?: Maybe<Scalars['String']>;
  tariffCode: Scalars['String'];
  tariffId: Scalars['ID'];
  tariffName: Scalars['String'];
  tariffType?: Maybe<TariffType>;
  territoryId?: Maybe<Scalars['ID']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type TariffCost = {
  chargeType: Scalars['String'];
  cost: Scalars['Float'];
  fromDateTime?: Maybe<Scalars['String']>;
  itemQuantity: Scalars['Float'];
  rateAmount: Scalars['Float'];
  rateGroupName: Scalars['String'];
  rateName: Scalars['String'];
  toDateTime?: Maybe<Scalars['String']>;
};

export type TariffDocument = {
  document: Document;
  documentId: Scalars['ID'];
  documentSectionId: Scalars['ID'];
  tariffId: Scalars['ID'];
};

export type TariffNormalization = {
  mappedPropertyInputs?: Maybe<Array<NormalizationPropertyKey>>;
  mappedTariff: MappedTariff;
  mappedTariffId?: Maybe<Scalars['ID']>;
  mappingRequestCount?: Maybe<MappingRequestCount>;
  missingPropertyInputs?: Maybe<Array<NormalizationPropertyKey>>;
  serviceAreaZipCodeMappingsLoaded?: Maybe<Scalars['Boolean']>;
  sourceTariffName: Scalars['String'];
  sourceUtilityId: Scalars['ID'];
  territoryInputZipCodeMappingsLoaded?: Maybe<Scalars['Boolean']>;
};

export type TariffProperty = {
  choices?: Maybe<Array<Maybe<GenPropertyChoice>>>;
  dataType?: Maybe<PropertyDataType>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<Scalars['String']>;
  family: Scalars['String'];
  formulaDetail?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  keyName: Scalars['String'];
  keyspace: Scalars['String'];
  lookbackIntervalQuantity?: Maybe<Scalars['Int']>;
  lookbackPeriod?: Maybe<Scalars['String']>;
  lookbackQuantity?: Maybe<Scalars['Int']>;
  lookbackSeasonId?: Maybe<Scalars['ID']>;
  lookbackTimeOfUseId?: Maybe<Scalars['ID']>;
  maxValue?: Maybe<Scalars['String']>;
  minValue?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  period?: Maybe<TimeOfUseType>;
  privacy?: Maybe<PrivacyFlag>;
  propertyTypes?: Maybe<TariffPropertyType>;
  propertyValue?: Maybe<Scalars['String']>;
  quantityKey?: Maybe<Scalars['String']>;
  quantityUnit?: Maybe<Scalars['String']>;
  subKeyname?: Maybe<Scalars['String']>;
};

export enum TariffPropertyType {
  Applicability = 'APPLICABILITY',
  Benefit = 'BENEFIT',
  DataReputation = 'DATA_REPUTATION',
  Info = 'INFO',
  RateCriteria = 'RATE_CRITERIA',
  ServiceTerms = 'SERVICE_TERMS',
}

export type TariffRate = {
  applicabilityKey?: Maybe<Scalars['String']>;
  chargeClass?: Maybe<Array<Maybe<ChargeClass>>>;
  chargePeriod?: Maybe<ChargePeriod>;
  chargeType?: Maybe<ChargeType>;
  edgePredominance?: Maybe<PredominanceRule>;
  fromDateTime?: Maybe<Scalars['String']>;
  masterTariffRateId?: Maybe<Scalars['ID']>;
  prorationRules?: Maybe<Array<Maybe<ProrationRule>>>;
  quantityKey?: Maybe<Scalars['String']>;
  rateBands?: Maybe<Array<Maybe<TariffRateBand>>>;
  rateGroupName: Scalars['String'];
  rateName: Scalars['String'];
  riderId: Scalars['ID'];
  riderTariffId?: Maybe<Scalars['ID']>;
  season?: Maybe<Season>;
  tariffId?: Maybe<Scalars['ID']>;
  tariffRateId: Scalars['ID'];
  tariffSequenceNumber?: Maybe<Scalars['Int']>;
  territory?: Maybe<Territory>;
  timeOfUse?: Maybe<TimeOfUse>;
  toDateTime?: Maybe<Scalars['String']>;
  transactionType?: Maybe<TransactionType>;
  variableFactorKey?: Maybe<Scalars['String']>;
  variableLimitKey?: Maybe<Scalars['String']>;
  variableRateKey?: Maybe<Scalars['String']>;
};

export type TariffRateBand = {
  applicabilityValue?: Maybe<Scalars['String']>;
  calculationFactor?: Maybe<Scalars['Float']>;
  consumptionUpperLimit?: Maybe<Scalars['Float']>;
  demandUpperLimit?: Maybe<Scalars['Float']>;
  hasConsumptionLimit?: Maybe<Scalars['Boolean']>;
  hasDemandLimit?: Maybe<Scalars['Boolean']>;
  hasPropertyLimit?: Maybe<Scalars['Boolean']>;
  isCredit?: Maybe<Scalars['Boolean']>;
  propertyUpperLimit?: Maybe<Scalars['Float']>;
  rateAmount?: Maybe<Scalars['Float']>;
  rateSequenceNumber?: Maybe<Scalars['Int']>;
  rateUnit?: Maybe<RateUnit>;
  tariffRateBandId?: Maybe<Scalars['ID']>;
  tariffRateId?: Maybe<Scalars['ID']>;
};

export type TariffSearchResults = {
  count?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Tariff>>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TariffString = {
  examplePdf?: Maybe<Scalars['String']>;
  lastUsed: Scalars['String'];
  lseType: Scalars['String'];
  numUsages: Scalars['Int'];
  tariffName?: Maybe<Scalars['String']>;
  utilityId: Scalars['Int'];
  utilityName: Scalars['String'];
};

export enum TariffType {
  Alternative = 'ALTERNATIVE',
  Default = 'DEFAULT',
  Incentive = 'INCENTIVE',
  OptionalExtra = 'OPTIONAL_EXTRA',
  Proposed = 'PROPOSED',
  Rider = 'RIDER',
}

export type Task = {
  account?: Maybe<Account>;
  assignee?: Maybe<AdminUser>;
  billStartDate?: Maybe<Scalars['Date']>;
  billingQueueItem?: Maybe<BillingQueueItem>;
  createdAt: Scalars['Datetime'];
  emailParsingResult?: Maybe<EmailParsingResult>;
  history?: Maybe<Array<Maybe<TaskHistoryEvent>>>;
  id: Scalars['Int'];
  lastBilledAt?: Maybe<Scalars['Datetime']>;
  notes: Array<Note>;
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['Int']>;
  resolvedAt?: Maybe<Scalars['Datetime']>;
  scraperStatus?: Maybe<Scalars['String']>;
  snoozedAt?: Maybe<Scalars['Datetime']>;
  snoozedBy?: Maybe<AdminUser>;
  snoozedUntil?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  targetUtilityAccountIds: Array<Scalars['Int']>;
  taskCenterType?: Maybe<TaskCenterType>;
  taskType?: Maybe<TaskType>;
  taskableId?: Maybe<Scalars['Int']>;
  taskableType?: Maybe<Scalars['String']>;
  utility?: Maybe<Utility>;
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  utilityAccountStatus?: Maybe<Scalars['String']>;
  utilityCredential?: Maybe<UtilityCredential>;
  utilityCredentialId?: Maybe<Scalars['Int']>;
  utilityStatement?: Maybe<UtilityStatement>;
};

export type TaskAccountArgs = {
  includeShellAccounts?: InputMaybe<Scalars['Boolean']>;
};

export enum TaskCenterType {
  Arc = 'arc',
  Arcadia = 'arcadia',
}

export type TaskCreated = {
  assigneeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type TaskHistoryEvent = {
  date?: Maybe<Scalars['Datetime']>;
  type?: Maybe<TaskHistoryEventType>;
};

export enum TaskHistoryEventType {
  Created = 'created',
  Resolved = 'resolved',
  Snoozed = 'snoozed',
  Unsnoozed = 'unsnoozed',
}

export type TaskResolved = {
  assigneeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type TaskType = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type TasksFilterOptions = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  billingSettingCollectAutomatically?: InputMaybe<Scalars['Boolean']>;
  billingSettingOfflineInvoicing?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<DateRangeFilter>;
  resolvedAt?: InputMaybe<DateRangeFilter>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  scraperStatuses?: InputMaybe<Array<InputMaybe<ScraperStatus>>>;
  snoozed?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taskCenterType?: InputMaybe<TaskCenterType>;
  taskTypes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityAccountStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  utilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum TasksOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type TasksResponse = {
  resultCount: Scalars['Int'];
  tasks: Array<Maybe<Task>>;
};

export enum TasksSortOptions {
  BillStartDate = 'billStartDate',
  CreatedAt = 'createdAt',
  LastBilledAt = 'lastBilledAt',
  ResolvedAt = 'resolvedAt',
  SnoozedUntil = 'snoozedUntil',
  UtilityName = 'utilityName',
}

export type Tenant = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export type Territory = {
  centerPoint?: Maybe<CenterPoint>;
  deregCandi?: Maybe<Scalars['Boolean']>;
  deregRes?: Maybe<Scalars['Boolean']>;
  itemTypes?: Maybe<Array<Maybe<ItemType>>>;
  items?: Maybe<Array<Maybe<TerritoryItem>>>;
  lseId: Scalars['ID'];
  lseName: Scalars['String'];
  parentTerritoryId?: Maybe<Scalars['ID']>;
  territoryId: Scalars['ID'];
  territoryLses?: Maybe<Array<Maybe<TerritoryLse>>>;
  territoryName: Scalars['String'];
  usageType?: Maybe<UsageType>;
};

export type TerritoryItem = {
  exclude?: Maybe<Scalars['Boolean']>;
  partial?: Maybe<Scalars['Boolean']>;
  territoryItemId: Scalars['ID'];
  territoryType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TerritoryLse = {
  distribution?: Maybe<Scalars['Boolean']>;
  generalCoverage?: Maybe<Scalars['Float']>;
  lseId?: Maybe<Scalars['ID']>;
  lseName?: Maybe<Scalars['String']>;
  residentialCoverage?: Maybe<Scalars['Float']>;
  supplierGeneral?: Maybe<Scalars['Boolean']>;
  supplierResidential?: Maybe<Scalars['Boolean']>;
  territoryId: Scalars['ID'];
};

export type ThinkFileContents = {
  content?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum ThirdPartyPlatform {
  Google = 'google',
}

export type ThirdPartyUser = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type TimeOfUse = {
  calendarId?: Maybe<Scalars['ID']>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  lseId?: Maybe<Scalars['ID']>;
  privacy?: Maybe<Scalars['String']>;
  season?: Maybe<Season>;
  touGroupId?: Maybe<Scalars['ID']>;
  touId: Scalars['ID'];
  touName?: Maybe<Scalars['String']>;
  touPeriods?: Maybe<Array<Maybe<TimeOfUsePeriod>>>;
  touType?: Maybe<TimeOfUseType>;
};

export type TimeOfUseGroup = {
  lseId: Scalars['ID'];
  timeOfUses?: Maybe<Array<Maybe<TimeOfUse>>>;
  touGroupId: Scalars['ID'];
};

export type TimeOfUseInterval = {
  fromDateTime?: Maybe<Scalars['String']>;
  toDateTime?: Maybe<Scalars['String']>;
  touGroupId?: Maybe<Scalars['ID']>;
  touId: Scalars['ID'];
  touName?: Maybe<Scalars['String']>;
};

export type TimeOfUsePeriod = {
  fromDayOfWeek?: Maybe<Scalars['Int']>;
  fromHour?: Maybe<Scalars['Int']>;
  fromMinute?: Maybe<Scalars['Int']>;
  toDayOfWeek?: Maybe<Scalars['Int']>;
  toHour?: Maybe<Scalars['Int']>;
  toMinute?: Maybe<Scalars['Int']>;
  touId?: Maybe<Scalars['ID']>;
  touPeriodId: Scalars['ID'];
};

export enum TimeOfUseType {
  CriticalPeak = 'CRITICAL_PEAK',
  OffPeak = 'OFF_PEAK',
  OnPeak = 'ON_PEAK',
  PartialPeak = 'PARTIAL_PEAK',
  SuperOffPeak = 'SUPER_OFF_PEAK',
  SuperOnPeak = 'SUPER_ON_PEAK',
}

export type TimeZone = {
  name?: Maybe<Scalars['String']>;
  tzinfoName?: Maybe<Scalars['String']>;
};

export type Tip = {
  businessTip?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  effortRequired: Scalars['Int'];
  headline: Scalars['String'];
  id: Scalars['Int'];
  savings: Scalars['Int'];
};

export type ToggleSkipRemittanceInput = {
  skip: Scalars['Boolean'];
  statementId: Scalars['Int'];
};

export type TotalChargeStatistics = {
  current?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Int']>;
  previous?: Maybe<Scalars['Int']>;
};

export enum TransactionType {
  Buy = 'BUY',
  BuyImport = 'BUY_IMPORT',
  Net = 'NET',
  Sell = 'SELL',
  SellExport = 'SELL_EXPORT',
}

export type TriggerVnmUtilitySubmissionScraperInput = {
  submissionType: VnmUtilitySubmissionScraperType;
  vnmUtilitySubmissionId: Scalars['Int'];
};

export type UnassignTasksInput = {
  taskIds: Array<InputMaybe<Scalars['Int']>>;
};

export type UnassignWinbackAccountLeadsInput = {
  accountLeadIds: Array<Scalars['Int']>;
};

export type UnparsedQueryParams = {
  annualizedUsageEstimate?: Maybe<Scalars['Int']>;
  meterNumber?: Maybe<Scalars['String']>;
  secondaryAccountId?: Maybe<Scalars['String']>;
  utilityAccountNumber?: Maybe<Scalars['String']>;
};

export type UnsnoozeTasksInput = {
  taskIds: Array<Scalars['Int']>;
};

export type UpdateAccountClosureRequestInput = {
  rejectionReason?: InputMaybe<Scalars['String']>;
  requestId: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdateAccountInput = {
  billStartDate?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  isMdu?: InputMaybe<Scalars['Boolean']>;
  legalDispute?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['Int']>;
  transitionBillingExclusion?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAccountKwhInput = {
  kwh?: InputMaybe<Scalars['Int']>;
};

export type UpdateAnnualizedUsageEstimateInput = {
  annualizedUsageEstimate?: InputMaybe<Scalars['Int']>;
};

export type UpdateAssociatedSupplierStatementDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  rateClassId?: InputMaybe<Scalars['Int']>;
  rateClassName?: InputMaybe<Scalars['String']>;
};

export type UpdateBillPayServiceProductEligibilityInput = {
  reasons?: InputMaybe<Array<Scalars['String']>>;
  status: BillPayServiceProductEligibilityStatus;
};

export type UpdateBillPayServiceProductSubscriptionInput = {
  billStartDate: Scalars['String'];
  id: Scalars['Int'];
};

export type UpdateBulkProcessingRequestInput = {
  rejectionReason?: InputMaybe<Scalars['String']>;
  requestId: Scalars['Int'];
  status: Scalars['String'];
};

export type UpdateContractInput = {
  displayName: Scalars['String'];
};

export type UpdateContractVersionPersonalizationRequestInput = {
  status: Scalars['String'];
};

export type UpdateCredentialCredentialsInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UpdateCredentialGeneralInput = {
  overrideEmail?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
};

export type UpdateCredentialUtilityInput = {
  accountId: Scalars['Int'];
  utilityId: Scalars['Int'];
};

export type UpdateCreditInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  creditTypeKey?: InputMaybe<Scalars['String']>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  userCreditId: Scalars['Int'];
};

export type UpdateCustomerSnapshotInput = {
  funnelError?: InputMaybe<Scalars['String']>;
  funnelStatus?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  utilityConnectStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerSnapshotResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLineItemInput = {
  amountCents: Scalars['Int'];
  lineItemTypeKey: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  partnerAccountId?: InputMaybe<Scalars['String']>;
  remittanceAmountCents?: InputMaybe<Scalars['Int']>;
};

export type UpdateMeterInput = {
  id: Scalars['Int'];
  meterNumber: Scalars['String'];
};

export type UpdateMoveRequestInput = {
  id: Scalars['Int'];
  newPlanNickname?: InputMaybe<Scalars['String']>;
  newUtilityAccountId?: InputMaybe<Scalars['Int']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type UpdateNoteInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  taskId?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  type: NoteType;
  userId?: InputMaybe<Scalars['Int']>;
};

export type UpdateNotificationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  read?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNotificationsInput = {
  ids: Array<Scalars['Int']>;
  read: Scalars['Boolean'];
};

export type UpdatePlanInput = {
  billingSettingsDetails?: InputMaybe<BillingSettingsInput>;
  name?: InputMaybe<Scalars['String']>;
  netPaymentTerms?: InputMaybe<Scalars['Int']>;
  nextBillDate?: InputMaybe<Scalars['Date']>;
  paymentMethodId?: InputMaybe<Scalars['Int']>;
};

export type UpdateProductLeadInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billStartDate?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdateRuleInput = {
  ruleKey: Scalars['String'];
  utilityAccountId: Scalars['Int'];
};

export type UpdateRuleResponse = {
  utilityAccountId: Scalars['Int'];
};

export type UpdateSessionInput = {
  app: SessionApp;
  id: Scalars['String'];
  location: Scalars['String'];
};

export type UpdateSignNowEnvelopeInput = {
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateSignupFunnelLeadInput = {
  docusignService?: InputMaybe<Scalars['JSON']>;
  enrollmentScreen?: InputMaybe<Scalars['JSON']>;
  esignScreen?: InputMaybe<Scalars['JSON']>;
  esignService?: InputMaybe<Scalars['JSON']>;
  legalScreen?: InputMaybe<Scalars['JSON']>;
  lmiZoneVerificationService?: InputMaybe<Scalars['JSON']>;
  mailingAddressScreen?: InputMaybe<Scalars['JSON']>;
  otherAttributes?: InputMaybe<Scalars['JSON']>;
  paymentScreen?: InputMaybe<Scalars['JSON']>;
  paymentService?: InputMaybe<Scalars['JSON']>;
  proofDocUploadScreen?: InputMaybe<Scalars['JSON']>;
  selfAttestationScreen?: InputMaybe<Scalars['JSON']>;
  userScreen?: InputMaybe<Scalars['JSON']>;
  utilityAccountsDetailsScreen?: InputMaybe<Scalars['JSON']>;
  utilityConnectService?: InputMaybe<Scalars['JSON']>;
  utilityScreen?: InputMaybe<Scalars['JSON']>;
};

export type UpdateStatementInput = {
  autoIssue?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  lineItems?: InputMaybe<Array<InputMaybe<UpdateLineItemInput>>>;
  paymentScheduledAt?: InputMaybe<Scalars['String']>;
  reapplyCredits?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateSupplierStatementDetailInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  budgetBill?: InputMaybe<Scalars['Boolean']>;
  currentSupplyRate?: InputMaybe<Scalars['Float']>;
  disconnectionNotice?: InputMaybe<Scalars['Boolean']>;
  finalBill?: InputMaybe<Scalars['Boolean']>;
  firstBill?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  loadZoneId?: InputMaybe<Scalars['Int']>;
  municipalAggregation?: InputMaybe<Scalars['Boolean']>;
  netMetered?: InputMaybe<Scalars['Boolean']>;
  pastDue?: InputMaybe<Scalars['Boolean']>;
  pastDueAmount?: InputMaybe<Scalars['Float']>;
  rateClassId?: InputMaybe<Scalars['Int']>;
  rateClassName?: InputMaybe<Scalars['String']>;
  secondaryAccountIdentifier?: InputMaybe<Scalars['String']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressState?: InputMaybe<Scalars['String']>;
  serviceAddressStreetOne?: InputMaybe<Scalars['String']>;
  serviceAddressStreetTwo?: InputMaybe<Scalars['String']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  serviceCustomerName?: InputMaybe<Scalars['String']>;
  sosSupply?: InputMaybe<Scalars['Boolean']>;
  supplierName?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  communicationPreferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** This field or skipCurrentPasswordConfirmation is required if a User is updating their password */
  currentPassword?: InputMaybe<Scalars['String']>;
  doNotCall?: InputMaybe<Scalars['Boolean']>;
  dormantPromoCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  languageShortCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  metaData?: InputMaybe<Scalars['JSON']>;
  originationSourceAttributes?: InputMaybe<UserOriginationSourceInput>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  skipCurrentPasswordConfirmation?: InputMaybe<Scalars['Boolean']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPreferencesInput = {
  enabledGoogleSignIn: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type UpdateUserTipInput = {
  completed: Scalars['Boolean'];
  userId: Scalars['Int'];
  userTipId: Scalars['Int'];
};

export type UpdateUtilityAccountDetailInput = {
  requiresAffirmativeConsent?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUtilityAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  annualizedUsageEstimate?: InputMaybe<Scalars['Int']>;
  autopayDisabled?: InputMaybe<Scalars['Boolean']>;
  billUploadIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  budgetBilling?: InputMaybe<Scalars['Boolean']>;
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  ebillDisabled?: InputMaybe<Scalars['Boolean']>;
  enrollmentDataSourceName?: InputMaybe<EnrollmentOptionName>;
  estimatedMonthlyKwh?: InputMaybe<Scalars['Int']>;
  hasRooftopSolar?: InputMaybe<Scalars['Boolean']>;
  highlights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is60Days?: InputMaybe<Scalars['Boolean']>;
  isMultiAccount?: InputMaybe<Scalars['Boolean']>;
  loadZoneId?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameKeyForEdi?: InputMaybe<Scalars['String']>;
  noEbill?: InputMaybe<Scalars['Boolean']>;
  nonArcadiaCommunitySolar?: InputMaybe<Scalars['Boolean']>;
  pastDueAmount?: InputMaybe<Scalars['Float']>;
  rateClassId?: InputMaybe<Scalars['Int']>;
  scraperEnabled?: InputMaybe<Scalars['Boolean']>;
  secondaryAccountIdentifier?: InputMaybe<Scalars['String']>;
  serviceAddress?: InputMaybe<Scalars['String']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressState?: InputMaybe<Scalars['String']>;
  serviceAddressStreetOne?: InputMaybe<Scalars['String']>;
  serviceAddressStreetTwo?: InputMaybe<Scalars['String']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  serviceCustomerName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  utilityCredentialId?: InputMaybe<Scalars['Int']>;
};

export type UpdateUtilityAccountLmiSourceTypeInput = {
  documentType?: InputMaybe<Scalars['String']>;
  lmiProofDocUploadId?: InputMaybe<Scalars['Int']>;
  lmiProofNumber?: InputMaybe<Scalars['String']>;
  lmiSourceTypeName?: InputMaybe<Scalars['String']>;
  nameInProof?: InputMaybe<Scalars['String']>;
  proofExpirationDate?: InputMaybe<Scalars['Date']>;
  proofIssueDate?: InputMaybe<Scalars['Date']>;
  reasonMessage?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<RejectionReason>;
  serviceStartDate?: InputMaybe<Scalars['Date']>;
  statementDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateUtilityCredentialInput = {
  accountId?: InputMaybe<Scalars['Int']>;
  credentials?: InputMaybe<UpdateCredentialCredentialsInput>;
  general?: InputMaybe<UpdateCredentialGeneralInput>;
  highlights?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overrideEmail?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  utility?: InputMaybe<UpdateCredentialUtilityInput>;
  utilityId?: InputMaybe<Scalars['Int']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
};

export type UpdateUtilityEmailsInput = {
  filters?: InputMaybe<UtilityEmailFilters>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  status: UtilityEmailStatus;
};

export type UpdateUtilityEmailsOutput = {
  ids: Array<Scalars['Int']>;
};

export type UpdateUtilityStatementInput = {
  arcVnmBillCredits?: InputMaybe<Scalars['Float']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  carryForwardCredits?: InputMaybe<Scalars['Float']>;
  carryForwardKwh?: InputMaybe<Scalars['Int']>;
  carryoverCredits?: InputMaybe<Scalars['Float']>;
  cdgSubscriptionFee?: InputMaybe<Scalars['Float']>;
  closingCreditsBalance?: InputMaybe<Scalars['Float']>;
  creditsAppliedThisPeriod?: InputMaybe<Scalars['Float']>;
  creditsExpired?: InputMaybe<Scalars['Float']>;
  creditsReceived?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['String']>;
  expiringVnmKwh?: InputMaybe<Scalars['Int']>;
  fixedPercentage?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  kwh?: InputMaybe<Scalars['Int']>;
  meterNumbers?: InputMaybe<Array<Scalars['String']>>;
  openingCreditsBalance?: InputMaybe<Scalars['Float']>;
  preVnmServiceCharge?: InputMaybe<Scalars['Float']>;
  rawVnmData?: InputMaybe<Scalars['JSON']>;
  recRatio?: InputMaybe<Scalars['Float']>;
  serviceEndDate?: InputMaybe<Scalars['String']>;
  serviceStartDate?: InputMaybe<Scalars['String']>;
  statementDate?: InputMaybe<Scalars['String']>;
  supplierStatementDetail?: InputMaybe<UpdateAssociatedSupplierStatementDetailInput>;
  utilityCharge?: InputMaybe<Scalars['Float']>;
  vnmAppliedKwh?: InputMaybe<Scalars['Int']>;
  vnmBillCredits?: InputMaybe<Scalars['Float']>;
  vnmProductionCredits?: InputMaybe<Scalars['Float']>;
  vnmProductionKwh?: InputMaybe<Scalars['Int']>;
};

export type UpdateUtilityThinkEligibilitiesInput = {
  thinkEligible: Scalars['Boolean'];
  utilityIds: Array<Scalars['Int']>;
};

export type UpdateUtilityThinkEligibilitiesOutput = {
  query: Query;
  utilityIds: Array<Scalars['Int']>;
};

export type UpdateVnmProductEligibilityInput = {
  reasons?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
  statusFrozen?: InputMaybe<Scalars['Boolean']>;
  utilityAccountId: Scalars['Int'];
};

export type UpdateVnmProductEligibilityOutput = {
  id: Scalars['Int'];
};

export type UpdateVnmSolarProjectInput = {
  creditWaitPeriod?: InputMaybe<Scalars['Int']>;
  editWindowDays?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  siteIdentifier?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  targetCoverage?: InputMaybe<Scalars['Float']>;
  targetUsageFactor?: InputMaybe<Scalars['Float']>;
  timeZone?: InputMaybe<Scalars['String']>;
  vnmPartnerId?: InputMaybe<Scalars['Int']>;
};

export type UpdateVnmSubscriptionInput = {
  cancelationRequestedDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  optOutEndDate?: InputMaybe<Scalars['String']>;
  optOutStartDate?: InputMaybe<Scalars['String']>;
  savingsRate?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
};

export type UpdateWinbackUtilityAccountLeadStatusInput = {
  accountLeadId: Scalars['Int'];
  status: Scalars['String'];
  utilityAccountLeadIds: Array<Scalars['Int']>;
};

export type UploadFileOutput = {
  ETag?: Maybe<Scalars['String']>;
  VersionId?: Maybe<Scalars['String']>;
};

export type UploadIpaFormInput = {
  file: Scalars['String'];
  originalFilename: Scalars['String'];
};

export type UploadIpaFormOutput = {
  key: Scalars['String'];
};

export type Usage = {
  billingDays?: Maybe<Scalars['Int']>;
  endingRead?: Maybe<Scalars['Float']>;
  endingReadAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  initialRead?: Maybe<Scalars['Float']>;
  initialReadAt?: Maybe<Scalars['Datetime']>;
  meterId: Scalars['Int'];
  multiplier?: Maybe<Scalars['Float']>;
  previousUtilityStatement?: Maybe<PreviousUtilityStatement>;
  readingType?: Maybe<Scalars['String']>;
  supplierRate?: Maybe<Scalars['Float']>;
  totalUsage?: Maybe<Scalars['Int']>;
  utilityStatementId: Scalars['Int'];
};

export enum UsageType {
  ClimateZone = 'CLIMATE_ZONE',
  Service = 'SERVICE',
  Tariff = 'TARIFF',
  UtilityClimateZone = 'UTILITY_CLIMATE_ZONE',
}

export type User = {
  accounts: Array<Account>;
  address?: Maybe<Scalars['String']>;
  advocacyRepresentatives: Array<Representative>;
  allPlansPerchManaged: Scalars['Boolean'];
  ambassador?: Maybe<Ambassador>;
  availableCredits?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  communicationPreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  contactAddress?: Maybe<Address>;
  contractAgreements: Array<ContractAgreement>;
  createdAt: Scalars['Datetime'];
  credits?: Maybe<Array<Maybe<Credit>>>;
  /** all of the notifications under a user (and their accounts and utility accounts) that are high priority or unread. rendered in lovebird under the current tab */
  currentNotifications: Array<Notification>;
  /** all of the notifications under a user (and their accounts and utility accounts) that are high or low priority. rendered in lovebird on the dashboard page */
  dashboardNotifications: Array<Notification>;
  dashboardUrl: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['Date']>;
  doNotCall: Scalars['Boolean'];
  docuSignClickwraps?: Maybe<Array<DocuSignClickwrap>>;
  docuSignEnvelope?: Maybe<DocuSignEnvelope>;
  docuSignEnvelopes: Array<DocuSignEnvelope>;
  dormantIncentive?: Maybe<Incentive>;
  dormantPromoCode?: Maybe<PromoCode>;
  email: Scalars['String'];
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  firstName: Scalars['String'];
  fullAddress: Scalars['String'];
  /** Returns a JWT to make requests as this user. Only available in development. */
  gryphonToken: Scalars['String'];
  hasSignedSelfAttestationContract: Scalars['Boolean'];
  id: Scalars['Int'];
  idle: Scalars['Boolean'];
  individualPromoCodes: Array<Maybe<IndividualPromoCode>>;
  jobTitle?: Maybe<Scalars['String']>;
  languageShortCode: Scalars['String'];
  lastName: Scalars['String'];
  lmiProofDocs: Array<Maybe<LmiProofDocs>>;
  membershipStatus?: Maybe<MembershipStatus>;
  metaData?: Maybe<Scalars['JSON']>;
  migratedToAdm: Scalars['Boolean'];
  migratedToAdmAt?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  notes: Array<Note>;
  originationSource?: Maybe<UserOriginationSource>;
  passwordResetUrl: Scalars['String'];
  /** all of the notifications under a user (and their accounts and utility accounts) that are low or update priority and are read. rendered in lovebird under the past tab */
  pastNotifications: Array<Notification>;
  perchAcquired: Scalars['Boolean'];
  phone?: Maybe<Scalars['String']>;
  preferences: UserPreferences;
  primaryAccount: Account;
  /** @deprecated Use signupPromoCode instead. */
  promoCode?: Maybe<PromoCode>;
  redirectApp: Scalars['String'];
  redirectUrl: Scalars['String'];
  referralSummary: ReferralSummary;
  referralValueCents: Scalars['Int'];
  referrals?: Maybe<Array<Maybe<Referral>>>;
  representatives?: Maybe<Array<Representative>>;
  sandboxed: Scalars['Boolean'];
  shareableReferralCode: Scalars['String'];
  signedAgencyContract?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use signupPromoCode.code or signupReferralCode.code instead. */
  signupCode?: Maybe<Scalars['String']>;
  signupFunnelLead?: Maybe<SignupFunnelLead>;
  /** @deprecated Use signupIncentives instead. */
  signupIncentive?: Maybe<Incentive>;
  signupIncentives: Array<Incentive>;
  signupPromoCode?: Maybe<PromoCode>;
  signupReferralCode?: Maybe<UserPromoCode>;
  tenant: Tenant;
  updatedAt: Scalars['Datetime'];
  userDocuSignEnvelopes?: Maybe<Array<Maybe<UserDocuSignEnvelopes>>>;
  userReward?: Maybe<UserReward>;
  userTips?: Maybe<Array<Maybe<UserTip>>>;
  /** @deprecated If you believe this is necessary, post your use case in core-data-model-upgrade. */
  utilities: Array<Maybe<Utility>>;
  /** @deprecated Use account.utilityAccounts instead. */
  utilityAccounts: Array<Maybe<UtilityAccount>>;
  /** @deprecated Use account.utilityCredentials instead. */
  utilityCredentials: Array<Maybe<UtilityCredential>>;
  zip?: Maybe<Scalars['String']>;
  zipCode: ZipCode;
};

export type UserAccountsArgs = {
  includeShellAccounts?: InputMaybe<Scalars['Boolean']>;
};

export type UserAdvocacyRepresentativesArgs = {
  address: Scalars['String'];
};

export type UserDocuSignEnvelopeArgs = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type UserDocuSignEnvelopesArgs = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type UserPasswordResetUrlArgs = {
  queryParams?: InputMaybe<Scalars['String']>;
};

export type UserRedirectUrlArgs = {
  app?: InputMaybe<ArcadiaApp>;
  path?: InputMaybe<Scalars['String']>;
  queryParams?: InputMaybe<Scalars['String']>;
  tokenType?: InputMaybe<Scalars['String']>;
};

export type UserReferralsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  signedUp?: InputMaybe<Scalars['Boolean']>;
};

export type UserRepresentativesArgs = {
  address: Scalars['String'];
  levels?: InputMaybe<Array<InputMaybe<Level>>>;
  roles?: InputMaybe<Array<InputMaybe<RepresentativeRole>>>;
};

export type UserChangeHistoryFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  events?: InputMaybe<Array<VersionHistoryEventType>>;
  itemTypes?: InputMaybe<Array<Scalars['String']>>;
  whodunnit?: InputMaybe<Scalars['Int']>;
  whodunnitType?: InputMaybe<Array<Scalars['String']>>;
};

export type UserDocuSignEnvelopes = {
  completedFile?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  envelopeUpdatedAt?: Maybe<Scalars['String']>;
  personalizedContractId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserDuplicatesInput = {
  username: Scalars['String'];
  utilityCredentialId: Scalars['Int'];
  utilityId: Scalars['Int'];
};

export type UserFilters = {
  activeProductLeads?: InputMaybe<Array<Scalars['String']>>;
  activeProductSubscriptions?: InputMaybe<Array<Scalars['String']>>;
  promoCodeIds?: InputMaybe<Array<Scalars['Int']>>;
  sandboxed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  tenantIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UserOriginationSource = {
  createdAt: Scalars['Datetime'];
  enrollmentExperience?: Maybe<Scalars['String']>;
  funnel?: Maybe<Scalars['String']>;
  funnelBillExperience?: Maybe<Scalars['String']>;
  funnelVnmProjectId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  originationSourceType: Scalars['String'];
  queryParams?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Datetime'];
};

export type UserOriginationSourceInput = {
  enrollmentExperience?: InputMaybe<EnrollmentOptionName>;
  funnel?: InputMaybe<Scalars['String']>;
  funnelBillExperience?: InputMaybe<FunnelBillExperience>;
  queryParams?: InputMaybe<Scalars['JSON']>;
};

export type UserPreferences = {
  enabledGoogleSignIn: Scalars['Boolean'];
};

export type UserPromoCode = {
  code: Scalars['String'];
  emailVerificationDomains?: Maybe<Array<Scalars['String']>>;
  fulfillmentAvailable: Scalars['Boolean'];
  fulfillmentExpirationDate?: Maybe<Scalars['Date']>;
  fulfillmentStep?: Maybe<Scalars['String']>;
  incentiveDescription?: Maybe<Scalars['String']>;
  incentiveId?: Maybe<Scalars['Int']>;
  isUserReferral: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  promoText: Scalars['String'];
  referralValueCents?: Maybe<Scalars['Int']>;
  referredByUserName?: Maybe<Scalars['String']>;
  requiresEmailVerification: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  requiresFreePlanTemplateOption: Scalars['Boolean'];
  requiresPhoenixFunnel: Scalars['Boolean'];
  requiresRefreshedQuickWinsFunnel: Scalars['Boolean'];
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  requiresWindPlanTemplate: Scalars['Boolean'];
  shouldShow: Scalars['Boolean'];
  sponsorName?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type UserReward = {
  canceledAt?: Maybe<Scalars['Datetime']>;
  enrolledAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  rewardValue: Scalars['Int'];
  source: Scalars['String'];
  status: Scalars['String'];
  userId: Scalars['Int'];
};

export type UserRewardResponse = {
  message?: Maybe<Scalars['String']>;
  nextRewardAmount?: Maybe<Scalars['Int']>;
  nextRewardDate?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  totalRewardValue?: Maybe<Scalars['Int']>;
};

export enum UserSortOptions {
  ActiveAt = 'activeAt',
  CreatedAt = 'createdAt',
  LastName = 'lastName',
}

export type UserTip = {
  completed?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  tip?: Maybe<Tip>;
  userId: Scalars['Int'];
};

export type UserTipOutput = {
  userTipId: Scalars['Int'];
};

export type UsersResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<User>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UtilitiesForZip = {
  other: Array<Maybe<Utility>>;
  suggested: Array<Maybe<Utility>>;
  utilities: Array<Maybe<Utility>>;
};

export type UtilitiesResponse = {
  count: Scalars['Int'];
  records: Array<Maybe<Utility>>;
};

export type Utility = {
  accountNumberRules: Array<Maybe<UtilityAccountNumberValidationRule>>;
  autoAddsOnlineAccount: Scalars['Boolean'];
  brokerable: Scalars['Boolean'];
  brokerageIdentifier?: Maybe<Scalars['String']>;
  consolidated: Scalars['Boolean'];
  credentialFreeLogin: Scalars['Boolean'];
  credentialType?: Maybe<Scalars['String']>;
  creditCardOnly: Scalars['Boolean'];
  demandResponseEligible: Scalars['Boolean'];
  displayName: Scalars['String'];
  emailIsUsername: Scalars['Boolean'];
  evergreenOnly: Scalars['Boolean'];
  fieldValidationRules: Array<UtilityAccountFieldValidationRule>;
  financialAssistanceProgramLink?: Maybe<Scalars['String']>;
  forgotPassword?: Maybe<Scalars['String']>;
  forgotUsername?: Maybe<Scalars['String']>;
  funnelSignupPaths: Array<FunnelSignupPath>;
  funnelTrack: FunnelTrack;
  id: Scalars['Int'];
  isutilityScraperEligible: Scalars['Boolean'];
  loadZones?: Maybe<Array<Maybe<LoadZone>>>;
  loggedInUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onboardingRateClasses: Array<OnboardingRateClass>;
  overrideEmailIsUsername: Scalars['Boolean'];
  paymentMedium: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  products: Array<Product>;
  rateClassStrings?: Maybe<Array<Maybe<RateClassString>>>;
  registerForAccount?: Maybe<Scalars['String']>;
  requiresCommunitySolarProjectGroup: Scalars['Boolean'];
  requiresPhoneNumberInFunnel: Scalars['Boolean'];
  revealable: Scalars['Boolean'];
  scraperId?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  shouldCreatePlanBasedOnBillingExperience?: Maybe<Scalars['Boolean']>;
  signInHelp?: Maybe<Scalars['String']>;
  specialCases: UtilitySpecialCases;
  state: State;
  thinkEligible: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  usesIpaContracts: Scalars['Boolean'];
  utilityTariffs?: Maybe<Array<Maybe<TariffString>>>;
  vnmActivelyAcquiring: Scalars['Boolean'];
  vnmAllocationSubmissionSchedules?: Maybe<Array<VnmAllocationSubmissionSchedule>>;
  vnmEligible: Scalars['Boolean'];
  vnmProductAvailable: Scalars['Boolean'];
  vnmSolarProjects?: Maybe<Array<VnmSolarProject>>;
};

export type UtilityFieldValidationRulesArgs = {
  fieldType?: InputMaybe<UtilityAccountFieldType>;
};

export type UtilityVnmSolarProjectsArgs = {
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  utilityAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type UtilityAccount = {
  account: Account;
  accountId: Scalars['Int'];
  accountNumber?: Maybe<Scalars['String']>;
  activeBillingSettings?: Maybe<ActiveBillingSettings>;
  annualizedUsageEstimate?: Maybe<Scalars['Int']>;
  autopayDisabled?: Maybe<Scalars['Boolean']>;
  availableProducts: Array<Product>;
  billPayIneligibleWithLargeBalance: Scalars['Boolean'];
  billPayServiceProductEligibility?: Maybe<BillPayServiceProductEligibility>;
  billingExperienceOptions?: Maybe<Array<BillingExperienceOption>>;
  /** @deprecated use activeBillingSettings instead */
  billingExperienceType?: Maybe<BillingExperienceType>;
  budgetBilling?: Maybe<Scalars['Boolean']>;
  communitySolarLead?: Maybe<CommunitySolarLead>;
  communitySolarLeadId?: Maybe<Scalars['Int']>;
  communitySolarProgramEligibility?: Maybe<SubscriberRequirement>;
  communitySolarProjectGroup?: Maybe<CommunitySolarProjectGroup>;
  communitySolarProjectGroupId?: Maybe<Scalars['Int']>;
  communitySolarQualification?: Maybe<SubscriberRequirement>;
  communitySolarUtilityAccount?: Maybe<CommunitySolarUtilityAccount>;
  connected: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  creditCorrections: Array<Maybe<CreditCorrection>>;
  customerClass?: Maybe<Scalars['String']>;
  customerClassSource?: Maybe<Scalars['String']>;
  developerSourced: Scalars['Boolean'];
  developerSourcesAcceptedDevelopers?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayServiceAddress: Scalars['String'];
  ebillDisabled?: Maybe<Scalars['Boolean']>;
  eligibleHighlights: Array<Scalars['String']>;
  emailOverrideUpdate?: Maybe<Scalars['String']>;
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  enrollmentDataSourceName?: Maybe<EnrollmentOptionName>;
  enrollmentStatus?: Maybe<Scalars['String']>;
  funnelBillExperience?: Maybe<BillExperience>;
  gasOnly: Scalars['Boolean'];
  geoAddress?: Maybe<GeoAddress>;
  geoAddressAccuracy?: Maybe<GeoAddressAccuracy>;
  hasElectricMultimeter?: Maybe<Scalars['Boolean']>;
  hasInValidScraperDetails: Scalars['Boolean'];
  /** @deprecated barely used */
  hasRooftopSolar?: Maybe<Scalars['Boolean']>;
  hasVnmProduct: Scalars['Boolean'];
  highlights: Array<Scalars['String']>;
  historicalUtilityStatements?: Maybe<Array<UtilityStatement>>;
  id: Scalars['Int'];
  intervalUsages: IntervalUsagePageType;
  /** @deprecated barely used */
  is60Days?: Maybe<Scalars['Boolean']>;
  isLmi?: Maybe<Scalars['Boolean']>;
  /** @deprecated barely used */
  isMultiAccount?: Maybe<Scalars['Boolean']>;
  isPerchSignup?: Maybe<Scalars['Boolean']>;
  lmiZoneLookup?: Maybe<LmiZoneLookup>;
  lmiZoneOptions?: Maybe<LmiZoneOptions>;
  loadZone?: Maybe<LoadZone>;
  meters?: Maybe<Array<Maybe<Meter>>>;
  mostRecentProductLead?: Maybe<ProductLead>;
  mostRecentUtilityStatement?: Maybe<UtilityStatement>;
  moveRequest?: Maybe<Array<Maybe<MoveRequest>>>;
  name?: Maybe<Scalars['String']>;
  nameKeyForEdi?: Maybe<Scalars['String']>;
  noEbill?: Maybe<Scalars['Boolean']>;
  nonArcadiaCommunitySolar?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<Array<Notification>>;
  nyLmiZoneOptions?: Maybe<NyLmiZoneOptions>;
  openTasks: Array<Task>;
  pastDueAmount?: Maybe<Scalars['Float']>;
  pastDueUpdatedAt?: Maybe<Scalars['Date']>;
  paymentAssistanceProgram?: Maybe<Scalars['Boolean']>;
  pendingMoveRequest?: Maybe<MoveRequest>;
  perchManaged?: Maybe<Scalars['Boolean']>;
  personalizedContractVersionsPending: Scalars['Boolean'];
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['Int']>;
  productLeads: Array<ProductLead>;
  productSubscriptionStatuses: UtilityAccountProductSubscriptionStatuses;
  productSubscriptions: Array<ProductSubscription>;
  rateClass?: Maybe<RateClass>;
  rateClassId?: Maybe<Scalars['Int']>;
  salesforceId?: Maybe<Scalars['String']>;
  sandboxed: Scalars['Boolean'];
  sanitizedAccountNumber?: Maybe<Scalars['String']>;
  scrapedPhoneNumber?: Maybe<Scalars['String']>;
  scraperActivity: Array<Maybe<ScraperActivity>>;
  scraperEnabled?: Maybe<Scalars['Boolean']>;
  scraperRequests: Array<Maybe<ScraperRequest>>;
  secondaryAccountIdentifier?: Maybe<Scalars['String']>;
  /** @deprecated use serviceAddressStreetOne instead */
  serviceAddress?: Maybe<Scalars['String']>;
  serviceAddressCity?: Maybe<Scalars['String']>;
  /** @deprecated use displayServiceAddress instead */
  serviceAddressFull?: Maybe<Scalars['String']>;
  serviceAddressState?: Maybe<Scalars['String']>;
  serviceAddressStreetOne?: Maybe<Scalars['String']>;
  serviceAddressStreetTwo?: Maybe<Scalars['String']>;
  serviceAddressZip?: Maybe<Scalars['String']>;
  serviceCustomerName?: Maybe<Scalars['String']>;
  /** The most recent SignNow envelope for this utility account and contract type (e.g. "disclosure"). */
  signNowEnvelope?: Maybe<SignNowEnvelope>;
  sourcedPromoCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriberContractRequirement: SubscriberRequirement;
  targetBillExperience?: Maybe<BillExperience>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  unassociatedUtilityStatements?: Maybe<Array<Maybe<UtilityStatement>>>;
  updateAccountSettingsScrapeUuid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  uploadedBills: Array<Maybe<BillUpload>>;
  urjanetLastSubmittedDate?: Maybe<Scalars['Date']>;
  user: User;
  userId: Scalars['Int'];
  utility: Utility;
  utilityAccountLmiSourceTypes: Array<Maybe<UtilityAccountLmiSourceType>>;
  utilityAccountMissingError?: Maybe<Scalars['String']>;
  utilityAccountPersonalizedContracts?: Maybe<Array<Maybe<UtilityAccountPersonalizedContract>>>;
  utilityCredential: UtilityCredential;
  utilityStatements?: Maybe<Array<UtilityStatement>>;
  vnmProductEligibility?: Maybe<VnmProductEligibility>;
  vnmSubscription?: Maybe<VnmSubscription>;
};

export type UtilityAccountIntervalUsagesArgs = {
  page: Scalars['Int'];
};

export type UtilityAccountLmiZoneLookupArgs = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UtilityAccountMostRecentProductLeadArgs = {
  productType?: InputMaybe<Scalars['String']>;
};

export type UtilityAccountProductLeadsArgs = {
  productType?: InputMaybe<Scalars['String']>;
};

export type UtilityAccountProductSubscriptionsArgs = {
  type?: InputMaybe<Scalars['String']>;
};

export type UtilityAccountSignNowEnvelopeArgs = {
  contractType: Scalars['String'];
};

export type UtilityAccountAttributesInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  serviceAddress?: InputMaybe<Scalars['String']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressState?: InputMaybe<Scalars['String']>;
  serviceAddressZip?: InputMaybe<Scalars['String']>;
  utilityCredentialId?: InputMaybe<Scalars['Int']>;
};

export type UtilityAccountBillExtractionOutput = {
  id: Scalars['Int'];
};

export type UtilityAccountDetailOutput = {
  utilityAccountDetailId?: Maybe<Scalars['Int']>;
};

export enum UtilityAccountFieldType {
  MeterNumber = 'meter_number',
  SecondaryAccountIdentifier = 'secondary_account_identifier',
}

export type UtilityAccountFieldValidationRule = {
  fieldName: Scalars['String'];
  fieldType: UtilityAccountFieldType;
  helpText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  patterns: Array<Scalars['String']>;
};

export type UtilityAccountIdInput = {
  utilityAccountId: Scalars['Int'];
};

export type UtilityAccountIdsInput = {
  utilityAccountIds: Array<Scalars['Int']>;
};

export type UtilityAccountInput = {
  annualizedUsageEstimate?: InputMaybe<Scalars['Int']>;
  billUploadIds: Array<InputMaybe<Scalars['Int']>>;
  enrollmentDataSourceName?: InputMaybe<EnrollmentOptionName>;
  meterNumber?: InputMaybe<Scalars['String']>;
  monthlyUsages?: InputMaybe<Array<MonthlyUsageInput>>;
  onboardingRateClassId?: InputMaybe<Scalars['Int']>;
  secondaryAccountIdentifier?: InputMaybe<Scalars['String']>;
  serviceAddress: ServiceAddressInput;
  serviceCustomerName?: InputMaybe<Scalars['String']>;
  utilityAccountNumber: Scalars['String'];
};

export type UtilityAccountLmiSourceType = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  lastUpdatedByEmail?: Maybe<Scalars['String']>;
  lmiProofDocUploads?: Maybe<Array<LmiProofDocUpload>>;
  lmiProofNumber?: Maybe<Scalars['String']>;
  lmiSourceType: LmiSourceType;
  reasonMessage?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<RejectionReason>;
  serviceStartDate?: Maybe<Scalars['Date']>;
  sourceFile?: Maybe<SourceFile>;
  statementDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  utilityAccount: UtilityAccount;
  utilityAccountId: Scalars['Int'];
  utilityAccountLmiSourceTypeMetaData?: Maybe<UtilityAccountLmiSourceTypeMetaData>;
};

export type UtilityAccountLmiSourceTypeFilters = {
  createdAt?: InputMaybe<DateRangeFilter>;
  customFilters?: InputMaybe<Array<Scalars['String']>>;
  hasSignedRequiredContracts?: InputMaybe<Scalars['Boolean']>;
  lmiSourceTypeNames?: InputMaybe<Array<Scalars['String']>>;
  rejectionReasons?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UtilityAccountLmiSourceTypeMetaData = {
  createdAt: Scalars['Datetime'];
  expirationDate?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  issueDate?: Maybe<Scalars['Datetime']>;
  lmiProofNumber?: Maybe<Scalars['String']>;
  metaData?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  nameMatchTag?: Maybe<Scalars['String']>;
  relationship: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  utilityAccountLmiSourceTypeId: Scalars['Int'];
};

export type UtilityAccountNumberValidationRule = {
  example?: Maybe<Scalars['String']>;
  pattern?: Maybe<Scalars['String']>;
};

export type UtilityAccountPersonalizedContract = {
  contractAgreementId?: Maybe<Scalars['Int']>;
  contractVersionId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  utilityAccountId?: Maybe<Scalars['Int']>;
};

export type UtilityAccountProductSubscriptionStatuses = {
  billPay: ProductSubscriptionStatus;
  membership: ProductSubscriptionStatus;
  vnm: VnmSubscriptionStatus;
  wind: ProductSubscriptionStatus;
};

export type UtilityAccountUpdate = {
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum UtilityAccountsOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type UtilityAccountsSearchFilterOptions = {
  accountId?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['Int']>;
  secondaryAccountIdentifier?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  utilityCredentialId?: InputMaybe<Scalars['Int']>;
};

export type UtilityAccountsSearchResponse = {
  count: Scalars['Int'];
  utilityAccounts: Array<Maybe<UtilityAccount>>;
};

export enum UtilityAccountsSortOption {
  AccountNumber = 'accountNumber',
  Id = 'id',
  ServiceAddressStreetOne = 'serviceAddressStreetOne',
  Status = 'status',
  Types = 'types',
}

export type UtilityChargeStatistics = {
  current?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Int']>;
  previous?: Maybe<Scalars['Int']>;
};

export type UtilityCredential = {
  accounts: Array<Maybe<Account>>;
  createdAt: Scalars['Datetime'];
  credentialServiceUuid?: Maybe<Scalars['String']>;
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  highlights: Array<Scalars['String']>;
  id: Scalars['Int'];
  overrideEmail: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  sandboxed: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** @deprecated Use utilityCredential.account instead. This will be introduced in phase 5 of core data model upgrade. */
  user: User;
  username?: Maybe<Scalars['String']>;
  utility: Utility;
  utilityAccounts: Array<Maybe<UtilityAccount>>;
  utilityAccountsWithHighlights?: Maybe<Scalars['Int']>;
  utilityId: Scalars['Int'];
  verificationStatus: Scalars['String'];
  verificationUpdatedAt?: Maybe<Scalars['Datetime']>;
};

export type UtilityCredentialScrapeFinished = {
  id: Scalars['Int'];
  scraperRequestUuid?: Maybe<Scalars['String']>;
  status: VerificationStatus;
};

export type UtilityCredentialSession = {
  request?: Maybe<UtilityScraperRequest>;
  scraperError?: Maybe<Array<Maybe<UtilityScraperError>>>;
  session?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UtilityEmail = {
  account?: Maybe<Account>;
  body?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Datetime']>;
  from: Scalars['String'];
  id: Scalars['Int'];
  labels: Array<Scalars['String']>;
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
  utility?: Maybe<Utility>;
  utilityAccount?: Maybe<UtilityAccount>;
  utilityCredential?: Maybe<UtilityCredential>;
};

export type UtilityEmailBody = {
  body?: Maybe<Scalars['String']>;
};

export type UtilityEmailDateRange = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type UtilityEmailFilters = {
  dateRange?: InputMaybe<UtilityEmailDateRange>;
  label?: InputMaybe<UtilityEmailLabel>;
  priority?: InputMaybe<UtilityEmailPriority>;
  specialCases?: InputMaybe<Array<UtilityEmailSpecialCase>>;
  starred?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<UtilityEmailStatus>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  utilityIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum UtilityEmailLabel {
  NoLabel = 'no_label',
}

export enum UtilityEmailPriority {
  High = 'high',
  Low = 'low',
}

export enum UtilityEmailSpecialCase {
  Evergreen = 'evergreen',
  NotActive = 'not_active',
}

export enum UtilityEmailStatus {
  Archive = 'archive',
  Inbox = 'inbox',
  Spam = 'spam',
}

export type UtilityEmailsResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<UtilityEmail>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UtilityFilters = {
  brokerable?: InputMaybe<Scalars['Boolean']>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  thinkEligible?: InputMaybe<Scalars['Boolean']>;
};

export type UtilityForUniqueRateClassStrings = {
  abbreviation: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  rateClassCount?: Maybe<Scalars['Int']>;
};

export type UtilityLineItem = FormattedLineItem & {
  amountCents: Scalars['Int'];
  entryType: LineItemEntryType;
  /** indicates whether a non-$0 SolarLineItem with the same utility statement id exists */
  hasCorrespondingSolarCharge: Scalars['Boolean'];
  id: Scalars['String'];
  key: LineItemKey;
  name: Scalars['String'];
  sandboxed: Scalars['Boolean'];
  /**
   * may not be present depending on statement metadata captured at the time
   * the utility info returned will be current rather than a snapshot of the utility at the time of the statement
   */
  utility?: Maybe<Utility>;
  /**
   * may not be present depending on statement metadata captured at the time
   * the utility account info returned will be current rather than a snapshot of the utility account at the time of the statement
   */
  utilityAccount?: Maybe<UtilityAccount>;
  /** may not be present depending on statement metadata captured at the time */
  utilityAccountId?: Maybe<Scalars['Int']>;
  /** may not be present depending on statement metadata captured at the time */
  utilityId?: Maybe<Scalars['Int']>;
  /** may not be present depending on statement metadata captured at the time */
  utilityStatement?: Maybe<UtilityStatement>;
  /** may not be present depending on statement metadata captured at the time */
  utilityStatementId?: Maybe<Scalars['Int']>;
};

export type UtilityMapping = {
  mappedUtilities?: Maybe<Array<MappedUtility>>;
  sourceUtilityId: Scalars['ID'];
};

export type UtilityOrSupplierWithTariffCount = {
  abbreviation?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lseType: Scalars['String'];
  name: Scalars['String'];
  tariffCount?: Maybe<Scalars['Int']>;
};

export type UtilityRemittance = {
  amountCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  paymentFile: PaymentFile;
  status?: Maybe<Scalars['String']>;
  utilityName?: Maybe<Scalars['String']>;
};

export type UtilityScraperError = {
  code?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UtilityScraperRequest = {
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  startedAt?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};

export enum UtilitySortOption {
  EligibleBrokerageProductEligibilities = 'eligible_brokerage_product_eligibilities',
}

export type UtilitySpecialCases = {
  creditCardOnly: Scalars['Boolean'];
  emailIsUsername: Scalars['Boolean'];
  noEbilling: Scalars['Boolean'];
  onlyAverageBilling: Scalars['Boolean'];
  overrideEmailIsUsername: Scalars['Boolean'];
  sixtyDays: Scalars['Boolean'];
  solar: Scalars['Boolean'];
};

export type UtilityStatement = {
  /** @deprecated use utilityAccount.accountId instead. */
  accountId: Scalars['Int'];
  accumulatedKwh?: Maybe<Scalars['Int']>;
  /** VNM Fields for Non Arcadia Customers */
  arcVnmBillCredits?: Maybe<Scalars['Float']>;
  billable: Scalars['Boolean'];
  carryForwardCredits?: Maybe<Scalars['Float']>;
  carryForwardKwh?: Maybe<Scalars['Int']>;
  carryoverCredits?: Maybe<Scalars['Float']>;
  cdgSubscriptionFee?: Maybe<Scalars['Float']>;
  closingCreditsBalance?: Maybe<Scalars['Float']>;
  /** the date the utility statement was added to the database (set by arcadia) */
  createdAt: Scalars['Datetime'];
  creditsAppliedThisPeriod?: Maybe<Scalars['Float']>;
  creditsExpired?: Maybe<Scalars['Float']>;
  creditsReceived?: Maybe<Scalars['Float']>;
  derivedStatementData: DerivedStatementData;
  /** the date the utility statement is due (set by the utility) */
  dueDate?: Maybe<Scalars['Date']>;
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  expiringVnmKwh?: Maybe<Scalars['Int']>;
  finalBill?: Maybe<Scalars['Boolean']>;
  fixedPercentage?: Maybe<Scalars['String']>;
  highlights?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['Int'];
  /** the date the utility statement was issued (also referred to as statement date) (set by the utility) */
  issueDate?: Maybe<Scalars['Date']>;
  kwh?: Maybe<Scalars['Int']>;
  meterNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  openingCreditsBalance?: Maybe<Scalars['Float']>;
  paymentConfirmedDate?: Maybe<Scalars['Date']>;
  pdfSource?: Maybe<Scalars['String']>;
  preVnmServiceCharge?: Maybe<Scalars['Float']>;
  rawVnmData?: Maybe<Scalars['JSON']>;
  recRatio?: Maybe<Scalars['Float']>;
  sandboxed: Scalars['Boolean'];
  secondarySupplierRate?: Maybe<Scalars['Float']>;
  /** the date that the monthly electricity period started (set by the utility) */
  serviceEndDate?: Maybe<Scalars['Date']>;
  /** the date that the monthly electricity period ended (set by the utility) */
  serviceStartDate?: Maybe<Scalars['Date']>;
  sgStatementXid?: Maybe<Scalars['String']>;
  /** @deprecated use issue date instead */
  statementDate?: Maybe<Scalars['Date']>;
  statistics?: Maybe<UtilityStatementStatistics>;
  supplierStatementDetail?: Maybe<SupplierStatementDetail>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  usages?: Maybe<Array<Usage>>;
  utility: Utility;
  utilityAccount: UtilityAccount;
  utilityAccountId: Scalars['Int'];
  utilityCharge?: Maybe<Scalars['Float']>;
  utilityId: Scalars['Int'];
  vnmAppliedKwh?: Maybe<Scalars['Int']>;
  vnmBillCredits?: Maybe<Scalars['Float']>;
  vnmProductionCredits?: Maybe<Scalars['Float']>;
  vnmProductionKwh?: Maybe<Scalars['Int']>;
};

export type UtilityStatementStatistics = {
  kwh?: Maybe<KwhStatistics>;
  utilityCharge?: Maybe<UtilityChargeStatistics>;
};

export type VnmCreditEntry = {
  amountCents: Scalars['Int'];
  billingExperience?: Maybe<BillingExperienceOptionName>;
  createdAt: Scalars['Datetime'];
  entryType: Scalars['String'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['JSON']>;
  sourceId: Scalars['Int'];
  sourceType: Scalars['String'];
  statement?: Maybe<Statement>;
  updatedAt: Scalars['Datetime'];
};

export type VnmCreditEntryOptions = {
  billingExperience?: InputMaybe<BillingExperienceOptionName>;
};

export type VnmEligibilityCountsByStatus = {
  eligible?: Maybe<Scalars['Int']>;
  ineligible?: Maybe<Scalars['Int']>;
  needsReview?: Maybe<Scalars['Int']>;
};

export enum VnmEnrollmentStatus {
  Allocated = 'allocated',
  Available = 'available',
  Billed = 'billed',
  Bounced = 'bounced',
  Canceled = 'canceled',
  DroppedFromProject = 'dropped_from_project',
  Eligible = 'eligible',
  Enrolled = 'enrolled',
  Inactive = 'inactive',
  Ineligible = 'ineligible',
  NeedsReview = 'needs_review',
  New = 'new',
  OptedOut = 'opted_out',
  Pending = 'pending',
  PendingCancelation = 'pending_cancelation',
  Rejected = 'rejected',
  Unavailable = 'unavailable',
  Unknown = 'unknown',
  Waitlist = 'waitlist',
}

export type VnmPartner = {
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  stripeAccountId: Scalars['String'];
  stripeRefreshToken: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type VnmProductEligibilitiesFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  customerClass?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  developerNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eligibilityStatuses?: InputMaybe<Array<InputMaybe<VnmProductEligibilityStatus>>>;
  hasActiveBillPayProductSubscription?: InputMaybe<Scalars['Boolean']>;
  hasAgencyLanguage?: InputMaybe<Scalars['Boolean']>;
  hasBillCreditIncentives?: InputMaybe<Scalars['Boolean']>;
  hasBudgetBilling?: InputMaybe<Scalars['Boolean']>;
  hasDualBilling?: InputMaybe<Scalars['Boolean']>;
  hasPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  ineligibilityReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isLmi?: InputMaybe<Scalars['Boolean']>;
  latestDisclosureFormVersionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  latestSubscriberAgreementVersionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  loadZoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  needsReviewReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rateClassIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  secondaryAccountIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  statusFrozen?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityAccountNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  utilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vnmSolarProjectIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type VnmProductEligibility = {
  createdAt: Scalars['Datetime'];
  flags?: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  ineligibilityReasons?: Maybe<Array<IneligibilityReason>>;
  needsReviewReasons?: Maybe<Array<NeedsReviewReason>>;
  status: Scalars['String'];
  statusFrozen: Scalars['Boolean'];
  statusHistory?: Maybe<Array<Maybe<HistoryRecord>>>;
  utilityAccount: UtilityAccount;
  utilityAccountId: Scalars['Int'];
  vnmSubscription?: Maybe<VnmSubscription>;
};

export type VnmProductEligibilityIneligibilityReasonsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};

export type VnmProductEligibilityNeedsReviewReasonsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};

export type VnmProductStatus = {
  status: VnmEnrollmentStatus;
};

/** TODO: make ProductSubscription an interface, and VnmProductSubscription can extend the interface */
export type VnmProductSubscription = {
  amountCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  vnmSubscription?: Maybe<VnmSubscription>;
};

export type VnmProductionData = {
  homesPowered: Scalars['Int'];
  kwh: Scalars['Float'];
};

export type VnmSolarProjectStatistics = {
  cumulativeCarsOffRoad?: Maybe<Scalars['Float']>;
  cumulativeDollarsSaved?: Maybe<Scalars['Float']>;
  cumulativeHomesPowered?: Maybe<Scalars['Float']>;
  /** If real solar production data exists, return whProducedToDate else return estimatedKwhProducedToDate */
  estimatedKwhProducedToDate?: Maybe<Scalars['Float']>;
  kwhProducedToDate?: Maybe<Scalars['Float']>;
};

export type VnmSolarProjectsSearchResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<VnmSolarProject>;
};

export type VnmStateStatistics = {
  abbreviation?: Maybe<Scalars['String']>;
  expectedKwh?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  numberOfProjects?: Maybe<Scalars['Int']>;
  totalNumberOfMembers?: Maybe<Scalars['Int']>;
};

export enum VnmStatuses {
  AcquiredForPerchProject = 'acquired_for_perch_project',
  Allocated = 'allocated',
  Available = 'available',
  Billed = 'billed',
  Bounced = 'bounced',
  Canceled = 'canceled',
  Disqualified = 'disqualified',
  DroppedFromProject = 'dropped_from_project',
  Eligible = 'eligible',
  Enrolled = 'enrolled',
  Inactive = 'inactive',
  Ineligible = 'ineligible',
  Migrated = 'migrated',
  NeedsReview = 'needs_review',
  New = 'new',
  NotReady = 'not_ready',
  OptedOut = 'opted_out',
  Pending = 'pending',
  PendingCancelation = 'pending_cancelation',
  PendingComplete = 'pending_complete',
  ProgramEligible = 'program_eligible',
  ProgramIneligible = 'program_ineligible',
  Rejected = 'rejected',
  Unavailable = 'unavailable',
  Waitlist = 'waitlist',
}

export type VnmSubscription = {
  attrition?: Maybe<Attrition>;
  attritionDate?: Maybe<Scalars['Date']>;
  cancelationRequestedDate?: Maybe<Scalars['Date']>;
  canceledStatusCreatedAt?: Maybe<Scalars['Date']>;
  closureDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Datetime'];
  dataFrozenAt?: Maybe<Scalars['Datetime']>;
  dataFrozenForPerchMigration?: Maybe<Scalars['Boolean']>;
  emailSuppressedForPerchEntity: Scalars['Boolean'];
  executedContracts?: Maybe<Array<ExecutedContract>>;
  fixedAllocationKwAc?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  meterNumber?: Maybe<Scalars['String']>;
  migratedToPerchAt?: Maybe<Scalars['Datetime']>;
  mostRecentSubscriptionSubmission?: Maybe<VnmSubscriptionUtilitySubmission>;
  pendingAllocation?: Maybe<Scalars['Float']>;
  pendingCancelationDays: Scalars['Int'];
  preClosureStatus?: Maybe<Scalars['String']>;
  priorEnrolledStatus?: Maybe<Scalars['String']>;
  productSubscription?: Maybe<ProductSubscription>;
  projectIdHistory?: Maybe<Array<Maybe<HistoryRecord>>>;
  salesforceId?: Maybe<Scalars['String']>;
  salesforceInstance?: Maybe<SalesforceInstance>;
  savingsRate?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  statusHistory?: Maybe<Array<Maybe<HistoryRecord>>>;
  updatedAt: Scalars['Datetime'];
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  vnmCreditBalanceCents: Scalars['Int'];
  vnmCreditEntries: Array<VnmCreditEntry>;
  vnmPartner?: Maybe<VnmPartner>;
  vnmSolarProject?: Maybe<VnmSolarProject>;
  vnmSubscriptionSubmissionIds?: Maybe<Array<Scalars['Int']>>;
  vnmSubscriptionUtilitySubmissions?: Maybe<Array<VnmSubscriptionUtilitySubmission>>;
};

export type VnmSubscriptionVnmCreditEntriesArgs = {
  filters?: InputMaybe<VnmCreditEntryOptions>;
};

export type VnmSubscriptionVnmSolarProjectArgs = {
  calculatedFields?: InputMaybe<Scalars['Boolean']>;
  nonCumulativeCalculatedFields?: InputMaybe<Scalars['Boolean']>;
};

export type VnmSubscriptionCountsByStatus = {
  allocated?: Maybe<Scalars['Int']>;
  billed?: Maybe<Scalars['Int']>;
  bounced?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Int']>;
  droppedFromProject?: Maybe<Scalars['Int']>;
  enrolled?: Maybe<Scalars['Int']>;
  optedOut?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
  pendingCancelation?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  waitlist?: Maybe<Scalars['Int']>;
};

export type VnmSubscriptionFilters = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isLmi?: InputMaybe<Scalars['Boolean']>;
  optOutPeriodId?: InputMaybe<Scalars['Int']>;
  secondaryAccountIdentifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityAccountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  utilityAccountNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vnmSolarProjectId: Scalars['Int'];
};

export type VnmSubscriptionStatus = {
  status: VnmStatuses;
};

export type VnmSubscriptionStatusCounts = {
  optedOut?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
};

export type Validation = {
  availableEmail: ValidationOutput;
  cutOffDateEligibility: ValidationOutput;
  perchSfProductId: ValidationOutput;
  phoneNumber: ValidationOutput;
  /** @deprecated The use of plan templates is deprecated, use a product data model attribute instead. */
  planTemplateAndUtility: ValidationOutput;
  promoCode: ValidationOutput;
  utility: ValidationOutput;
  vnmSolarProject: ValidationOutput;
  zipCode: ValidationOutput;
  zipCodeAndUtility: ValidationOutput;
};

export type ValidationAvailableEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};

export type ValidationCutOffDateEligibilityArgs = {
  billIssueDate?: InputMaybe<Scalars['Date']>;
  proofCutOffDate?: InputMaybe<Scalars['Date']>;
  utilityAccountId?: InputMaybe<Scalars['Int']>;
  utilityAccountLmiSourceTypeId?: InputMaybe<Scalars['Int']>;
};

export type ValidationPerchSfProductIdArgs = {
  customerType?: InputMaybe<Scalars['String']>;
  perchSfProductId: Scalars['String'];
  requireFico?: InputMaybe<Scalars['Boolean']>;
  stateId?: InputMaybe<Scalars['Int']>;
};

export type ValidationPhoneNumberArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ValidationPlanTemplateAndUtilityArgs = {
  planTemplateId?: InputMaybe<Scalars['Int']>;
  utilityId?: InputMaybe<Scalars['Int']>;
};

export type ValidationPromoCodeArgs = {
  promoCode?: InputMaybe<Scalars['String']>;
};

export type ValidationUtilityArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ValidationVnmSolarProjectArgs = {
  utilityId?: InputMaybe<Scalars['Int']>;
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
};

export type ValidationZipCodeArgs = {
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ValidationZipCodeAndUtilityArgs = {
  utilityId?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ValidationError = {
  key: Scalars['String'];
  message: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type ValidationOutput = {
  error?: Maybe<ValidationError>;
  isValid: Scalars['Boolean'];
  response?: Maybe<Scalars['JSON']>;
};

export enum VerificationStatus {
  Correct = 'correct',
  Empty = 'empty',
  Error = 'error',
  Incorrect = 'incorrect',
  Unverified = 'unverified',
}

export type VersionHistoryEvent = {
  accountId?: Maybe<Scalars['Int']>;
  changedBy?: Maybe<AdminUser>;
  changedById?: Maybe<Scalars['Int']>;
  changes: Array<VersionHistoryItem>;
  createdAt: Scalars['Datetime'];
  event: VersionHistoryEventType;
  id: Scalars['Int'];
  itemId: Scalars['Int'];
  itemType: Scalars['String'];
  userId?: Maybe<Scalars['Int']>;
  whodunnit?: Maybe<Scalars['String']>;
  whodunnitType?: Maybe<Scalars['String']>;
};

export enum VersionHistoryEventType {
  Create = 'create',
  Destroy = 'destroy',
  Update = 'update',
}

export type VersionHistoryItem = {
  currentValue: Scalars['String'];
  field: Scalars['String'];
  previousValue: Scalars['String'];
};

export type VersionHistoryResponse = {
  count: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  records: Array<VersionHistoryEvent>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VnmAllocationSubmissionSchedule = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type VnmCampaign = {
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  inputFileUrl?: Maybe<Scalars['String']>;
  optOutPeriod?: Maybe<OptOutPeriod>;
  optOutPeriodId?: Maybe<Scalars['Int']>;
  resultsFileUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  vnmSolarProject: VnmSolarProject;
  vnmSolarProjectId: Scalars['Int'];
};

export type VnmCampaignBatch = {
  adminUser?: Maybe<AdminUser>;
  createdAt: Scalars['Datetime'];
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  parsingError?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

export type VnmCampaignBatchCompletedOutput = {
  adminUserId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type VnmCampaignBatchesInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type VnmCampaignBatchesOutput = {
  records: Array<VnmCampaignBatch>;
  totalCount: Scalars['Int'];
};

export type VnmCampaignCompletedOutput = {
  id: Scalars['Int'];
  vnmCampaignBatchId?: Maybe<Scalars['Int']>;
};

export type VnmCampaignContractsInput = {
  campaignType: VnmCampaignType;
  data: Scalars['JSON'];
};

export enum VnmCampaignType {
  Enrollment = 'enrollment',
  ExecutedAgreement = 'executed_agreement',
  OptOut = 'opt_out',
}

export type VnmCampaignsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  vnmCampaignBatchId?: InputMaybe<Scalars['Int']>;
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
};

export type VnmCampaignsOutput = {
  records: Array<VnmCampaign>;
  totalCount: Scalars['Int'];
};

export type VnmContractUrl = {
  expiresAt: Scalars['String'];
  key: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type VnmDeveloper = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum VnmProductEligibilityStatus {
  EligibilityIssue = 'eligibility_issue',
  Eligible = 'eligible',
  Ineligible = 'ineligible',
  NeedsReview = 'needs_review',
  New = 'new',
  Waitlist = 'waitlist',
}

export type VnmSolarProject = {
  acquisitionStatistics?: Maybe<AcquisitionStatistics>;
  address?: Maybe<Scalars['String']>;
  agencyAllowed: Scalars['Boolean'];
  alternateName?: Maybe<Scalars['String']>;
  arcadiaCapacityKwdc?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  communitySolarProjectGroupId?: Maybe<Scalars['Int']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  creditWaitPeriod?: Maybe<Scalars['Int']>;
  defaultEligibilityFilters?: Maybe<Scalars['JSON']>;
  defaultUtilitySubmissionExportColumnKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  developerName?: Maybe<Scalars['String']>;
  editWindowDays?: Maybe<Scalars['Int']>;
  estimatedAnnualHomesPowered?: Maybe<Scalars['Float']>;
  firstYearHomesPoweredEstimate?: Maybe<Scalars['Float']>;
  firstYearProductionEstimate: Scalars['Float'];
  hostName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image?: Maybe<VnmSolarProjectImage>;
  ipaDeveloperContactInfo?: Maybe<Scalars['String']>;
  ipaProjectAppId?: Maybe<Scalars['String']>;
  ipaProjectStatus?: Maybe<Scalars['String']>;
  ipaVendorName?: Maybe<Scalars['String']>;
  lastUtilitySubmission?: Maybe<VnmUtilitySubmission>;
  latitude?: Maybe<Scalars['String']>;
  lineItemCopy?: Maybe<Scalars['String']>;
  lmiMinimumCoverage?: Maybe<Scalars['Float']>;
  loadZone?: Maybe<LoadZone>;
  loadZoneId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['String']>;
  maximumCommercialCoverage?: Maybe<Scalars['Float']>;
  /**
   * Maryland identifier - also called a "Subscriber Organization Number" or SON
   * For non-MD solar projects, this will be null
   */
  mdIdentifier?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optOutPeriods?: Maybe<Array<OptOutPeriod>>;
  paymentDetails?: Maybe<PaymentDetails>;
  perchManaged: Scalars['Boolean'];
  productionFactor: Scalars['Float'];
  programTermLength?: Maybe<Scalars['Int']>;
  programType?: Maybe<Scalars['String']>;
  projectedStatistics?: Maybe<ProjectedVnmSolarProjectStatistics>;
  salesforceId?: Maybe<Scalars['String']>;
  salesforceInstance?: Maybe<SalesforceInstance>;
  salesforceOpportunityUrl?: Maybe<Scalars['String']>;
  salesforceStage?: Maybe<Scalars['String']>;
  savingsRateOptions: Array<Scalars['Float']>;
  siteIdentifier?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  subscriptionStatistics?: Maybe<SubscriptionStatistics>;
  targetCoverage: Scalars['Float'];
  targetUsageFactor: Scalars['Float'];
  timeZone?: Maybe<Scalars['String']>;
  totalAcCapacity?: Maybe<Scalars['Float']>;
  totalCapacity: Scalars['Float'];
  updatedAt: Scalars['Date'];
  utility: Utility;
  utilityConsolidatedBilling: Scalars['Boolean'];
  utilityId?: Maybe<Scalars['Int']>;
  utilityPortalSubmissionEligible?: Maybe<Scalars['Boolean']>;
  utilitySubmissionExportColumns?: Maybe<Array<Maybe<ExportColumn>>>;
  vnmDeveloperId?: Maybe<Scalars['Int']>;
  vnmPartner?: Maybe<VnmPartner>;
  vnmSubscriptions?: Maybe<Array<Maybe<VnmSubscription>>>;
  vnmUtilitySubmissions?: Maybe<Array<VnmUtilitySubmission>>;
  zipCode?: Maybe<ZipCode>;
};

export type VnmSolarProjectOptOutPeriodsArgs = {
  endDate?: InputMaybe<StringRangeFilter>;
  startDate?: InputMaybe<StringRangeFilter>;
};

export type VnmSolarProjectProjectedStatisticsArgs = {
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type VnmSolarProjectVnmSubscriptionsArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountIds?: InputMaybe<Array<Scalars['Int']>>;
  utilityAccountNumbers?: InputMaybe<Array<Scalars['String']>>;
};

export type VnmSolarProjectImage = {
  large?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type VnmSolarProjectPaginationResult = {
  count?: Maybe<Scalars['Int']>;
  records: Array<Maybe<VnmSolarProject>>;
};

export type VnmSubscriptionUtilitySubmission = {
  allocation: Scalars['Float'];
  annualizedUsageEstimate: Scalars['Int'];
  calculatedAllocationKw?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  usageFactor: Scalars['Float'];
  vnmSubscriptionId: Scalars['Int'];
  vnmUtilitySubmission?: Maybe<VnmUtilitySubmission>;
  vnmUtilitySubmissionId: Scalars['Int'];
};

export type VnmUtilitySubmission = {
  allocation?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Datetime'];
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['Int'];
  isComplete: Scalars['Boolean'];
  submissionDate: Scalars['Date'];
  usageFactor?: Maybe<Scalars['Float']>;
  vnmSolarProject?: Maybe<VnmSolarProject>;
  vnmSolarProjectId: Scalars['Int'];
};

export type VnmUtilitySubmissionCompleted = {
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type VnmUtilitySubmissionScraperCompleted = {
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export enum VnmUtilitySubmissionScraperType {
  Decrease = 'decrease',
  Increase = 'increase',
}

export type VoidCreditInput = {
  id: Scalars['Int'];
  sandboxed?: InputMaybe<Scalars['Boolean']>;
};

export type WinbackAccountLead = {
  account?: Maybe<Account>;
  accountId: Scalars['Int'];
  assignee?: Maybe<AdminUser>;
  assigneeId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  cumulativeSolarSavingsCents?: Maybe<Scalars['Int']>;
  followUpDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  lastNoteInOsprey?: Maybe<Scalars['String']>;
  previousCallAttemptDate?: Maybe<Scalars['Datetime']>;
  previousCallAttemptOutcome?: Maybe<WinbackCallAttemptOutcome>;
  priorVnmStatus?: Maybe<Scalars['String']>;
  resolved: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  userId: Scalars['Int'];
  winbackCampaign?: Maybe<WinbackCampaign>;
  winbackCampaignId?: Maybe<Scalars['Int']>;
};

export type WinbackAccountLeadFilterOptions = {
  assignee?: InputMaybe<Scalars['String']>;
  attritionCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  campaignId?: InputMaybe<Scalars['String']>;
  customerAccountTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priorVnmStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  winbackStatuses?: InputMaybe<Array<InputMaybe<WinbackCallAttemptOutcome>>>;
};

export type WinbackAccountLeadsResponse = {
  resultCount: Scalars['Int'];
  winbackAccountLeads: Array<Maybe<WinbackAccountLead>>;
};

export type WinbackCallAttempt = {
  accountLead?: Maybe<WinbackUtilityAccountLead>;
  accountLeadId: Scalars['Int'];
  attemptedBy?: Maybe<AdminUser>;
  attemptedById?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  followUpDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  outcome: WinbackCallAttemptOutcome;
  updatedAt: Scalars['Datetime'];
  voicemailSent: Scalars['Boolean'];
};

export enum WinbackCallAttemptOutcome {
  Answered = 'answered',
  ConnectionFailed = 'connection_failed',
  FollowUp = 'follow_up',
  Unanswered = 'unanswered',
}

export type WinbackCampaign = {
  active: Scalars['Boolean'];
  closedAt?: Maybe<Scalars['Datetime']>;
  closedBy?: Maybe<AdminUser>;
  closureComment?: Maybe<Scalars['String']>;
  closureReason?: Maybe<WinbackCampaignClosureReason>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<AdminUser>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initialLeadsForWinbackCampaign?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  resolvedWinbackLeadsCount?: Maybe<Scalars['Int']>;
  targetCompletionDate: Scalars['Datetime'];
  unresolvedWinbackLeadsDuringClosure?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<AdminUser>;
  winbackCampaignFilters?: Maybe<Array<Maybe<WinbackCampaignFilters>>>;
  winbackLeadsAssignmentStatus?: Maybe<Scalars['String']>;
};

export enum WinbackCampaignClosureReason {
  AllEligibleLeadsContacted = 'all_eligible_leads_contacted',
  CampaignDeemedUnsuccessful = 'campaign_deemed_unsuccessful',
  Other = 'other',
  PivotInPriorities = 'pivot_in_priorities',
}

export type WinbackCampaignFilterOptions = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type WinbackCampaignFilters = {
  attributeCriteria: AttributeCriteria;
  attributeName: Scalars['String'];
  id: Scalars['Int'];
  winbackCampaignId: Scalars['Int'];
};

export type WinbackCampaignFiltersInput = {
  attributeName: Scalars['String'];
  criteria: FilterInput;
  partialMatch?: InputMaybe<Scalars['Boolean']>;
};

export type WinbackCampaignsResponse = {
  resultCount: Scalars['Int'];
  winbackCampaigns: Array<Maybe<WinbackCampaign>>;
};

export type WinbackUtilityAccountLead = {
  attritionReason?: Maybe<Scalars['String']>;
  billingExperienceAtAttrition?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  currentVnmStatus?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  priorVnmStatus?: Maybe<Scalars['String']>;
  status: WinbackUtilityAccountLeadStatus;
  updatedAt: Scalars['Datetime'];
  utilityAccount?: Maybe<UtilityAccount>;
  utilityAccountId?: Maybe<Scalars['Int']>;
  vnmSubscription?: Maybe<VnmSubscription>;
  vnmSubscriptionId?: Maybe<Scalars['Int']>;
};

export enum WinbackUtilityAccountLeadStatus {
  ErroneousAttritionReversed = 'erroneous_attrition_reversed',
  Lost = 'lost',
  Pending = 'pending',
  TryAgain = 'try_again',
  WinbackForArcadia = 'winback_for_arcadia',
  WinbackForProject = 'winback_for_project',
}

export type WindProject = {
  carbonEquivalency: CarbonEquivalency;
  description: Scalars['String'];
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  jobsCreated?: Maybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  location: Scalars['String'];
  longitude: Scalars['Float'];
  month?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  numberOfSource: Scalars['Int'];
  powerSource: Scalars['String'];
  projectType: Scalars['String'];
  state: Scalars['String'];
  totalYearlyPowerProduced: Scalars['Float'];
  unitType: Scalars['String'];
  unitsPowered: Scalars['Int'];
};

export type ZipCode = {
  city?: Maybe<Scalars['String']>;
  egridSubregion?: Maybe<EgridSubregion>;
  id: Scalars['Int'];
  state: State;
  zip: Scalars['String'];
};

export type ZuoraDigitalSignature = {
  key?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  tenantId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type ZuoraLinkToken = {
  digitalSignature: ZuoraDigitalSignature;
  hostedPageId: Scalars['String'];
  hostedPageUri: Scalars['String'];
};

export enum ZuoraLinkTokenMethodType {
  Ach = 'ach',
  Card = 'card',
}

export type ClosureWarning = {
  canOverride: Scalars['Boolean'];
  key: Scalars['String'];
  resourceId?: Maybe<Scalars['Int']>;
  resourceType?: Maybe<Scalars['String']>;
};

export type EnrollUserRewardInput = {
  rewardValue?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};

export type FetchedMessages = {
  messages?: Maybe<Array<Message>>;
  nextPageUrl?: Maybe<Scalars['String']>;
};

export type FetchedPaginatedMessages = {
  messages?: Maybe<Array<Message>>;
  nextPageUrl?: Maybe<Scalars['String']>;
  previousPageUrl?: Maybe<Scalars['String']>;
};

export type ReferredUsersResponse = {
  count?: Maybe<Scalars['Int']>;
  records: Array<Maybe<ReferredUser>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TokenExchangeOutput = {
  token: Scalars['String'];
};

export type Flex_FetchDashboardUrlQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type Flex_FetchDashboardUrlQuery = { user: { url: string } };

export type Flex_UpdateUserMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUserInput;
}>;

export type Flex_UpdateUserMutation = {
  updateUser: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
  };
};

export type Flex_FetchCountiesQueryVariables = Exact<{
  id: Scalars['Int'];
  zipCode: Scalars['String'];
}>;

export type Flex_FetchCountiesQuery = {
  countyData?: { counties?: Array<string | null> | null } | null;
};

export type Flex_FetchUtilitiesQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;

export type Flex_FetchUtilitiesQuery = {
  utilities: { suggested: Array<{ id: number; name: string } | null> };
};

export type Flex_GoogleLoginUrlQueryVariables = Exact<{
  path?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
}>;

export type Flex_GoogleLoginUrlQuery = { googleLoginUrl: string };

export type Flex_ValidatePhoneNumberQueryVariables = Exact<{
  countryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;

export type Flex_ValidatePhoneNumberQuery = {
  validation: {
    phoneNumber: {
      response?: any | null;
      isValid: boolean;
      error?: { message: string; status?: number | null } | null;
    };
  };
};

export type Flex_FetchUtilityAccountNumberRulesQueryVariables = Exact<{
  utilityId: Scalars['Int'];
}>;

export type Flex_FetchUtilityAccountNumberRulesQuery = {
  utility: { rules: Array<{ example?: string | null; pattern?: string | null } | null> };
};

export type Flex_ValidateZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;

export type Flex_ValidateZipCodeQuery = { validation: { zipCode: { isValid: boolean } } };

export type Flex_FetchPersonalizedContractQueryVariables = Exact<{
  contractVersionId: Scalars['Int'];
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_FetchPersonalizedContractQuery = {
  contractVersion: { id: number; personalizedFile?: string | null };
};

export type Flex_FetchPerchPersonalizedContractQueryVariables = Exact<{
  contractVersionId: Scalars['Int'];
  planId: Scalars['Int'];
}>;

export type Flex_FetchPerchPersonalizedContractQuery = {
  contractVersion: { id: number; perchPersonalizedFile?: string | null };
};

export type Flex_FetchPromoInfoQueryVariables = Exact<{
  promoCode: Scalars['String'];
  utilityId?: InputMaybe<Scalars['Int']>;
}>;

export type Flex_FetchPromoInfoQuery = {
  promoCode: {
    incentiveDescription?: string | null;
    fulfillmentAvailable: boolean;
    fulfillmentStep?: string | null;
    isUserReferral: boolean;
    referralValueCents?: number | null;
    referredByUserName?: string | null;
  };
};

export type Flex_FetchGeneralTermsQueryVariables = Exact<{ [key: string]: never }>;

export type Flex_FetchGeneralTermsQuery = {
  generalContractVersions: Array<{ id: number; displayName: string }>;
};

export type Flex_FetchPerchGeneralTermsQueryVariables = Exact<{ [key: string]: never }>;

export type Flex_FetchPerchGeneralTermsQuery = {
  generalContractVersions: Array<{ id: number; displayName: string }>;
};

export type Flex_FetchPerchConsentQueryVariables = Exact<{
  signupContractTemplateId: Scalars['Int'];
}>;

export type Flex_FetchPerchConsentQuery = {
  signupContractTemplateContractVersions: Array<{
    id: number;
    displayName: string;
    internalName: string;
    contractType: string;
    notes?: string | null;
    fileUrl: string;
  }>;
};

export type Flex_FetchPerchCreditCheckConsentQueryVariables = Exact<{ [key: string]: never }>;

export type Flex_FetchPerchCreditCheckConsentQuery = {
  currentContractVersions: Array<{
    id: number;
    displayName: string;
    internalName: string;
    contractType: string;
    notes?: string | null;
    fileUrl: string;
  }>;
};

export type Flex_FetchWaitListTermsQueryVariables = Exact<{ [key: string]: never }>;

export type Flex_FetchWaitListTermsQuery = {
  generalContractVersions: Array<{ id: number; displayName: string }>;
};

export type GetFunnelQueryParamsQueryVariables = Exact<{
  token: Scalars['String'];
}>;

export type GetFunnelQueryParamsQuery = {
  funnelQueryParams: {
    error?: string | null;
    params?: {
      email: string;
      phone: string;
      zipCode: string;
      lastName: string;
      firstName: string;
      utilityId: number;
      inviteCode?: string | null;
      meterNumber?: string | null;
      accountNumber: string;
      partnerSource: string;
      preferredEnrollment: EnrollmentOptionName;
      serviceAddressZip: string;
      serviceAddressCity: string;
      serviceAddressState: string;
      annualizedUsageEstimate: number;
      serviceAddressStreetOne: string;
      serviceAddressStreetTwo?: string | null;
      secondaryAccountIdentifier?: string | null;
    } | null;
  };
};

export type Flex_FetchGoogleUserQueryVariables = Exact<{
  code: Scalars['String'];
  secureToken: Scalars['String'];
}>;

export type Flex_FetchGoogleUserQuery = {
  googleUser?: { email: string; firstName?: string | null; lastName?: string | null } | null;
};

export type Flex_ValidateProjectIdQueryVariables = Exact<{
  vnmSolarProjectId?: InputMaybe<Scalars['Int']>;
  utilityId?: InputMaybe<Scalars['Int']>;
}>;

export type Flex_ValidateProjectIdQuery = {
  validation: {
    vnmSolarProject: {
      isValid: boolean;
      error?: { message: string; status?: number | null } | null;
    };
  };
};

export type Flex_ValidatePromoCodeQueryVariables = Exact<{
  promoCode?: InputMaybe<Scalars['String']>;
}>;

export type Flex_ValidatePromoCodeQuery = { validation: { promoCode: { isValid: boolean } } };

export type Flex_ExchangeTokenQueryVariables = Exact<{
  loginToken: Scalars['String'];
}>;

export type Flex_ExchangeTokenQuery = { tokenExchange: { token: string } };

export type Flex_ValidateUtilityAndZipQueryVariables = Exact<{
  utilityId?: InputMaybe<Scalars['Int']>;
  zipCode?: InputMaybe<Scalars['String']>;
}>;

export type Flex_ValidateUtilityAndZipQuery = {
  validation: {
    zipCode: { isValid: boolean };
    utility: { isValid: boolean };
    zipCodeAndUtility: { isValid: boolean };
  };
};

export type Flex_CreateContractAgreementPerchMutationVariables = Exact<{
  input: CreateContractAgreementsPerchInput;
}>;

export type Flex_CreateContractAgreementPerchMutation = {
  createContractAgreementsPerch: { success: boolean };
};

export type Flex_CreateContractAgreementsMutationVariables = Exact<{
  input: Array<CreateContractAgreementInput> | CreateContractAgreementInput;
}>;

export type Flex_CreateContractAgreementsMutation = {
  createContractAgreements: Array<{ success: boolean }>;
};

export type Flex_FetchSignNowEnvelopeStatusMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_FetchSignNowEnvelopeStatusMutation = {
  fetchSignNowEnvelopeStatus: { id: number; status: string; signingUrl?: string | null };
};

export type Flex_CreateFunnelPacketMutationVariables = Exact<{
  input: CreateFunnelPacketInput;
}>;

export type Flex_CreateFunnelPacketMutation = {
  createFunnelPacket: {
    signedContractIds: Array<number | null>;
    funnelVnmProjectId?: number | null;
    nonLmi?: boolean | null;
    inviteCode?: string | null;
    funnelEnrollmentExperience?: string | null;
    onboardingRateClasses: Array<{ id: number; displayName: string }>;
    customPlan: {
      id: number;
      paymentMethodId?: number | null;
      planTemplate?: { id: number; billingExperienceType?: string | null } | null;
      billingAddress?: {
        id: number;
        streetOne: string;
        streetTwo?: string | null;
        city: string;
        state: string;
        zipCode: string;
        addressType: AddressType;
      } | null;
      utilityAccounts: Array<{
        id: number;
        serviceAddressZip?: string | null;
        serviceAddressState?: string | null;
        serviceAddressCity?: string | null;
        serviceAddressStreetOne?: string | null;
        serviceAddressStreetTwo?: string | null;
      }>;
    };
    funnelConfiguration?: {
      showLmiScreens?: boolean | null;
      signUpContractTemplate?: { id?: number | null; savingsPercentage?: number | null } | null;
    } | null;
    signupContractTemplate?: {
      id?: number | null;
      savingsPercentage?: number | null;
      supportedCustomerTypes?: Array<string> | null;
      proofDocRequirement: PerchProductProofDocRequirement;
      paymentProvider?: PaymentProvider | null;
    } | null;
    meter?: { id: number; meterNumber: string } | null;
    utilityAccount: {
      id: number;
      annualizedUsageEstimate?: number | null;
      accountNumber?: string | null;
      secondaryAccountIdentifier?: string | null;
      serviceAddressZip?: string | null;
      serviceAddressState?: string | null;
      serviceAddressCity?: string | null;
      serviceAddressStreetOne?: string | null;
      enrollmentDataSourceName?: EnrollmentOptionName | null;
      serviceAddressStreetTwo?: string | null;
      utilityAccountMissingError?: string | null;
      communitySolarProjectGroup?: { id: number; usesIpaContracts: boolean } | null;
      account: { id: number; businessName?: string | null; customerType?: string | null };
      user: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
        metaData?: any | null;
        phone?: string | null;
        phoneNumber?: string | null;
        zipCode?: string | null;
        originationSource?: {
          originationSourceType: string;
          funnel?: string | null;
          enrollmentExperience?: string | null;
          queryParams?: any | null;
        } | null;
        signupPromoCode?: { code: string } | null;
        signupFunnelLead?: { paymentService?: any | null } | null;
      };
      utility: {
        id: number;
        displayName: string;
        funnelTrack: FunnelTrack;
        forgotPassword?: string | null;
        registerForAccount?: string | null;
        state: {
          abbreviation: string;
          requireCommunicationPreference: boolean;
          id: number;
          name: string;
        };
        fieldValidationRules: Array<{
          id: number;
          fieldName: string;
          fieldType: UtilityAccountFieldType;
          helpText?: string | null;
          patterns: Array<string>;
        }>;
      };
      utilityCredential: { id: number; username?: string | null; verificationStatus: string };
    };
    unparsedQueryParams?: {
      utilityAccountNumber?: string | null;
      secondaryAccountId?: string | null;
      meterNumber?: string | null;
      annualizedUsageEstimate?: number | null;
    } | null;
    projectSnapshot?: {
      ira?: boolean | null;
      product?: string | null;
      salesforceUtilityId?: string | null;
      programName?: string | null;
      lmiProductId?: string | null;
      collectPayment?: boolean | null;
      productId?: string | null;
      savingsPercent?: number | null;
      ciCapacityAvailable?: boolean | null;
      lmiCapacityAvailable?: boolean | null;
      resiCapacityAvailable?: boolean | null;
      smallCsCapacityAvailable?: boolean | null;
      waitlist?: boolean | null;
    } | null;
  };
};

export type Flex_CreateMeterMutationVariables = Exact<{
  input: CreateMeterInput;
}>;

export type Flex_CreateMeterMutation = {
  meter: {
    id: number;
    meterNumber: string;
    serviceType: string;
    utilityAccountId: number;
    utilityId: number;
  };
};

export type Flex_CreatePaymentHoldMutationVariables = Exact<{
  input: CreateTemporaryPaymentHoldInput;
}>;

export type Flex_CreatePaymentHoldMutation = {
  createTemporaryPaymentHold: { result: PaymentHoldResult; message?: string | null };
};

export type Flex_CreatePersonalizedContractPreviewMutationVariables = Exact<{
  input: CreatePersonalizedContractPreviewInput;
}>;

export type Flex_CreatePersonalizedContractPreviewMutation = {
  createPersonalizedContractPreview: { base64: string };
};

export type Flex_CreateProductLeadMutationVariables = Exact<{
  input: CreateProductLeadInput;
}>;

export type Flex_CreateProductLeadMutation = { createProductLead: { id?: number | null } };

export type CreateProspectUserMutationVariables = Exact<{
  input: CreateProspectUserInput;
}>;

export type CreateProspectUserMutation = {
  createProspectUser: {
    id: number;
    utilityId: number;
    zipcode?: string | null;
    firstName: string;
    lastName: string;
    phone?: string | null;
    email: string;
  };
};

export type Flex_CreateSignNowEnvelopeMutationVariables = Exact<{
  input: CreateSignNowEnvelopeInput;
}>;

export type Flex_CreateSignNowEnvelopeMutation = {
  createSignNowEnvelope: {
    id: number;
    status: string;
    signingUrl?: string | null;
    inviteExpiresAt?: any | null;
    personalizedContractId: number;
  };
};

export type Flex_CreateUaLmiStWithContractsMutationVariables = Exact<{
  utilityAccountId: Scalars['Int'];
  input: CreateUaLmiSourceTypeWithContractInput;
}>;

export type Flex_CreateUaLmiStWithContractsMutation = {
  createUaLmiSourceTypeWithContracts: { id: number };
};

export type Flex_CreateEnrollingUserMutationVariables = Exact<{
  input: EnrollingUserInput;
}>;

export type Flex_CreateEnrollingUserMutation = {
  enrollingUser: {
    id: number;
    token?: string | null;
    user?: { id: number; email: string; signupFunnelLeadId?: number | null } | null;
  };
};

export type Flex_CreateZuoraLinkTokenMutationVariables = Exact<{
  input: CreateZuoraLinkTokenInput;
}>;

export type Flex_CreateZuoraLinkTokenMutation = {
  createZuoraLinkToken: {
    hostedPageId: string;
    hostedPageUri: string;
    digitalSignature: {
      key?: string | null;
      signature?: string | null;
      token?: string | null;
      tenantId?: string | null;
      success: boolean;
    };
  };
};

export type Flex_DeleteBillUploadMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_DeleteBillUploadMutation = { deleteBillUpload: { id: number } };

export type Flex_DeleteLmiProofDocUploadMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_DeleteLmiProofDocUploadMutation = { deleteLMIProofDocUpload: { id: number } };

export type Flex_FetchBillingExperienceOptionsQueryVariables = Exact<{
  utilityId: Scalars['Int'];
  enrollmentDataSourceName: EnrollmentOptionName;
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
}>;

export type Flex_FetchBillingExperienceOptionsQuery = {
  billingExperienceOptions: Array<{ name: BillingExperienceOptionName }>;
};

export type Flex_FetchBillpayEligibilityQueryVariables = Exact<{
  utilityId: Scalars['Int'];
}>;

export type Flex_FetchBillpayEligibilityQuery = {
  utility: { id: number; products: Array<{ id: number; key: string }> };
};

export type Flex_FetchContractLanguageQueryVariables = Exact<{
  contractVersionId: Scalars['Int'];
  languageShortCode: Scalars['String'];
}>;

export type Flex_FetchContractLanguageQuery = {
  contractVersion: { id: number; contractVersionLanguage?: { id: number } | null };
};

export type Flex_FetchCountiesInfoQueryVariables = Exact<{
  id: Scalars['Int'];
  zipCode: Scalars['String'];
}>;

export type Flex_FetchCountiesInfoQuery = {
  countyData?: { counties?: Array<string | null> | null; incomeLimits?: any | null } | null;
};

export type Flex_FetchDocuSignEnvelopesQueryVariables = Exact<{
  returnUrl: Scalars['String'];
  userId: Scalars['Int'];
}>;

export type Flex_FetchDocuSignEnvelopesQuery = {
  user: {
    id: number;
    docuSignEnvelopes: Array<{ id: number; status?: string | null; url?: string | null }>;
  };
};

export type Flex_FetchEnrollmentOptionsQueryVariables = Exact<{
  utilityId: Scalars['Int'];
}>;

export type Flex_FetchEnrollmentOptionsQuery = {
  enrollmentOptions: Array<{ id: number; name: EnrollmentOptionName }>;
};

export type Flex_FetchExistingPaymentMethodsQueryVariables = Exact<{
  accountId: Scalars['Int'];
}>;

export type Flex_FetchExistingPaymentMethodsQuery = {
  account: {
    paymentMethods: Array<{
      id: number;
      source: string;
      lastFour: string;
      type: string;
      hasSuccessfulTransactions: boolean;
    }>;
  };
};

export type Flex_FetchExistingPlansQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type Flex_FetchExistingPlansQuery = {
  user: {
    id: number;
    accounts: Array<{ id: number; customPlans: Array<{ id: number; active: boolean }> }>;
  };
};

export type Flex_FetchExistingUtilityAccountsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type Flex_FetchExistingUtilityAccountsQuery = {
  user: {
    id: number;
    accounts: Array<{
      id: number;
      utilityAccounts: Array<{
        id: number;
        accountNumber?: string | null;
        displayServiceAddress: string;
        hasInValidScraperDetails: boolean;
        hasVnmProduct: boolean;
        utility: { id: number; displayName: string };
      }>;
    }>;
  };
};

export type Flex_FetchFunnelBillingExperienceQueryVariables = Exact<{
  input: FunnelBillingExperienceConfigurationInput;
}>;

export type Flex_FetchFunnelBillingExperienceQuery = {
  funnelBillingExperienceConfiguration?: {
    id: number;
    funnelBillingExperience: NewBillingExperienceType;
  } | null;
};

export type Flex_FetchFunnelConfigurationQueryVariables = Exact<{
  zipCode: Scalars['Int'];
  utilityId: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<Scalars['String']>;
  requireFico?: InputMaybe<Scalars['Boolean']>;
  perchSfProductId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['String']>;
  countyId?: InputMaybe<Scalars['Int']>;
}>;

export type Flex_FetchFunnelConfigurationQuery = {
  resolveFunnelConfig?: {
    paymentProvider?: PaymentProvider | null;
    perchSfProductId?: string | null;
    isCapacityAvailable?: boolean | null;
    productSignupContractTemplateIds?: any | null;
    proofDocRequirement?: PerchProductProofDocRequirement | null;
    projectDetails?: any | null;
    savingsPercentage?: number | null;
    signUpContractTemplateId?: number | null;
    supportedCustomerTypes?: Array<string> | null;
    requireFicoCheck?: boolean | null;
    requireFicoCheckForLmiProduct?: boolean | null;
    requireFicoCheckForDefaultProduct?: boolean | null;
    countyProjectMatch?: CountyProjectMatch | null;
  } | null;
};

export type Flex_FetchFunnelPacketQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['Int']>;
  customPlanId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  utilityAccountId?: InputMaybe<Scalars['Int']>;
}>;

export type Flex_FetchFunnelPacketQuery = {
  funnelPacket: {
    signedContractIds: Array<number | null>;
    funnelVnmProjectId?: number | null;
    nonLmi?: boolean | null;
    inviteCode?: string | null;
    funnelEnrollmentExperience?: string | null;
    onboardingRateClasses: Array<{ id: number; displayName: string }>;
    customPlan: {
      id: number;
      paymentMethodId?: number | null;
      planTemplate?: { id: number; billingExperienceType?: string | null } | null;
      billingAddress?: {
        id: number;
        streetOne: string;
        streetTwo?: string | null;
        city: string;
        state: string;
        zipCode: string;
        addressType: AddressType;
      } | null;
      utilityAccounts: Array<{
        id: number;
        serviceAddressZip?: string | null;
        serviceAddressState?: string | null;
        serviceAddressCity?: string | null;
        serviceAddressStreetOne?: string | null;
        serviceAddressStreetTwo?: string | null;
      }>;
    };
    funnelConfiguration?: {
      showLmiScreens?: boolean | null;
      signUpContractTemplate?: { id?: number | null; savingsPercentage?: number | null } | null;
    } | null;
    signupContractTemplate?: {
      id?: number | null;
      savingsPercentage?: number | null;
      supportedCustomerTypes?: Array<string> | null;
      proofDocRequirement: PerchProductProofDocRequirement;
      paymentProvider?: PaymentProvider | null;
    } | null;
    meter?: { id: number; meterNumber: string } | null;
    utilityAccount: {
      id: number;
      annualizedUsageEstimate?: number | null;
      accountNumber?: string | null;
      secondaryAccountIdentifier?: string | null;
      serviceAddressZip?: string | null;
      serviceAddressState?: string | null;
      serviceAddressCity?: string | null;
      serviceAddressStreetOne?: string | null;
      enrollmentDataSourceName?: EnrollmentOptionName | null;
      serviceAddressStreetTwo?: string | null;
      utilityAccountMissingError?: string | null;
      communitySolarProjectGroup?: { id: number; usesIpaContracts: boolean } | null;
      account: { id: number; businessName?: string | null; customerType?: string | null };
      user: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
        metaData?: any | null;
        phone?: string | null;
        phoneNumber?: string | null;
        zipCode?: string | null;
        originationSource?: {
          originationSourceType: string;
          funnel?: string | null;
          enrollmentExperience?: string | null;
          queryParams?: any | null;
        } | null;
        signupPromoCode?: { code: string } | null;
        signupFunnelLead?: { paymentService?: any | null } | null;
      };
      utility: {
        id: number;
        displayName: string;
        funnelTrack: FunnelTrack;
        forgotPassword?: string | null;
        registerForAccount?: string | null;
        state: {
          abbreviation: string;
          requireCommunicationPreference: boolean;
          id: number;
          name: string;
        };
        fieldValidationRules: Array<{
          id: number;
          fieldName: string;
          fieldType: UtilityAccountFieldType;
          helpText?: string | null;
          patterns: Array<string>;
        }>;
      };
      utilityCredential: { id: number; username?: string | null; verificationStatus: string };
    };
    unparsedQueryParams?: {
      utilityAccountNumber?: string | null;
      secondaryAccountId?: string | null;
      meterNumber?: string | null;
      annualizedUsageEstimate?: number | null;
    } | null;
    projectSnapshot?: {
      ira?: boolean | null;
      product?: string | null;
      salesforceUtilityId?: string | null;
      programName?: string | null;
      lmiProductId?: string | null;
      collectPayment?: boolean | null;
      productId?: string | null;
      savingsPercent?: number | null;
      ciCapacityAvailable?: boolean | null;
      lmiCapacityAvailable?: boolean | null;
      resiCapacityAvailable?: boolean | null;
      smallCsCapacityAvailable?: boolean | null;
      waitlist?: boolean | null;
    } | null;
  };
};

export type Flex_FetchIpaContractQueryVariables = Exact<{
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_FetchIpaContractQuery = {
  signNowEnvelopeByUtilityAccount?: {
    id: number;
    status: string;
    signingUrl?: string | null;
    inviteExpiresAt?: any | null;
    personalizedContractId: number;
  } | null;
};

export type Flex_FetchLmiFormQueryVariables = Exact<{
  stateId: Scalars['Int'];
  tags: Array<ContractTag> | ContractTag;
}>;

export type Flex_FetchLmiFormQuery = {
  lmiForm?: {
    contractType: string;
    displayName: string;
    fileUrl: string;
    id: number;
    scrollRequired: boolean;
    tag?: ContractTag | null;
    contractId: number;
  } | null;
};

export type Flex_FetchLmiProofDocLabelOptionsQueryVariables = Exact<{
  utilityId: Scalars['Int'];
  productId?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
}>;

export type Flex_FetchLmiProofDocLabelOptionsQuery = {
  lmiProofDocLabelOptions: { data?: any | null };
};

export type Flex_FetchLmiProofDocsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type Flex_FetchLmiProofDocsQuery = {
  user: {
    lmiProofDocs: Array<{
      proofDocUrls: Array<string | null>;
      proofDocName?: string | null;
      proofDocStatus?: string | null;
      uaLmiSourceTypeId?: number | null;
      utilityAccountId?: number | null;
      utilityAccountNumber?: string | null;
      utilityName?: string | null;
    } | null>;
  };
};

export type Flex_FetchLmiZoneLookupQueryVariables = Exact<{
  utilityAccountId: Scalars['Int'];
  street?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}>;

export type Flex_FetchLmiZoneLookupQuery = {
  utilityAccount: {
    lmiZoneLookup?: {
      isInLmiArea: boolean;
      isInCensusTract: boolean;
      isAddressPresent: boolean;
      error: boolean;
      lmiZoneArea: { dacZone?: boolean | null; empowerZone?: boolean | null };
    } | null;
  };
};

export type Flex_FetchMembershipPromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String'];
  userId: Scalars['Int'];
}>;

export type Flex_FetchMembershipPromoCodeQuery = {
  promoCode: { sponsorName?: string | null };
  user: { id: number; signupIncentives: Array<{ sponsoredMembership: boolean }> };
};

export type Flex_FetchPaymentConsentQueryVariables = Exact<{
  internalName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type Flex_FetchPaymentConsentQuery = {
  currentContractVersions: Array<{
    id: number;
    displayName: string;
    internalName: string;
    contractType: string;
    notes?: string | null;
    fileUrl: string;
  }>;
};

export type Flex_FetchPersonalizedSignupContractSetFromTemplateQueryVariables = Exact<{
  input: PersonalizedSignupContractSetInput;
}>;

export type Flex_FetchPersonalizedSignupContractSetFromTemplateQuery = {
  personalizedSignupContractSet: {
    contractSet?: {
      contracts: Array<{
        id: number;
        displayName: string;
        internalName: string;
        contractType: string;
        fileUrl: string;
        notes?: string | null;
        hasPersonalization?: boolean | null;
        scrollRequired: boolean;
        signatureType: string;
        contractId: number;
        version: number;
        stateId?: number | null;
        base64PerchPersonalizedFile?: string | null;
        presignedUrl?: string | null;
        perchPersonalizedError?: string | null;
        base64PerchPersonalizedFiles?: Array<{
          utilityAccountId?: number | null;
          base64PerchPersonalizedFile?: string | null;
          perchPersonalizedError?: string | null;
        }> | null;
        contractVersionLanguage?: { id: number } | null;
      } | null>;
    } | null;
  };
};

export type Flex_FetchPlanTemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_FetchPlanTemplateQuery = {
  planTemplate: {
    id: number;
    enrollmentDataSourceName?: string | null;
    billingExperienceType?: string | null;
    products: Array<{ id: number; productType: string }>;
  };
};

export type Flex_ScraperDetailsValidityQueryVariables = Exact<{
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_ScraperDetailsValidityQuery = {
  utilityAccount: { hasInValidScraperDetails: boolean };
};

export type Flex_FetchSignNowDocumentGroupForEnrollmentQueryVariables = Exact<{
  planId: Scalars['Int'];
}>;

export type Flex_FetchSignNowDocumentGroupForEnrollmentQuery = {
  signNowDocumentGroupByPlan?: {
    id: number;
    status: string;
    signingUrl?: string | null;
    userId: number;
    inviteExpiresAt?: any | null;
    envelopeIds: Array<number>;
  } | null;
};

export type Flex_FetchSignNowDocumentGroupStatusMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_FetchSignNowDocumentGroupStatusMutation = {
  fetchSignNowDocumentGroupStatus: {
    id: number;
    status: string;
    signingUrl?: string | null;
    userId: number;
    inviteExpiresAt?: any | null;
    envelopeIds: Array<number>;
  };
};

export type Flex_FetchSignNowEnvelopeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type Flex_FetchSignNowEnvelopeQuery = {
  signNowEnvelope?: {
    id: number;
    status: string;
    signingUrl?: string | null;
    inviteExpiresAt?: any | null;
  } | null;
};

export type Flex_FetchSignupContractSetFromTemplateQueryVariables = Exact<{
  signupContractTemplateId: Scalars['Int'];
}>;

export type Flex_FetchSignupContractSetFromTemplateQuery = {
  signupContractSets: {
    contractSet?: {
      contracts: Array<{
        id: number;
        displayName: string;
        internalName: string;
        contractType: string;
        fileUrl: string;
        hasPersonalization?: boolean | null;
        scrollRequired: boolean;
        signatureType: string;
        presignedUrl?: string | null;
        contractId: number;
        version: number;
        stateId?: number | null;
      } | null>;
    } | null;
  };
};

export type Flex_FetchStripeTokenMutationVariables = Exact<{
  accountId: Scalars['Int'];
  achMicrodepositVerification: Scalars['Boolean'];
}>;

export type Flex_FetchStripeTokenMutation = { createSetupIntent: { stripeClientSecret: string } };

export type Flex_FetchUsageRequestFormQueryVariables = Exact<{
  stateId: Scalars['Int'];
  communitySolarProjectGroupId?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<ContractTag> | ContractTag>;
}>;

export type Flex_FetchUsageRequestFormQuery = {
  usageRequestForm?: {
    contractType: string;
    displayName: string;
    fileUrl: string;
    hasPersonalization?: boolean | null;
    id: number;
    scrollRequired: boolean;
    tag?: ContractTag | null;
    contractId: number;
  } | null;
};

export type Flex_FetchUtilityAccountQueryVariables = Exact<{
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_FetchUtilityAccountQuery = {
  utilityAccount: {
    id: number;
    accountNumber?: string | null;
    serviceAddressStreetOne?: string | null;
    serviceAddressCity?: string | null;
    serviceAddressState?: string | null;
    serviceAddressZip?: string | null;
  };
};

export type Flex_FetchUtilityConnectTokenQueryVariables = Exact<{
  utilityCredentialId: Scalars['Int'];
}>;

export type Flex_FetchUtilityConnectTokenQuery = { utilityCredentialConnectToken: string };

export type Flex_FetchUtilityQueryVariables = Exact<{
  utilityId: Scalars['Int'];
}>;

export type Flex_FetchUtilityQuery = {
  utility: {
    id: number;
    displayName: string;
    funnelTrack: FunnelTrack;
    forgotPassword?: string | null;
    registerForAccount?: string | null;
    state: {
      abbreviation: string;
      requireCommunicationPreference: boolean;
      id: number;
      name: string;
    };
    fieldValidationRules: Array<{
      id: number;
      fieldName: string;
      fieldType: UtilityAccountFieldType;
      helpText?: string | null;
      patterns: Array<string>;
    }>;
  };
};

export type Flex_FetchVnmTermsQueryVariables = Exact<{
  stateId: Scalars['Int'];
  tags: Array<ContractTag> | ContractTag;
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_FetchVnmTermsQuery = {
  utilityAccount: {
    id: number;
    subscriberContractRequirement: {
      dependencies: Array<{
        __typename: 'ContractSubscriberRequirement';
        status: SubscriberRequirementStatus;
        contract: {
          contractType: string;
          displayName: string;
          tag?: string | null;
          contractId: number;
          currentVersion?: {
            id: number;
            fileUrl: string;
            hasPersonalization?: boolean | null;
            scrollRequired: boolean;
            signatureType: string;
          } | null;
        };
      }>;
    };
  };
  generalContractVersions: Array<{
    contractType: string;
    displayName: string;
    fileUrl: string;
    hasPersonalization?: boolean | null;
    id: number;
    scrollRequired: boolean;
    tag?: ContractTag | null;
    contractId: number;
  }>;
  lmiForm?: {
    contractType: string;
    displayName: string;
    fileUrl: string;
    hasPersonalization?: boolean | null;
    id: number;
    scrollRequired: boolean;
    tag?: ContractTag | null;
    contractId: number;
  } | null;
  taggedContractVersions: Array<{
    contractType: string;
    displayName: string;
    fileUrl: string;
    hasPersonalization?: boolean | null;
    id: number;
    scrollRequired: boolean;
    tag?: ContractTag | null;
    contractId: number;
  }>;
};

export type Flex_FetchWaitlistOptionsQueryVariables = Exact<{
  utilityId: Scalars['Int'];
}>;

export type Flex_FetchWaitlistOptionsQuery = {
  utility: { funnelTrack: FunnelTrack; isutilityScraperEligible: boolean };
};

export type Flex_GenerateIlDisclosureFormsMutationVariables = Exact<{
  planId: Scalars['Int'];
  redirectUri?: InputMaybe<Scalars['String']>;
}>;

export type Flex_GenerateIlDisclosureFormsMutation = {
  generateIlDisclosureForms: { enqueued: boolean; planId: number };
};

export type Flex_ListenForPaymentSubscriptionVariables = Exact<{
  accountId: Scalars['Int'];
}>;

export type Flex_ListenForPaymentSubscription = {
  paymentMethodCreated: {
    id: number;
    source: string;
    lastFour: string;
    type: string;
    hasSuccessfulTransactions: boolean;
  };
};

export type Flex_FetchDashboardWithPathUrlQueryVariables = Exact<{
  userId: Scalars['Int'];
  path?: InputMaybe<Scalars['String']>;
}>;

export type Flex_FetchDashboardWithPathUrlQuery = { user: { url: string } };

export type Flex_FetchEmailUpdateStatusQueryVariables = Exact<{
  utilityAccountId: Scalars['Int'];
}>;

export type Flex_FetchEmailUpdateStatusQuery = {
  utilityAccount: { updateAccountSettingsScrapeUuid?: string | null };
};

export type Flex_RegenerateSignNowDocumentGroupMutationVariables = Exact<{
  envelopeIds: Array<Scalars['Int']> | Scalars['Int'];
  isEmbedded?: InputMaybe<Scalars['Boolean']>;
  redirectUri?: InputMaybe<Scalars['String']>;
}>;

export type Flex_RegenerateSignNowDocumentGroupMutation = {
  regenerateSignNowDocumentGroup: {
    id: number;
    status: string;
    signingUrl?: string | null;
    userId: number;
    inviteExpiresAt?: any | null;
    envelopeIds: Array<number>;
  };
};

export type Flex_GenerateDocuSignEnvelopeMutationVariables = Exact<{
  input: DocuSignEnvelopeCreateInput;
}>;

export type Flex_GenerateDocuSignEnvelopeMutation = { generateDocuSignEnvelope: number };

export type Flex_GenerateIlDisclosureFormMutationVariables = Exact<{
  utilityAccountId: Scalars['Int'];
  redirectUri: Scalars['String'];
}>;

export type Flex_GenerateIlDisclosureFormMutation = {
  generateIlDisclosureForm: { enqueued: boolean; utilityAccountId: number };
};

export type Flex_CreateUtilityAccountBillExtractionMutationVariables = Exact<{
  input: CreateUtilityAccountBillExtractionInput;
}>;

export type Flex_CreateUtilityAccountBillExtractionMutation = {
  createUtilityAccountBillExtraction: { id: number };
};

export type Flex_SendDocuSignInstantAlertMutationVariables = Exact<{
  input: DocuSignInstantAlertInput;
}>;

export type Flex_SendDocuSignInstantAlertMutation = { docusignInstantAlert: { success: boolean } };

export type Flex_SendInstantAlertMutationVariables = Exact<{
  input: InstantAlertInput;
}>;

export type Flex_SendInstantAlertMutation = {
  sendInstantAlert: { success: boolean; message?: string | null };
};

export type SendEmailsMutationVariables = Exact<{
  inputs: Array<EmailEventInput> | EmailEventInput;
}>;

export type SendEmailsMutation = {
  sendEmailEvents: {
    totalSent: number;
    totalFailed: number;
    failures: Array<{ name: string; data: any; message: string }>;
  };
};

export type Flex_SignUpUserMutationVariables = Exact<{
  input: SignUpUserInput;
}>;

export type Flex_SignUpUserMutation = { plan: { id: number; planTemplateId?: number | null } };

export type Flex_UpdateUtilityCredentialMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUtilityCredentialInput;
}>;

export type Flex_UpdateUtilityCredentialMutation = {
  updateUtilityCredential: { id: number; verificationStatus: string };
};

export type Flex_UpdateCustomerSnapshotMutationVariables = Exact<{
  utilityAccountId: Scalars['Int'];
  input: UpdateCustomerSnapshotInput;
}>;

export type Flex_UpdateCustomerSnapshotMutation = {
  updateCustomerSnapshot: { success?: boolean | null };
};

export type Flex_UpdateMultiUtilityAccountMutationVariables = Exact<{
  planId: Scalars['Int'];
  input: MultiUtilityAccountEnrollmentInput;
}>;

export type Flex_UpdateMultiUtilityAccountMutation = {
  multiUtilityAccountEnrollment?: { id?: number | null } | null;
};

export type Flex_UpdateOriginationSourceMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUserInput;
}>;

export type Flex_UpdateOriginationSourceMutation = {
  updateUser: { originationSource?: { funnel?: string | null } | null };
};

export type Flex_UpdatePlanPaymentMethodMutationVariables = Exact<{
  input: SetPaymentMethodInput;
}>;

export type Flex_UpdatePlanPaymentMethodMutation = {
  setPaymentMethod: {
    id: number;
    paymentMethod?: {
      id: number;
      source: string;
      lastFour: string;
      type: string;
      hasSuccessfulTransactions: boolean;
    } | null;
  };
};

export type Flex_UpdateUserMetaDataMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUserInput;
}>;

export type Flex_UpdateUserMetaDataMutation = { updateUser: { id: number } };

export type Flex_UpdateUserPreferencesMutationVariables = Exact<{
  input: UpdateUserPreferencesInput;
}>;

export type Flex_UpdateUserPreferencesMutation = { updateUserPreferences: { id?: number | null } };

export type Flex_UpdateUtilityAccountDetailMutationVariables = Exact<{
  utilityAccountId: Scalars['Int'];
  input: UpdateUtilityAccountDetailInput;
}>;

export type Flex_UpdateUtilityAccountDetailMutation = {
  updateUtilityAccountDetails: { utilityAccountDetailId?: number | null };
};

export type Flex_UpdateUtilityAccountMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUtilityAccountInput;
}>;

export type Flex_UpdateUtilityAccountMutation = { updateUtilityAccount: { id?: number | null } };

export type Flex_UploadBillImageMutationVariables = Exact<{
  input: BillUploadInput;
}>;

export type Flex_UploadBillImageMutation = { uploadBillImage: { id: number } };

export type Flex_UploadLmiProofDocMutationVariables = Exact<{
  input: LmiProofDocUploadInput;
}>;

export type Flex_UploadLmiProofDocMutation = { uploadLMIProofDoc: { id: number } };

export type GetUserDocuSignEnvelopesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type GetUserDocuSignEnvelopesQuery = {
  user: {
    id: number;
    userDocuSignEnvelopes?: Array<{
      displayName?: string | null;
      contractType?: string | null;
      status?: string | null;
      completedFile?: string | null;
      envelopeUpdatedAt?: string | null;
      userId?: string | null;
      personalizedContractId?: string | null;
    } | null> | null;
  };
};

export type Flex_ValidateEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type Flex_ValidateEmailQuery = {
  validateEmail: { userExists: boolean; valid: boolean; validationErrorMessage: string };
};

export type Flex_ValidatePerchSfProductIdQueryVariables = Exact<{
  perchSfProductId: Scalars['String'];
  customerType: Scalars['String'];
  requireFico: Scalars['Boolean'];
  stateId: Scalars['Int'];
}>;

export type Flex_ValidatePerchSfProductIdQuery = {
  validation: {
    perchSfProductId: {
      isValid: boolean;
      response?: any | null;
      error?: { message: string } | null;
    };
  };
};

export type UpdatePreferenceMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateUserInput;
}>;

export type UpdatePreferenceMutation = { updateUser: { id: number; languageShortCode: string } };
